import * as i0 from '@angular/core';
import { InjectionToken, inject, Injectable, effect, Directive, input, computed, EventEmitter, DestroyRef, booleanAttribute, Input, Output, ElementRef, Inject, Component, ChangeDetectionStrategy, ViewChild, Optional, numberAttribute, ContentChildren, Injector, ViewContainerRef, TemplateRef, NgZone, contentChild, output, viewChild, Renderer2, NgModule } from '@angular/core';
import { RectExtensions, RoundedRect, TransformModelExtensions, PointExtensions, SizeExtensions, Point, LineExtensions, GetIntersections, findClosestAlignment, setRectToElement, adjustRectToMinSize, setRectToViewBox } from '@foblex/2d';
import { __decorate } from 'tslib';
import * as i2$1 from '@foblex/mediator';
import { FExecutionRegister, FMediator } from '@foblex/mediator';
import * as i1 from '@foblex/platform';
import { BrowserService, PlatformService, EOperationSystem } from '@foblex/platform';
import { normalizeDomElementId, castToEnum, isClosestElementHasClass, flatMap, getDataAttrValueFromClosestElementWithClass, getOrCreateRootNodeForViewRef, deepCloneNode, disableDragInteractions, extendStyles } from '@foblex/utils';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { DragAndDropBase } from '@foblex/drag-toolkit';
const _c0 = ["f-connection-text", ""];
const _c1 = ["f-connection-drag-handle-start", ""];
const _c2 = ["f-connection-drag-handle-end", ""];
const _c3 = ["fConnectionGradient", ""];
const _c4 = ["f-connection-path", ""];
const _c5 = ["fConnectionSelection", ""];
const _c6 = ["defs"];
const _c7 = ["fConnectionCenter"];
const _c8 = ["*", [["", "fConnectionCenter", ""]]];
const _c9 = ["*", "[fConnectionCenter]"];
function FConnectionForCreateComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10, 1);
    i0.ɵɵprojection(2, 1);
    i0.ɵɵelementEnd();
  }
}
function FConnectionComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10, 1);
    i0.ɵɵprojection(2, 1);
    i0.ɵɵelementEnd();
  }
}
const _c10 = "[_nghost-%COMP%]{pointer-events:none;position:absolute}[_nghost-%COMP%]   svg[_ngcontent-%COMP%]{overflow:visible}[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   .f-connection-group[_ngcontent-%COMP%]{pointer-events:all}[_nghost-%COMP%]   .f-connection-center[_ngcontent-%COMP%]{pointer-events:all}";
function FSnapConnectionComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10, 1);
    i0.ɵɵprojection(2, 1);
    i0.ɵɵelementEnd();
  }
}
const _c11 = ["*"];
const _c12 = ["fGroupsContainer"];
const _c13 = ["fNodesContainer"];
const _c14 = ["fConnectionsContainer"];
const _c15 = [[["", "fGroup", ""]], [["f-snap-connection"]], [["f-connection"]], [["f-connection-for-create"]], [["", "fNode", ""]]];
const _c16 = ["[fGroup]", "f-snap-connection", "f-connection", "f-connection-for-create", "[fNode]"];
const _c17 = [[["", "fDefinitions", ""]], [["f-background"]], [["f-line-alignment"]], [["f-canvas"]], [["f-selection-area"]], [["f-minimap"]]];
const _c18 = ["[fDefinitions]", "f-background", "f-line-alignment", "f-canvas", "f-selection-area", "f-minimap"];
const F_BACKGROUND_PATTERN = new InjectionToken('F_BACKGROUND_PATTERN');
class GetElementRoundedRectRequest {
  element;
  constructor(element) {
    this.element = element;
  }
}
let GetElementRoundedRectExecution = /*#__PURE__*/(() => {
  let GetElementRoundedRectExecution = class GetElementRoundedRectExecution {
    _fBrowser = inject(BrowserService);
    handle(request) {
      return this._getRoundedRect(RectExtensions.fromElement(request.element), request.element, this._getComputedStyle(request.element));
    }
    _getRoundedRect(rect, element, styles) {
      return new RoundedRect(rect.x, rect.y, rect.width, rect.height, this._toPixels(styles.borderTopLeftRadius, element, styles.fontSize), this._toPixels(styles.borderTopRightRadius, element, styles.fontSize), this._toPixels(styles.borderBottomRightRadius, element, styles.fontSize), this._toPixels(styles.borderBottomLeftRadius, element, styles.fontSize));
    }
    _getComputedStyle(element) {
      return this._fBrowser.window.getComputedStyle(element);
    }
    _toPixels(value, element, fontSize) {
      return this._fBrowser.toPixels(value, element.clientWidth, element.clientHeight, fontSize) || 0;
    }
    static ɵfac = function GetElementRoundedRectExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetElementRoundedRectExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetElementRoundedRectExecution,
      factory: GetElementRoundedRectExecution.ɵfac
    });
  };
  GetElementRoundedRectExecution = __decorate([FExecutionRegister(GetElementRoundedRectRequest)], GetElementRoundedRectExecution);
  return GetElementRoundedRectExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class AddBackgroundToStoreRequest {
  fBackground;
  constructor(fBackground) {
    this.fBackground = fBackground;
  }
}
class NotifyDataChangedRequest {}
let NotifyDataChangedExecution = /*#__PURE__*/(() => {
  let NotifyDataChangedExecution = class NotifyDataChangedExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.dataChanged();
    }
    static ɵfac = function NotifyDataChangedExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NotifyDataChangedExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NotifyDataChangedExecution,
      factory: NotifyDataChangedExecution.ɵfac
    });
  };
  NotifyDataChangedExecution = __decorate([FExecutionRegister(NotifyDataChangedRequest)], NotifyDataChangedExecution);
  return NotifyDataChangedExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ListenDataChangesRequest {}
function debounceTime(delay) {
  let timeoutId;
  return callback => {
    return () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => callback(), delay);
    };
  };
}
class FChannel {
  _listeners = new Set();
  notify() {
    this._listeners.forEach(callback => callback());
  }
  listen(callback) {
    this._listeners.add(callback);
    return () => this.stop(callback);
  }
  stop(callback) {
    this._listeners.delete(callback);
  }
}
class FResizeChannel extends FChannel {
  _htmlElement;
  _observer = new ResizeObserver(() => this.notify());
  _isObserving = false;
  constructor(_htmlElement) {
    super();
    this._htmlElement = _htmlElement;
  }
  listen(callback) {
    if (!this._isObserving) {
      this._observer.observe(this._htmlElement);
      this._isObserving = true;
    }
    return super.listen(callback);
  }
  stop(callback) {
    super.stop(callback);
    if (this._listeners.size === 0) {
      this._disconnect();
    }
  }
  _disconnect() {
    this._observer.unobserve(this._htmlElement);
    this._observer.disconnect();
    this._isObserving = false;
  }
}
class FChannelHub {
  _channels = [];
  _operators = [];
  constructor(...channels) {
    this._channels = [...channels];
  }
  pipe(...operators) {
    const result = new FChannelHub(...this._channels);
    result._operators = [...this._operators, ...operators];
    return result;
  }
  listen(destroyRef, callback) {
    let modifiedCallback = callback;
    this._operators.forEach(operator => {
      modifiedCallback = operator(modifiedCallback);
    });
    const unsubscribeCallbacks = this._channels.map(channel => channel.listen(() => modifiedCallback()));
    destroyRef.onDestroy(() => {
      unsubscribeCallbacks.forEach(unsubscribe => unsubscribe());
    });
  }
}
function mediatorEffect(fn, options) {
  let isFirstRun = true;
  return effect(() => {
    const request = fn();
    if (isFirstRun) {
      isFirstRun = false;
      return;
    }
    options?.injector?.get(FMediator).execute(request);
  }, options);
}
function notifyOnStart() {
  return callback => {
    callback();
    return callback;
  };
}
let ListenDataChangesExecution = /*#__PURE__*/(() => {
  let ListenDataChangesExecution = class ListenDataChangesExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      return new FChannelHub(this._fComponentsStore.dataChanges$).pipe(notifyOnStart(), debounceTime(1));
    }
    static ɵfac = function ListenDataChangesExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListenDataChangesExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ListenDataChangesExecution,
      factory: ListenDataChangesExecution.ɵfac
    });
  };
  ListenDataChangesExecution = __decorate([FExecutionRegister(ListenDataChangesRequest)], ListenDataChangesExecution);
  return ListenDataChangesExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ListenCountChangesRequest {}
let ListenCountChangesExecution = /*#__PURE__*/(() => {
  let ListenCountChangesExecution = class ListenCountChangesExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      return new FChannelHub(this._fComponentsStore.countChanges$).pipe(notifyOnStart(), debounceTime(1));
    }
    static ɵfac = function ListenCountChangesExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListenCountChangesExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ListenCountChangesExecution,
      factory: ListenCountChangesExecution.ɵfac
    });
  };
  ListenCountChangesExecution = __decorate([FExecutionRegister(ListenCountChangesRequest)], ListenCountChangesExecution);
  return ListenCountChangesExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ListenTransformChangesRequest {}
let ListenTransformChangesExecution = /*#__PURE__*/(() => {
  let ListenTransformChangesExecution = class ListenTransformChangesExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      return new FChannelHub(this._fComponentsStore.transformChanges$, this._fComponentsStore.dataChanges$, this._fComponentsStore.countChanges$);
    }
    static ɵfac = function ListenTransformChangesExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListenTransformChangesExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ListenTransformChangesExecution,
      factory: ListenTransformChangesExecution.ɵfac
    });
  };
  ListenTransformChangesExecution = __decorate([FExecutionRegister(ListenTransformChangesRequest)], ListenTransformChangesExecution);
  return ListenTransformChangesExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class NotifyTransformChangedRequest {}
let FComponentsStore = /*#__PURE__*/(() => {
  class FComponentsStore {
    transformChanges$ = new FChannel();
    dataChanges$ = new FChannel();
    countChanges$ = new FChannel();
    get flowHost() {
      return this.fFlow?.hostElement;
    }
    fComponents = {};
    fFlow;
    fCanvas;
    fBackground;
    fNodes = [];
    fConnections = [];
    fTempConnection;
    fSnapConnection;
    fMarkers = [];
    fOutputs = [];
    fInputs = [];
    fOutlets = [];
    fDraggable;
    fLineAlignment;
    addComponent(collection, component) {
      collection.push(component);
      this.countChanged();
    }
    removeComponent(collection, component) {
      const index = collection.indexOf(component);
      if (index > -1) {
        collection.splice(index, 1);
        this.countChanged();
      }
    }
    countChanged() {
      this.countChanges$.notify();
    }
    dataChanged() {
      this.dataChanges$.notify();
    }
    transformChanged() {
      this.transformChanges$.notify();
    }
    static ɵfac = function FComponentsStore_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FComponentsStore)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FComponentsStore,
      factory: FComponentsStore.ɵfac
    });
  }
  return FComponentsStore;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotifyTransformChangedExecution = /*#__PURE__*/(() => {
  let NotifyTransformChangedExecution = class NotifyTransformChangedExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.transformChanged();
    }
    static ɵfac = function NotifyTransformChangedExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NotifyTransformChangedExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NotifyTransformChangedExecution,
      factory: NotifyTransformChangedExecution.ɵfac
    });
  };
  NotifyTransformChangedExecution = __decorate([FExecutionRegister(NotifyTransformChangedRequest)], NotifyTransformChangedExecution);
  return NotifyTransformChangedExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_STORAGE_PROVIDERS = [NotifyDataChangedExecution, ListenCountChangesExecution, ListenDataChangesExecution, ListenTransformChangesExecution, NotifyTransformChangedExecution, FComponentsStore];
let AddBackgroundToStoreExecution = /*#__PURE__*/(() => {
  let AddBackgroundToStoreExecution = class AddBackgroundToStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fBackground = request.fBackground;
    }
    static ɵfac = function AddBackgroundToStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddBackgroundToStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddBackgroundToStoreExecution,
      factory: AddBackgroundToStoreExecution.ɵfac
    });
  };
  AddBackgroundToStoreExecution = __decorate([FExecutionRegister(AddBackgroundToStoreRequest)], AddBackgroundToStoreExecution);
  return AddBackgroundToStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class AddPatternToBackgroundRequest {
  fPattern;
  constructor(fPattern) {
    this.fPattern = fPattern;
  }
}
let uniqueId$c = 0;
let AddPatternToBackgroundExecution = /*#__PURE__*/(() => {
  let AddPatternToBackgroundExecution = class AddPatternToBackgroundExecution {
    _fComponentsStore = inject(FComponentsStore);
    _fBrowser = inject(BrowserService);
    get _fBackground() {
      return this._fComponentsStore.fBackground;
    }
    handle(request) {
      const children = request.fPattern?.hostElement.getElementsByTagName('pattern') || [];
      const pattern = children.length ? children[0] : undefined;
      if (pattern) {
        const defs = createSVGElement('defs', this._fBrowser);
        pattern.id = 'f-background-pattern-' + uniqueId$c++;
        request.fPattern?.hostElement.remove();
        defs.appendChild(pattern);
        this._fBackground.hostElement?.firstChild?.appendChild(defs);
        const rect = createSVGElement('rect', this._fBrowser);
        rect.setAttribute('fill', 'url(#' + pattern.id + ')');
        rect.setAttribute('width', '100%');
        rect.setAttribute('height', '100%');
        this._fBackground.hostElement.firstChild?.appendChild(rect);
        const transform = this._fComponentsStore.fCanvas?.transform || TransformModelExtensions.default();
        request.fPattern?.setTransform(transform);
      }
    }
    static ɵfac = function AddPatternToBackgroundExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddPatternToBackgroundExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddPatternToBackgroundExecution,
      factory: AddPatternToBackgroundExecution.ɵfac
    });
  };
  AddPatternToBackgroundExecution = __decorate([FExecutionRegister(AddPatternToBackgroundRequest)], AddPatternToBackgroundExecution);
  return AddPatternToBackgroundExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RemoveBackgroundFromStoreRequest {
  fConnection;
  constructor(fConnection) {
    this.fConnection = fConnection;
  }
}
let RemoveBackgroundFromStoreExecution = /*#__PURE__*/(() => {
  let RemoveBackgroundFromStoreExecution = class RemoveBackgroundFromStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fBackground = undefined;
    }
    static ɵfac = function RemoveBackgroundFromStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveBackgroundFromStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RemoveBackgroundFromStoreExecution,
      factory: RemoveBackgroundFromStoreExecution.ɵfac
    });
  };
  RemoveBackgroundFromStoreExecution = __decorate([FExecutionRegister(RemoveBackgroundFromStoreRequest)], RemoveBackgroundFromStoreExecution);
  return RemoveBackgroundFromStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class SetBackgroundTransformRequest {
  fTransform;
  constructor(fTransform) {
    this.fTransform = fTransform;
  }
}
let SetBackgroundTransformExecution = /*#__PURE__*/(() => {
  let SetBackgroundTransformExecution = class SetBackgroundTransformExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fBackground?.setTransform(request.fTransform);
    }
    static ɵfac = function SetBackgroundTransformExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SetBackgroundTransformExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SetBackgroundTransformExecution,
      factory: SetBackgroundTransformExecution.ɵfac
    });
  };
  SetBackgroundTransformExecution = __decorate([FExecutionRegister(SetBackgroundTransformRequest)], SetBackgroundTransformExecution);
  return SetBackgroundTransformExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_BACKGROUND_FEATURES = [AddBackgroundToStoreExecution, AddPatternToBackgroundExecution, RemoveBackgroundFromStoreExecution, SetBackgroundTransformExecution];
class AddCanvasToStoreRequest {
  fCanvas;
  constructor(fCanvas) {
    this.fCanvas = fCanvas;
  }
}
let AddCanvasToStoreExecution = /*#__PURE__*/(() => {
  let AddCanvasToStoreExecution = class AddCanvasToStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fCanvas = request.fCanvas;
    }
    static ɵfac = function AddCanvasToStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddCanvasToStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddCanvasToStoreExecution,
      factory: AddCanvasToStoreExecution.ɵfac
    });
  };
  AddCanvasToStoreExecution = __decorate([FExecutionRegister(AddCanvasToStoreRequest)], AddCanvasToStoreExecution);
  return AddCanvasToStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CenterGroupOrNodeRequest {
  id;
  animated;
  constructor(id, animated) {
    this.id = id;
    this.animated = animated;
  }
}
let CenterGroupOrNodeExecution = /*#__PURE__*/(() => {
  let CenterGroupOrNodeExecution = class CenterGroupOrNodeExecution {
    _fComponentsStore = inject(FComponentsStore);
    get transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    _fMediator = inject(FMediator);
    handle(request) {
      const fNode = this.getNode(request.id);
      if (!fNode) {
        return;
      }
      this.toCenter(this.getNodeRect(fNode), this.getFlowRect(), fNode.position);
      this._fMediator.execute(new RedrawCanvasWithAnimationRequest(request.animated));
    }
    toCenter(fNodeRect, fFlowRect, position) {
      this.transform.scaledPosition = PointExtensions.initialize();
      this.transform.position = PointExtensions.initialize((fFlowRect.width - fNodeRect.width) / 2 - position.x * this.transform.scale, (fFlowRect.height - fNodeRect.height) / 2 - position.y * this.transform.scale);
    }
    getNode(id) {
      return this._fComponentsStore.fNodes.find(x => x.fId === id);
    }
    getNodeRect(fNode) {
      return RectExtensions.fromElement(fNode.hostElement);
    }
    getFlowRect() {
      return RectExtensions.fromElement(this._fComponentsStore.fFlow.hostElement);
    }
    static ɵfac = function CenterGroupOrNodeExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CenterGroupOrNodeExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CenterGroupOrNodeExecution,
      factory: CenterGroupOrNodeExecution.ɵfac
    });
  };
  CenterGroupOrNodeExecution = __decorate([FExecutionRegister(CenterGroupOrNodeRequest)], CenterGroupOrNodeExecution);
  return CenterGroupOrNodeExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FitToFlowRequest {
  toCenter;
  animated;
  constructor(toCenter, animated) {
    this.toCenter = toCenter;
    this.animated = animated;
  }
}
let FitToFlowExecution = /*#__PURE__*/(() => {
  let FitToFlowExecution = class FitToFlowExecution {
    _fComponentsStore = inject(FComponentsStore);
    get transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    _fMediator = inject(FMediator);
    handle(request) {
      const fNodesRect = this._fMediator.execute(new CalculateNodesBoundingBoxRequest()) || RectExtensions.initialize();
      if (fNodesRect.width === 0 || fNodesRect.height === 0) {
        return;
      }
      this.fitToParent(fNodesRect, RectExtensions.fromElement(this._fComponentsStore.fFlow.hostElement), this._fComponentsStore.fNodes.map(x => x.position), request.toCenter);
      this._fMediator.execute(new RedrawCanvasWithAnimationRequest(request.animated));
    }
    fitToParent(rect, parentRect, points, toCenter) {
      this.transform.scaledPosition = PointExtensions.initialize();
      this.transform.position = this.getZeroPositionWithoutScale(points);
      const itemsContainerWidth = rect.width / this.transform.scale + toCenter.x;
      const itemsContainerHeight = rect.height / this.transform.scale + toCenter.y;
      if (itemsContainerWidth > parentRect.width || itemsContainerHeight > parentRect.height || itemsContainerWidth < parentRect.width && itemsContainerHeight < parentRect.height) {
        this.transform.scale = Math.min(parentRect.width / itemsContainerWidth, parentRect.height / itemsContainerHeight);
      }
      const newX = (parentRect.width - itemsContainerWidth * this.transform.scale) / 2 - this.transform.position.x * this.transform.scale;
      const newY = (parentRect.height - itemsContainerHeight * this.transform.scale) / 2 - this.transform.position.y * this.transform.scale;
      this.transform.position = PointExtensions.initialize(newX + toCenter.x / 2 * this.transform.scale, newY + toCenter.y / 2 * this.transform.scale);
    }
    getZeroPositionWithoutScale(points) {
      const xPoint = points.length ? Math.min(...points.map(point => point.x)) : 0;
      const yPoint = points.length ? Math.min(...points.map(point => point.y)) : 0;
      return PointExtensions.initialize(xPoint, yPoint);
    }
    static ɵfac = function FitToFlowExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FitToFlowExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FitToFlowExecution,
      factory: FitToFlowExecution.ɵfac
    });
  };
  FitToFlowExecution = __decorate([FExecutionRegister(FitToFlowRequest)], FitToFlowExecution);
  return FitToFlowExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetCanvasRequest {}
let GetCanvasExecution = /*#__PURE__*/(() => {
  let GetCanvasExecution = class GetCanvasExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      const result = this._fComponentsStore.fCanvas;
      if (!result) {
        throw new Error(`Canvas not found in store`);
      }
      return result;
    }
    static ɵfac = function GetCanvasExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetCanvasExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetCanvasExecution,
      factory: GetCanvasExecution.ɵfac
    });
  };
  GetCanvasExecution = __decorate([FExecutionRegister(GetCanvasRequest)], GetCanvasExecution);
  return GetCanvasExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class InputCanvasPositionRequest {
  transform;
  position;
  constructor(transform, position) {
    this.transform = transform;
    this.position = position;
  }
}
let InputCanvasPositionExecution = /*#__PURE__*/(() => {
  let InputCanvasPositionExecution = class InputCanvasPositionExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      if (!request.position) {
        return;
      }
      const position = PointExtensions.sum(request.transform.position, request.transform.scaledPosition);
      if (!PointExtensions.isEqual(position, request.position)) {
        request.transform.position = request.position;
        request.transform.scaledPosition = PointExtensions.initialize();
        this._fComponentsStore.fCanvas?.redraw();
      }
      return void 0;
    }
    static ɵfac = function InputCanvasPositionExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InputCanvasPositionExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: InputCanvasPositionExecution,
      factory: InputCanvasPositionExecution.ɵfac
    });
  };
  InputCanvasPositionExecution = __decorate([FExecutionRegister(InputCanvasPositionRequest)], InputCanvasPositionExecution);
  return InputCanvasPositionExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class InputCanvasScaleRequest {
  transform;
  scale;
  constructor(transform, scale) {
    this.transform = transform;
    this.scale = scale;
  }
}
let InputCanvasScaleExecution = /*#__PURE__*/(() => {
  let InputCanvasScaleExecution = class InputCanvasScaleExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      if (!request.scale && request.scale !== 0) {
        return;
      }
      request.transform.scale = request.scale;
      this._fComponentsStore.fCanvas?.redraw();
    }
    static ɵfac = function InputCanvasScaleExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InputCanvasScaleExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: InputCanvasScaleExecution,
      factory: InputCanvasScaleExecution.ɵfac
    });
  };
  InputCanvasScaleExecution = __decorate([FExecutionRegister(InputCanvasScaleRequest)], InputCanvasScaleExecution);
  return InputCanvasScaleExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RedrawCanvasWithAnimationRequest {
  animated;
  constructor(animated) {
    this.animated = animated;
  }
}
function transitionEnd(element, callback) {
  const onTransitionEnd = event => {
    if (event.propertyName === 'transform') {
      element.removeEventListener('transitionend', onTransitionEnd);
      callback(event);
    }
  };
  element.addEventListener('transitionend', onTransitionEnd);
}
let RedrawCanvasWithAnimationExecution = /*#__PURE__*/(() => {
  let RedrawCanvasWithAnimationExecution = class RedrawCanvasWithAnimationExecution {
    _fComponentsStore = inject(FComponentsStore);
    get _fCanvasElement() {
      return this._fComponentsStore.fCanvas.hostElement;
    }
    handle(request) {
      request.animated ? this._redrawWithAnimation() : this._redraw();
      this._fComponentsStore.fCanvas.emitCanvasChangeEvent();
    }
    _redrawWithAnimation() {
      this._fComponentsStore.fCanvas.redrawWithAnimation();
      transitionEnd(this._fCanvasElement, () => this._fComponentsStore.dataChanged());
    }
    _redraw() {
      this._fComponentsStore.fCanvas.redraw();
      this._fComponentsStore.dataChanged();
    }
    static ɵfac = function RedrawCanvasWithAnimationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RedrawCanvasWithAnimationExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RedrawCanvasWithAnimationExecution,
      factory: RedrawCanvasWithAnimationExecution.ɵfac
    });
  };
  RedrawCanvasWithAnimationExecution = __decorate([FExecutionRegister(RedrawCanvasWithAnimationRequest)], RedrawCanvasWithAnimationExecution);
  return RedrawCanvasWithAnimationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RemoveCanvasFromStoreRequest {}
let RemoveCanvasFromStoreExecution = /*#__PURE__*/(() => {
  let RemoveCanvasFromStoreExecution = class RemoveCanvasFromStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fCanvas = undefined;
    }
    static ɵfac = function RemoveCanvasFromStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveCanvasFromStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RemoveCanvasFromStoreExecution,
      factory: RemoveCanvasFromStoreExecution.ɵfac
    });
  };
  RemoveCanvasFromStoreExecution = __decorate([FExecutionRegister(RemoveCanvasFromStoreRequest)], RemoveCanvasFromStoreExecution);
  return RemoveCanvasFromStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ResetScaleRequest {}
let ResetScaleExecution = /*#__PURE__*/(() => {
  let ResetScaleExecution = class ResetScaleExecution {
    _fComponentsStore = inject(FComponentsStore);
    get transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    handle(request) {
      this.transform.scale = 1;
      this.transform.scaledPosition = PointExtensions.initialize();
    }
    static ɵfac = function ResetScaleExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ResetScaleExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ResetScaleExecution,
      factory: ResetScaleExecution.ɵfac
    });
  };
  ResetScaleExecution = __decorate([FExecutionRegister(ResetScaleRequest)], ResetScaleExecution);
  return ResetScaleExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ResetScaleAndCenterRequest {
  animated;
  constructor(animated) {
    this.animated = animated;
  }
}
let ResetScaleAndCenterExecution = /*#__PURE__*/(() => {
  let ResetScaleAndCenterExecution = class ResetScaleAndCenterExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    get _transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    handle(request) {
      const fNodesRect = this._fMediator.execute(new CalculateNodesBoundingBoxRequest()) || RectExtensions.initialize();
      if (fNodesRect.width === 0 || fNodesRect.height === 0) {
        return;
      }
      this._oneToOneCentering(fNodesRect, RectExtensions.fromElement(this._fComponentsStore.fFlow.hostElement), this._fComponentsStore.fNodes.map(x => x.position));
      this._fMediator.execute(new RedrawCanvasWithAnimationRequest(request.animated));
    }
    _oneToOneCentering(rect, parentRect, points) {
      this._transform.scaledPosition = PointExtensions.initialize();
      this._transform.position = this._getZeroPositionWithoutScale(points);
      const newX = (parentRect.width - rect.width / this._transform.scale) / 2 - this._transform.position.x;
      const newY = (parentRect.height - rect.height / this._transform.scale) / 2 - this._transform.position.y;
      this._transform.scale = 1;
      this._transform.position = PointExtensions.initialize(newX, newY);
    }
    _getZeroPositionWithoutScale(points) {
      const xPoint = points.length ? Math.min(...points.map(point => point.x)) : 0;
      const yPoint = points.length ? Math.min(...points.map(point => point.y)) : 0;
      return PointExtensions.initialize(xPoint, yPoint);
    }
    static ɵfac = function ResetScaleAndCenterExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ResetScaleAndCenterExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ResetScaleAndCenterExecution,
      factory: ResetScaleAndCenterExecution.ɵfac
    });
  };
  ResetScaleAndCenterExecution = __decorate([FExecutionRegister(ResetScaleAndCenterRequest)], ResetScaleAndCenterExecution);
  return ResetScaleAndCenterExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class UpdateScaleRequest {
  scale;
  toPosition;
  constructor(scale, toPosition) {
    this.scale = scale;
    this.toPosition = toPosition;
  }
}
let UpdateScaleExecution = /*#__PURE__*/(() => {
  let UpdateScaleExecution = class UpdateScaleExecution {
    _fComponentsStore = inject(FComponentsStore);
    get transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    handle(request) {
      if (request.scale !== this.transform.scale) {
        const summaryPosition = PointExtensions.sum(this.transform.scaledPosition, this.transform.position);
        const newX = request.toPosition.x - (request.toPosition.x - summaryPosition.x) * request.scale / this.transform.scale;
        const newY = request.toPosition.y - (request.toPosition.y - summaryPosition.y) * request.scale / this.transform.scale;
        this.transform.scale = request.scale;
        this.transform.scaledPosition = PointExtensions.sub(PointExtensions.initialize(newX, newY), this.transform.position);
      }
    }
    static ɵfac = function UpdateScaleExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UpdateScaleExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UpdateScaleExecution,
      factory: UpdateScaleExecution.ɵfac
    });
  };
  UpdateScaleExecution = __decorate([FExecutionRegister(UpdateScaleRequest)], UpdateScaleExecution);
  return UpdateScaleExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_CANVAS_FEATURES = [AddCanvasToStoreExecution, CenterGroupOrNodeExecution, FitToFlowExecution, GetCanvasExecution, InputCanvasPositionExecution, InputCanvasScaleExecution, RedrawCanvasWithAnimationExecution, RemoveCanvasFromStoreExecution, ResetScaleExecution, ResetScaleAndCenterExecution, UpdateScaleExecution];
class AddConnectionForCreateToStoreRequest {
  fConnection;
  constructor(fConnection) {
    this.fConnection = fConnection;
  }
}
let AddConnectionForCreateToStoreExecution = /*#__PURE__*/(() => {
  let AddConnectionForCreateToStoreExecution = class AddConnectionForCreateToStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fTempConnection = request.fConnection;
    }
    static ɵfac = function AddConnectionForCreateToStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddConnectionForCreateToStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddConnectionForCreateToStoreExecution,
      factory: AddConnectionForCreateToStoreExecution.ɵfac
    });
  };
  AddConnectionForCreateToStoreExecution = __decorate([FExecutionRegister(AddConnectionForCreateToStoreRequest)], AddConnectionForCreateToStoreExecution);
  return AddConnectionForCreateToStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class AddConnectionMarkerToStoreRequest {
  fComponent;
  constructor(fComponent) {
    this.fComponent = fComponent;
  }
}
let AddConnectionMarkerToStoreExecution = /*#__PURE__*/(() => {
  let AddConnectionMarkerToStoreExecution = class AddConnectionMarkerToStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.addComponent(this._fComponentsStore.fMarkers, request.fComponent);
    }
    static ɵfac = function AddConnectionMarkerToStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddConnectionMarkerToStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddConnectionMarkerToStoreExecution,
      factory: AddConnectionMarkerToStoreExecution.ɵfac
    });
  };
  AddConnectionMarkerToStoreExecution = __decorate([FExecutionRegister(AddConnectionMarkerToStoreRequest)], AddConnectionMarkerToStoreExecution);
  return AddConnectionMarkerToStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class AddConnectionToStoreRequest {
  fConnection;
  constructor(fConnection) {
    this.fConnection = fConnection;
  }
}
let AddConnectionToStoreExecution = /*#__PURE__*/(() => {
  let AddConnectionToStoreExecution = class AddConnectionToStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fConnections.push(request.fConnection);
      this._fComponentsStore.dataChanged();
    }
    static ɵfac = function AddConnectionToStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddConnectionToStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddConnectionToStoreExecution,
      factory: AddConnectionToStoreExecution.ɵfac
    });
  };
  AddConnectionToStoreExecution = __decorate([FExecutionRegister(AddConnectionToStoreRequest)], AddConnectionToStoreExecution);
  return AddConnectionToStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class AddSnapConnectionToStoreRequest {
  fConnection;
  constructor(fConnection) {
    this.fConnection = fConnection;
  }
}
let AddSnapConnectionToStoreExecution = /*#__PURE__*/(() => {
  let AddSnapConnectionToStoreExecution = class AddSnapConnectionToStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fSnapConnection = request.fConnection;
    }
    static ɵfac = function AddSnapConnectionToStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddSnapConnectionToStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddSnapConnectionToStoreExecution,
      factory: AddSnapConnectionToStoreExecution.ɵfac
    });
  };
  AddSnapConnectionToStoreExecution = __decorate([FExecutionRegister(AddSnapConnectionToStoreRequest)], AddSnapConnectionToStoreExecution);
  return AddSnapConnectionToStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CreateConnectionMarkersRequest {
  fConnection;
  constructor(fConnection) {
    this.fConnection = fConnection;
  }
}
let CreateConnectionMarkersExecution = /*#__PURE__*/(() => {
  let CreateConnectionMarkersExecution = class CreateConnectionMarkersExecution {
    fBrowser;
    fComponentsStore;
    constructor(fBrowser, fComponentsStore) {
      this.fBrowser = fBrowser;
      this.fComponentsStore = fComponentsStore;
    }
    handle(request) {
      const element = createSVGElement$1('defs', this.fBrowser);
      const fConnection = request.fConnection;
      this.getMarkers(fConnection).forEach(marker => {
        const markerElement = this.createMarkerElement(marker, fConnection.fId);
        const clone = marker.hostElement.cloneNode(true);
        clone.setAttribute('height', `${marker.height}`);
        clone.setAttribute('width', `${marker.width}`);
        clone.removeAttribute('markerUnits');
        clone.style.display = 'unset';
        markerElement.append(clone);
        element.append(markerElement);
      });
      fConnection.fDefs.nativeElement.innerHTML = element.innerHTML;
      this.makeSafariCompatible(fConnection);
    }
    getMarkers(fConnection) {
      return this.fComponentsStore.fMarkers.filter(x => fConnection.hostElement.contains(x.hostElement));
    }
    // Safari does not support markers on path elements if markers are defined after the path element
    makeSafariCompatible(fConnection) {
      fConnection.fPath.hostElement.replaceWith(fConnection.fPath.hostElement);
    }
    createMarkerElement(marker, fConnectionId) {
      const markerElement = createSVGElement$1('marker', this.fBrowser);
      markerElement.setAttribute('id', normalizeDomElementId(marker.type + '-' + fConnectionId));
      markerElement.setAttribute('markerHeight', `${marker.height}`);
      markerElement.setAttribute('markerWidth', `${marker.width}`);
      markerElement.setAttribute('orient', `${marker.orient}`);
      markerElement.setAttribute('refX', `${marker.refX}`);
      markerElement.setAttribute('refY', `${marker.refY}`);
      markerElement.setAttribute('markerUnits', `${marker.markerUnits}`);
      return markerElement;
    }
    static ɵfac = function CreateConnectionMarkersExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CreateConnectionMarkersExecution)(i0.ɵɵinject(i1.BrowserService), i0.ɵɵinject(FComponentsStore));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CreateConnectionMarkersExecution,
      factory: CreateConnectionMarkersExecution.ɵfac
    });
  };
  CreateConnectionMarkersExecution = __decorate([FExecutionRegister(CreateConnectionMarkersRequest)], CreateConnectionMarkersExecution);
  return CreateConnectionMarkersExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function createSVGElement$1(tag, fBrowser) {
  return fBrowser.document.createElementNS('http://www.w3.org/2000/svg', tag);
}
class CalculateConnectionLineByBehaviorRequest {
  outputRect;
  inputRect;
  behavior;
  outputSide;
  inputSide;
  constructor(outputRect, inputRect, behavior, outputSide, inputSide) {
    this.outputRect = outputRect;
    this.inputRect = inputRect;
    this.behavior = behavior;
    this.outputSide = outputSide;
    this.inputSide = inputSide;
  }
}
class CalculateCenterBetweenPointsHandler {
  handle(request) {
    const {
      source,
      target
    } = request;
    const offsetX = Math.abs(target.x - source.x) / 2;
    const centerX = target.x < source.x ? target.x + offsetX : target.x - offsetX;
    const offsetY = Math.abs(target.y - source.y) / 2;
    const centerY = target.y < source.y ? target.y + offsetY : target.y - offsetY;
    return PointExtensions.initialize(centerX, centerY);
  }
}
class CalculateCenterBetweenPointsRequest {
  source;
  target;
  constructor(source, target) {
    this.source = source;
    this.target = target;
  }
}
class CalculateConnectionCenterHandler {
  handle(request) {
    const {
      points
    } = request;
    let totalDistance = 0;
    let distances = [];
    for (let i = 0; i < points.length - 1; i++) {
      const distance = this.calculateDistance(points[i], points[i + 1]);
      distances.push(distance);
      totalDistance += distance;
    }
    let accumulatedDistance = 0;
    let centerIndex = 0;
    const halfTotalDistance = totalDistance / 2;
    for (let i = 0; i < distances.length; i++) {
      accumulatedDistance += distances[i];
      if (accumulatedDistance >= halfTotalDistance) {
        centerIndex = i;
        break;
      }
    }
    const remainingDistanceToCenter = halfTotalDistance - (accumulatedDistance - distances[centerIndex]);
    return this.findPointAtDistance(points[centerIndex], points[centerIndex + 1], remainingDistanceToCenter);
  }
  calculateDistance(pointA, pointB) {
    return Math.sqrt(Math.pow(pointB.x - pointA.x, 2) + Math.pow(pointB.y - pointA.y, 2));
  }
  findPointAtDistance(startPoint, endPoint, distance) {
    const totalDistance = this.calculateDistance(startPoint, endPoint);
    const ratio = distance / totalDistance;
    const x = (1 - ratio) * startPoint.x + ratio * endPoint.x;
    const y = (1 - ratio) * startPoint.y + ratio * endPoint.y;
    return {
      x,
      y
    };
  }
}
class CalculateConnectionCenterRequest {
  points;
  constructor(points) {
    this.points = points;
  }
}
var EFConnectableSide = /*#__PURE__*/function (EFConnectableSide) {
  EFConnectableSide["LEFT"] = "left";
  EFConnectableSide["TOP"] = "top";
  EFConnectableSide["RIGHT"] = "right";
  EFConnectableSide["BOTTOM"] = "bottom";
  EFConnectableSide["AUTO"] = "auto";
  return EFConnectableSide;
}(EFConnectableSide || {});
class FConnectorBase {
  _isConnected = false;
  get isConnected() {
    return this._isConnected;
  }
  toConnector = [];
  isSelfConnectable = true;
  fConnectableSide = EFConnectableSide.AUTO;
  userFConnectableSide = EFConnectableSide.AUTO;
  isContains(element) {
    return this.hostElement.contains(element);
  }
  setConnected(toConnector) {
    this._isConnected = true;
    this.toConnector.push(toConnector);
  }
  resetConnected() {
    this._isConnected = false;
    this.toConnector = [];
  }
}
const F_NODE_INPUT = new InjectionToken('F_NODE_INPUT');
let FNodeInputBase = /*#__PURE__*/(() => {
  class FNodeInputBase extends FConnectorBase {
    get canBeConnected() {
      return !this.disabled && (this.multiple ? true : !this.isConnected);
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFNodeInputBase_BaseFactory;
      return function FNodeInputBase_Factory(__ngFactoryType__) {
        return (ɵFNodeInputBase_BaseFactory || (ɵFNodeInputBase_BaseFactory = i0.ɵɵgetInheritedFactory(FNodeInputBase)))(__ngFactoryType__ || FNodeInputBase);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FNodeInputBase,
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return FNodeInputBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var EFResizeHandleType = /*#__PURE__*/function (EFResizeHandleType) {
  EFResizeHandleType["LEFT"] = "left";
  EFResizeHandleType["LEFT_TOP"] = "left-top";
  EFResizeHandleType["TOP"] = "top";
  EFResizeHandleType["RIGHT_TOP"] = "right-top";
  EFResizeHandleType["RIGHT"] = "right";
  EFResizeHandleType["RIGHT_BOTTOM"] = "right-bottom";
  EFResizeHandleType["BOTTOM"] = "bottom";
  EFResizeHandleType["LEFT_BOTTOM"] = "left-bottom";
  return EFResizeHandleType;
}(EFResizeHandleType || {});
let FResizeHandleDirective = /*#__PURE__*/(() => {
  class FResizeHandleDirective {
    type = input.required({
      alias: 'fResizeHandleType',
      transform: x => castToEnum(x, 'fResizeHandleType', EFResizeHandleType)
    });
    class = computed(() => {
      return `f-resize-handle-${EFResizeHandleType[this.type().toUpperCase()]}`;
    });
    static ɵfac = function FResizeHandleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FResizeHandleDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FResizeHandleDirective,
      selectors: [["", "fResizeHandle", ""]],
      hostAttrs: [1, "f-resize-handle", "f-component"],
      hostVars: 3,
      hostBindings: function FResizeHandleDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("data-f-resize-handle-type", ctx.type().toUpperCase());
          i0.ɵɵclassMap(ctx.class());
        }
      },
      inputs: {
        type: [1, "fResizeHandleType", "type"]
      }
    });
  }
  return FResizeHandleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FRotateHandleDirective = /*#__PURE__*/(() => {
  class FRotateHandleDirective {
    static ɵfac = function FRotateHandleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FRotateHandleDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FRotateHandleDirective,
      selectors: [["", "fRotateHandle", ""]],
      hostAttrs: [1, "f-rotate-handle", "f-component"]
    });
  }
  return FRotateHandleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function isRotateHandle(element) {
  return isClosestElementHasClass(element, '.f-rotate-handle');
}
let FDragHandleDirective = /*#__PURE__*/(() => {
  class FDragHandleDirective {
    static ɵfac = function FDragHandleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FDragHandleDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FDragHandleDirective,
      selectors: [["", "fDragHandle", ""]],
      hostAttrs: [1, "f-drag-handle", "f-component"]
    });
  }
  return FDragHandleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_SELECTED_CLASS = 'f-selected';
function mixinChangeSelection(base) {
  return class extends base {
    fId = '';
    fSelectionDisabled = false;
    unmarkAsSelected() {
      this.unmarkChildrenAsSelected?.();
      this.hostElement.classList.remove(F_SELECTED_CLASS);
    }
    markAsSelected() {
      this.markChildrenAsSelected?.();
      if (!this.isSelected()) {
        this.hostElement.classList.add(F_SELECTED_CLASS);
      }
    }
    isSelected() {
      return this.hostElement.classList.contains(F_SELECTED_CLASS);
    }
    markChildrenAsSelected() {}
    unmarkChildrenAsSelected() {}
    constructor(...args) {
      super(...args);
    }
  };
}
function mixinChangeVisibility(base) {
  return class extends base {
    show() {
      this.hostElement.style.display = "unset";
    }
    hide() {
      this.hostElement.style.display = "none";
    }
    constructor(...args) {
      super(...args);
    }
  };
}
const F_NODE = new InjectionToken('F_NODE');
const MIXIN_BASE$1 = mixinChangeSelection(class {
  hostElement;
  constructor(hostElement) {
    this.hostElement = hostElement;
  }
});
class FNodeBase extends MIXIN_BASE$1 {
  stateChanges = new FChannel();
  _position = PointExtensions.initialize();
  _rotate = 0;
  _size;
  fCanBeResizedByChild = true;
  connectors = [];
  isContains(element) {
    return this.hostElement.contains(element);
  }
  redraw() {
    if (this.size) {
      this.setStyle('width', '' + this.size.width + 'px');
      this.setStyle('height', '' + this.size.height + 'px');
    }
    this.setStyle('transform', `translate(${this.position.x}px,${this.position.y}px) rotate(${this.rotate}deg)`);
  }
  updatePosition(position) {
    this._position = position;
  }
  updateRotate(rotate) {
    this._rotate = rotate;
  }
  updateSize(value) {
    this._size = value;
  }
  setClass(className) {
    this.hostElement.classList.add(className);
  }
  removeClass(className) {
    this.hostElement.classList.remove(className);
  }
  addConnector(connector) {
    this.connectors.push(connector);
    this.refresh();
  }
  removeConnector(connector) {
    const index = this.connectors.indexOf(connector);
    if (index !== -1) {
      this.connectors.splice(index, 1);
    }
    this.refresh();
  }
}
let uniqueId$b = 0;
let FGroupDirective = /*#__PURE__*/(() => {
  class FGroupDirective extends FNodeBase {
    renderer;
    fBrowser;
    fId = `f-group-${uniqueId$b++}`;
    fParentId = null;
    set position(value) {
      if (!PointExtensions.isEqual(this._position, value)) {
        this._position = value;
        this.redraw();
        this.refresh();
      }
    }
    get position() {
      return this._position;
    }
    positionChange = new EventEmitter();
    set rotate(value) {
      if (this._rotate !== value) {
        this._rotate = value;
        this.redraw();
        this.refresh();
      }
    }
    get rotate() {
      return this._rotate;
    }
    rotateChange = new EventEmitter();
    set size(value) {
      if (!this.size || !SizeExtensions.isEqual(this._size, value)) {
        this._size = value;
        this.redraw();
        this.refresh();
      }
    }
    get size() {
      return this._size;
    }
    sizeChange = new EventEmitter();
    fDraggingDisabled = false;
    fSelectionDisabled = false;
    fIncludePadding = true;
    fConnectOnNode = true;
    _destroyRef = inject(DestroyRef);
    _fMediator = inject(FMediator);
    constructor(elementReference, renderer, fBrowser) {
      super(elementReference.nativeElement);
      this.renderer = renderer;
      this.fBrowser = fBrowser;
    }
    ngOnInit() {
      this.setStyle('position', 'absolute');
      this.setStyle('transform-origin', 'center');
      this.setStyle('user-select', 'none');
      this.setStyle('pointer-events', 'all');
      this.setStyle('left', '0');
      this.setStyle('top', '0');
      super.redraw();
      this._fMediator.execute(new AddNodeToStoreRequest(this));
    }
    setStyle(styleName, value) {
      this.renderer.setStyle(this.hostElement, styleName, value);
    }
    redraw() {
      super.redraw();
      this._fMediator.execute(new NotifyTransformChangedRequest());
    }
    ngAfterViewInit() {
      if (!this.fBrowser.isBrowser()) {
        return;
      }
      this._listenStateSizeChanges();
    }
    _listenStateSizeChanges() {
      this._fMediator.execute(new UpdateNodeWhenStateOrSizeChangedRequest(this, this._destroyRef));
    }
    refresh() {
      this.stateChanges.notify();
    }
    ngOnDestroy() {
      this._fMediator.execute(new RemoveNodeFromStoreRequest(this));
    }
    static ɵfac = function FGroupDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FGroupDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.BrowserService));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FGroupDirective,
      selectors: [["", "fGroup", ""]],
      hostAttrs: [1, "f-group", "f-component"],
      hostVars: 5,
      hostBindings: function FGroupDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("data-f-group-id", ctx.fId);
          i0.ɵɵclassProp("f-group-dragging-disabled", ctx.fDraggingDisabled)("f-group-selection-disabled", ctx.fSelectionDisabled);
        }
      },
      inputs: {
        fId: [0, "fGroupId", "fId"],
        fParentId: [0, "fGroupParentId", "fParentId"],
        position: [0, "fGroupPosition", "position"],
        rotate: [0, "fGroupRotate", "rotate"],
        size: [0, "fGroupSize", "size"],
        fDraggingDisabled: [2, "fGroupDraggingDisabled", "fDraggingDisabled", booleanAttribute],
        fSelectionDisabled: [2, "fGroupSelectionDisabled", "fSelectionDisabled", booleanAttribute],
        fIncludePadding: [2, "fIncludePadding", "fIncludePadding", booleanAttribute],
        fConnectOnNode: [2, "fConnectOnNode", "fConnectOnNode", booleanAttribute]
      },
      outputs: {
        positionChange: "fGroupPositionChange",
        rotateChange: "fGroupRotateChange",
        sizeChange: "fGroupSizeChange"
      },
      exportAs: ["fComponent"],
      features: [i0.ɵɵProvidersFeature([{
        provide: F_NODE,
        useExisting: FGroupDirective
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature]
    });
  }
  return FGroupDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let uniqueId$a = 0;
let FNodeDirective = /*#__PURE__*/(() => {
  class FNodeDirective extends FNodeBase {
    renderer;
    fBrowser;
    fId = `f-node-${uniqueId$a++}`;
    fParentId = null;
    set position(value) {
      if (!PointExtensions.isEqual(this._position, value)) {
        this._position = value;
        this.redraw();
        this.refresh();
      }
    }
    get position() {
      return this._position;
    }
    positionChange = new EventEmitter();
    set size(value) {
      if (!this.size || !SizeExtensions.isEqual(this._size, value)) {
        this._size = value;
        this.redraw();
        this.refresh();
      }
    }
    set rotate(value) {
      if (this._rotate !== value) {
        this._rotate = value;
        this.redraw();
        this.refresh();
      }
    }
    get rotate() {
      return this._rotate;
    }
    rotateChange = new EventEmitter();
    get size() {
      return this._size;
    }
    sizeChange = new EventEmitter();
    fDraggingDisabled = false;
    fSelectionDisabled = false;
    fIncludePadding = true;
    //Add ability to connect to first connectable input if node is at pointer position
    fConnectOnNode = true;
    _destroyRef = inject(DestroyRef);
    _fMediator = inject(FMediator);
    constructor(elementReference, renderer, fBrowser) {
      super(elementReference.nativeElement);
      this.renderer = renderer;
      this.fBrowser = fBrowser;
    }
    ngOnInit() {
      this.setStyle('position', 'absolute');
      this.setStyle('transform-origin', 'center');
      this.setStyle('user-select', 'none');
      this.setStyle('pointer-events', 'all');
      this.setStyle('left', '0');
      this.setStyle('top', '0');
      super.redraw();
      this._fMediator.execute(new AddNodeToStoreRequest(this));
    }
    setStyle(styleName, value) {
      this.renderer.setStyle(this.hostElement, styleName, value);
    }
    redraw() {
      super.redraw();
      this._fMediator.execute(new NotifyTransformChangedRequest());
    }
    ngAfterViewInit() {
      if (!this.fBrowser.isBrowser()) {
        return;
      }
      this._listenStateSizeChanges();
    }
    _listenStateSizeChanges() {
      this._fMediator.execute(new UpdateNodeWhenStateOrSizeChangedRequest(this, this._destroyRef));
    }
    refresh() {
      this.stateChanges.notify();
    }
    ngOnDestroy() {
      this._fMediator.execute(new RemoveNodeFromStoreRequest(this));
    }
    static ɵfac = function FNodeDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FNodeDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.BrowserService));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FNodeDirective,
      selectors: [["", "fNode", ""]],
      hostAttrs: [1, "f-node", "f-component"],
      hostVars: 5,
      hostBindings: function FNodeDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("data-f-node-id", ctx.fId);
          i0.ɵɵclassProp("f-node-dragging-disabled", ctx.fDraggingDisabled)("f-node-selection-disabled", ctx.fSelectionDisabled);
        }
      },
      inputs: {
        fId: [0, "fNodeId", "fId"],
        fParentId: [0, "fNodeParentId", "fParentId"],
        position: [0, "fNodePosition", "position"],
        size: [0, "fNodeSize", "size"],
        rotate: [0, "fNodeRotate", "rotate"],
        fDraggingDisabled: [2, "fNodeDraggingDisabled", "fDraggingDisabled", booleanAttribute],
        fSelectionDisabled: [2, "fNodeSelectionDisabled", "fSelectionDisabled", booleanAttribute],
        fIncludePadding: [2, "fIncludePadding", "fIncludePadding", booleanAttribute],
        fConnectOnNode: [2, "fConnectOnNode", "fConnectOnNode", booleanAttribute]
      },
      outputs: {
        positionChange: "fNodePositionChange",
        rotateChange: "fNodeRotateChange",
        sizeChange: "fNodeSizeChange"
      },
      exportAs: ["fComponent"],
      features: [i0.ɵɵProvidersFeature([{
        provide: F_NODE,
        useExisting: FNodeDirective
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature]
    });
  }
  return FNodeDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function isNode(element) {
  return !!element.closest('[fNode]');
}
const F_NODE_PROVIDERS = [FGroupDirective, FNodeDirective, FDragHandleDirective, FResizeHandleDirective, FRotateHandleDirective];
let uniqueId$9 = 0;
let FNodeInputDirective = /*#__PURE__*/(() => {
  class FNodeInputDirective extends FNodeInputBase {
    _elementReference = inject(ElementRef);
    _fMediator = inject(FMediator);
    _fNode = inject(F_NODE);
    fId = `f-node-input-${uniqueId$9++}`;
    multiple = true;
    disabled = false;
    userFConnectableSide = EFConnectableSide.AUTO;
    get fNodeId() {
      return this._fNode.fId;
    }
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    ngOnInit() {
      this._fMediator.execute(new AddInputToStoreRequest(this));
      this._fNode.addConnector(this);
    }
    ngOnChanges(changes) {
      if (changes['userFConnectableSide']) {
        this._fNode.refresh();
      }
    }
    setConnected(toConnector) {
      super.setConnected(toConnector);
      this.hostElement.classList.toggle(F_CSS_CLASS.CONNECTOR.INPUT_CONNECTED, true);
      this.hostElement.classList.toggle(F_CSS_CLASS.CONNECTOR.INPUT_NOT_CONNECTABLE, !this.canBeConnected);
    }
    resetConnected() {
      super.resetConnected();
      this.hostElement.classList.toggle(F_CSS_CLASS.CONNECTOR.INPUT_CONNECTED, false);
      this.hostElement.classList.toggle(F_CSS_CLASS.CONNECTOR.INPUT_NOT_CONNECTABLE, !this.canBeConnected);
    }
    ngOnDestroy() {
      this._fNode.removeConnector(this);
      this._fMediator.execute(new RemoveInputFromStoreRequest(this));
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFNodeInputDirective_BaseFactory;
      return function FNodeInputDirective_Factory(__ngFactoryType__) {
        return (ɵFNodeInputDirective_BaseFactory || (ɵFNodeInputDirective_BaseFactory = i0.ɵɵgetInheritedFactory(FNodeInputDirective)))(__ngFactoryType__ || FNodeInputDirective);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FNodeInputDirective,
      selectors: [["", "fNodeInput", ""]],
      hostAttrs: [1, "f-component", "f-node-input"],
      hostVars: 5,
      hostBindings: function FNodeInputDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("data-f-input-id", ctx.fId);
          i0.ɵɵclassProp("f-node-input-multiple", ctx.multiple)("f-node-input-disabled", ctx.disabled);
        }
      },
      inputs: {
        fId: [0, "fInputId", "fId"],
        multiple: [0, "fInputMultiple", "multiple"],
        disabled: [2, "fInputDisabled", "disabled", booleanAttribute],
        userFConnectableSide: [2, "fInputConnectableSide", "userFConnectableSide", value => castToEnum(value, 'fInputConnectableSide', EFConnectableSide)]
      },
      exportAs: ["fNodeInput"],
      features: [i0.ɵɵProvidersFeature([{
        provide: F_NODE_INPUT,
        useExisting: FNodeInputDirective
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
    });
  }
  return FNodeInputDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_NODE_OUTLET = new InjectionToken('F_NODE_OUTLET');
let FNodeOutletBase = /*#__PURE__*/(() => {
  class FNodeOutletBase extends FConnectorBase {
    outputs = [];
    get canBeConnected() {
      return !this.disabled && this.outputs.some(output => output.canBeConnected);
    }
    setOutputs(outputs) {
      this.outputs = outputs;
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFNodeOutletBase_BaseFactory;
      return function FNodeOutletBase_Factory(__ngFactoryType__) {
        return (ɵFNodeOutletBase_BaseFactory || (ɵFNodeOutletBase_BaseFactory = i0.ɵɵgetInheritedFactory(FNodeOutletBase)))(__ngFactoryType__ || FNodeOutletBase);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FNodeOutletBase,
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return FNodeOutletBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function isNodeOutlet(element) {
  return !!element.closest('[fNodeOutlet]');
}
let uniqueId$8 = 0;
let FNodeOutletDirective = /*#__PURE__*/(() => {
  class FNodeOutletDirective extends FNodeOutletBase {
    _elementReference = inject(ElementRef);
    _fMediator = inject(FMediator);
    /// Inject FNodeBase to check if the outlet inside the node
    _fNode = inject(F_NODE);
    fId = `f-node-outlet-${uniqueId$8++}`;
    disabled = false;
    fConnectableSide = EFConnectableSide.AUTO;
    userFConnectableSide = EFConnectableSide.AUTO;
    isConnectionFromOutlet = false;
    canBeConnectedInputs = [];
    get fNodeId() {
      return this._fNode.fId;
    }
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    ngOnInit() {
      this._fMediator.execute(new AddOutletToStoreRequest(this));
    }
    ngOnDestroy() {
      this._fMediator.execute(new RemoveOutletFromStoreRequest(this));
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFNodeOutletDirective_BaseFactory;
      return function FNodeOutletDirective_Factory(__ngFactoryType__) {
        return (ɵFNodeOutletDirective_BaseFactory || (ɵFNodeOutletDirective_BaseFactory = i0.ɵɵgetInheritedFactory(FNodeOutletDirective)))(__ngFactoryType__ || FNodeOutletDirective);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FNodeOutletDirective,
      selectors: [["", "fNodeOutlet", ""]],
      hostAttrs: [1, "f-component", "f-node-outlet"],
      hostVars: 3,
      hostBindings: function FNodeOutletDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("data-f-outlet-id", ctx.fId);
          i0.ɵɵclassProp("f-node-outlet-disabled", ctx.disabled);
        }
      },
      inputs: {
        fId: [0, "fOutletId", "fId"],
        disabled: [2, "fOutletDisabled", "disabled", booleanAttribute],
        isConnectionFromOutlet: "isConnectionFromOutlet",
        canBeConnectedInputs: [0, "fCanBeConnectedInputs", "canBeConnectedInputs"]
      },
      exportAs: ["fNodeOutlet"],
      features: [i0.ɵɵProvidersFeature([{
        provide: F_NODE_OUTLET,
        useExisting: FNodeOutletDirective
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature]
    });
  }
  return FNodeOutletDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_NODE_OUTPUT = new InjectionToken('F_NODE_OUTPUT');
let FNodeOutputBase = /*#__PURE__*/(() => {
  class FNodeOutputBase extends FConnectorBase {
    get canBeConnected() {
      return !this.disabled && (this.multiple ? true : !this.isConnected);
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFNodeOutputBase_BaseFactory;
      return function FNodeOutputBase_Factory(__ngFactoryType__) {
        return (ɵFNodeOutputBase_BaseFactory || (ɵFNodeOutputBase_BaseFactory = i0.ɵɵgetInheritedFactory(FNodeOutputBase)))(__ngFactoryType__ || FNodeOutputBase);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FNodeOutputBase,
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return FNodeOutputBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function isNodeOutput(element) {
  return !!element.closest('[fNodeOutput]');
}
let uniqueId$7 = 0;
let FNodeOutputDirective = /*#__PURE__*/(() => {
  class FNodeOutputDirective extends FNodeOutputBase {
    _elementReference = inject(ElementRef);
    _fMediator = inject(FMediator);
    _fNode = inject(F_NODE);
    fId = `f-node-output-${uniqueId$7++}`;
    multiple = false;
    disabled = false;
    userFConnectableSide = EFConnectableSide.AUTO;
    isSelfConnectable = true;
    canBeConnectedInputs = [];
    get fNodeId() {
      return this._fNode.fId;
    }
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    ngOnInit() {
      this._fMediator.execute(new AddOutputToStoreRequest(this));
      this._fNode.addConnector(this);
    }
    ngOnChanges(changes) {
      if (changes['userFConnectableSide']) {
        this._fNode.refresh();
      }
    }
    setConnected(toConnector) {
      super.setConnected(toConnector);
      this.hostElement.classList.toggle(F_CSS_CLASS.CONNECTOR.OUTPUT_CONNECTED, true);
      this.hostElement.classList.toggle(F_CSS_CLASS.CONNECTOR.OUTPUT_NOT_CONNECTABLE, !this.canBeConnected);
    }
    resetConnected() {
      super.resetConnected();
      this.hostElement.classList.toggle(F_CSS_CLASS.CONNECTOR.OUTPUT_CONNECTED, false);
      this.hostElement.classList.toggle(F_CSS_CLASS.CONNECTOR.OUTPUT_NOT_CONNECTABLE, !this.canBeConnected);
    }
    ngOnDestroy() {
      this._fNode.removeConnector(this);
      this._fMediator.execute(new RemoveOutputFromStoreRequest(this));
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFNodeOutputDirective_BaseFactory;
      return function FNodeOutputDirective_Factory(__ngFactoryType__) {
        return (ɵFNodeOutputDirective_BaseFactory || (ɵFNodeOutputDirective_BaseFactory = i0.ɵɵgetInheritedFactory(FNodeOutputDirective)))(__ngFactoryType__ || FNodeOutputDirective);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FNodeOutputDirective,
      selectors: [["", "fNodeOutput", ""]],
      hostAttrs: [1, "f-component", "f-node-output"],
      hostVars: 7,
      hostBindings: function FNodeOutputDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("data-f-output-id", ctx.fId);
          i0.ɵɵclassProp("f-node-output-multiple", ctx.multiple)("f-node-output-disabled", ctx.disabled)("f-node-output-self-connectable", ctx.isSelfConnectable);
        }
      },
      inputs: {
        fId: [0, "fOutputId", "fId"],
        multiple: [0, "fOutputMultiple", "multiple"],
        disabled: [2, "fOutputDisabled", "disabled", booleanAttribute],
        userFConnectableSide: [2, "fOutputConnectableSide", "userFConnectableSide", value => castToEnum(value, 'fOutputConnectableSide', EFConnectableSide)],
        isSelfConnectable: "isSelfConnectable",
        canBeConnectedInputs: [0, "fCanBeConnectedInputs", "canBeConnectedInputs"]
      },
      exportAs: ["fNodeOutput"],
      features: [i0.ɵɵProvidersFeature([{
        provide: F_NODE_OUTPUT,
        useExisting: FNodeOutputDirective
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
    });
  }
  return FNodeOutputDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_CONNECTORS_PROVIDERS = [FNodeInputDirective, FNodeOutletDirective, FNodeOutputDirective];
class FBezierPathBuilder {
  static getConnectorOffset(distance, offset) {
    if (distance >= offset) {
      return distance;
    }
    return offset * Math.sqrt(offset - distance);
  }
  static getAnglePoint(side, source, target, offset) {
    let result = {
      x: source.x,
      y: source.y
    };
    switch (side) {
      case EFConnectableSide.LEFT:
        result.x -= FBezierPathBuilder.getConnectorOffset(source.x - target.x, offset);
        break;
      case EFConnectableSide.RIGHT:
        result.x += FBezierPathBuilder.getConnectorOffset(target.x - source.x, offset);
        break;
      case EFConnectableSide.TOP:
        result.y -= FBezierPathBuilder.getConnectorOffset(source.y - target.y, offset);
        break;
      case EFConnectableSide.BOTTOM:
        result.y += FBezierPathBuilder.getConnectorOffset(target.y - source.y, offset);
        break;
    }
    return result;
  }
  handle(request) {
    const {
      source,
      sourceSide,
      target,
      targetSide,
      offset
    } = request;
    const sourceAnglePoint = FBezierPathBuilder.getAnglePoint(sourceSide, source, target, offset);
    const targetAnglePoint = FBezierPathBuilder.getAnglePoint(targetSide, target, source, offset);
    const path = `M ${source.x} ${source.y} C ${sourceAnglePoint.x} ${sourceAnglePoint.y}, ${targetAnglePoint.x} ${targetAnglePoint.y}, ${target.x + 0.0002} ${target.y + 0.0002}`;
    const connectionCenter = new CalculateConnectionCenterHandler().handle(new CalculateConnectionCenterRequest([source, sourceAnglePoint, targetAnglePoint, target]));
    return {
      path,
      connectionCenter,
      penultimatePoint: targetAnglePoint
    };
  }
}
const CONNECTOR_SIDE_POINT = {
  [EFConnectableSide.LEFT]: PointExtensions.initialize(-1, 0),
  [EFConnectableSide.RIGHT]: PointExtensions.initialize(1, 0),
  [EFConnectableSide.TOP]: PointExtensions.initialize(0, -1),
  [EFConnectableSide.BOTTOM]: PointExtensions.initialize(0, 1),
  [EFConnectableSide.AUTO]: PointExtensions.initialize(0, 0)
};
class FSegmentPathBuilder {
  handle(request) {
    const {
      source,
      sourceSide,
      target,
      targetSide
    } = request;
    const {
      points,
      center
    } = this.getPathPoints(source, sourceSide, target, targetSide, request.offset);
    const path = this.buildPath(points, request.radius);
    const penultimatePoint = points.length > 1 ? points[points.length - 2] : source;
    return {
      path,
      connectionCenter: center,
      penultimatePoint
    };
  }
  getPathPoints(source, sourceSide, target, targetSide, offset) {
    const sourceDirection = CONNECTOR_SIDE_POINT[sourceSide];
    const targetDirection = CONNECTOR_SIDE_POINT[targetSide];
    const sourceGap = {
      x: source.x + sourceDirection.x * offset,
      y: source.y + sourceDirection.y * offset
    };
    const targetGap = {
      x: target.x + targetDirection.x * offset,
      y: target.y + targetDirection.y * offset
    };
    const direction = this.getDirection(sourceGap, sourceSide, targetGap);
    const directionAccessor = direction.x !== 0 ? 'x' : 'y';
    const currentDirection = direction[directionAccessor];
    let points = [];
    const sourceGapOffset = PointExtensions.initialize();
    const targetGapOffset = PointExtensions.initialize();
    const centerBetweenPoints = new CalculateCenterBetweenPointsHandler().handle(new CalculateCenterBetweenPointsRequest(source, target));
    if (sourceDirection[directionAccessor] * targetDirection[directionAccessor] === -1) {
      const verticalSplit = [{
        x: centerBetweenPoints.x,
        y: sourceGap.y
      }, {
        x: centerBetweenPoints.x,
        y: targetGap.y
      }];
      const horizontalSplit = [{
        x: sourceGap.x,
        y: centerBetweenPoints.y
      }, {
        x: targetGap.x,
        y: centerBetweenPoints.y
      }];
      if (sourceDirection[directionAccessor] === currentDirection) {
        points = directionAccessor === 'x' ? verticalSplit : horizontalSplit;
      } else {
        points = directionAccessor === 'x' ? horizontalSplit : verticalSplit;
      }
    } else {
      const sourceTarget = [{
        x: sourceGap.x,
        y: targetGap.y
      }];
      const targetSource = [{
        x: targetGap.x,
        y: sourceGap.y
      }];
      if (directionAccessor === 'x') {
        points = sourceDirection.x === currentDirection ? targetSource : sourceTarget;
      } else {
        points = sourceDirection.y === currentDirection ? sourceTarget : targetSource;
      }
      if (sourceSide === targetSide) {
        const diff = Math.abs(source[directionAccessor] - target[directionAccessor]);
        if (diff <= offset) {
          const gapOffset = Math.min(offset - 1, offset - diff);
          if (sourceDirection[directionAccessor] === currentDirection) {
            sourceGapOffset[directionAccessor] = (sourceGap[directionAccessor] > source[directionAccessor] ? -1 : 1) * gapOffset;
          } else {
            targetGapOffset[directionAccessor] = (targetGap[directionAccessor] > target[directionAccessor] ? -1 : 1) * gapOffset;
          }
        }
      }
      if (sourceSide !== targetSide) {
        const dirAccessorOpposite = directionAccessor === 'x' ? 'y' : 'x';
        const isSameDir = sourceDirection[directionAccessor] === targetDirection[dirAccessorOpposite];
        const sourceGtTargetOppo = sourceGap[dirAccessorOpposite] > targetGap[dirAccessorOpposite];
        const sourceLtTargetOppo = sourceGap[dirAccessorOpposite] < targetGap[dirAccessorOpposite];
        const flipSourceTarget = sourceDirection[directionAccessor] === 1 && (!isSameDir && sourceGtTargetOppo || isSameDir && sourceLtTargetOppo) || sourceDirection[directionAccessor] !== 1 && (!isSameDir && sourceLtTargetOppo || isSameDir && sourceGtTargetOppo);
        if (flipSourceTarget) {
          points = directionAccessor === 'x' ? sourceTarget : targetSource;
        }
      }
    }
    const pathPoints = [source, {
      x: sourceGap.x + sourceGapOffset.x,
      y: sourceGap.y + sourceGapOffset.y
    }, ...points, {
      x: targetGap.x + targetGapOffset.x,
      y: targetGap.y + targetGapOffset.y
    }, target];
    const center = new CalculateConnectionCenterHandler().handle(new CalculateConnectionCenterRequest(pathPoints));
    return {
      points: pathPoints,
      center: center
    };
  }
  getDirection(source, sourceSide, target) {
    if (sourceSide === EFConnectableSide.LEFT || sourceSide === EFConnectableSide.RIGHT) {
      return source.x < target.x ? PointExtensions.initialize(1, 0) : PointExtensions.initialize(-1, 0);
    }
    return source.y < target.y ? PointExtensions.initialize(0, 1) : PointExtensions.initialize(0, -1);
  }
  distance(a, b) {
    return Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
  }
  buildPath(points, borderRadius) {
    let path = '';
    for (let i = 0; i < points.length; i++) {
      const p = points[i];
      let segment = '';
      if (i > 0 && i < points.length - 1) {
        segment = this.getBend(points[i - 1], p, points[i + 1], borderRadius);
      } else if (i === points.length - 1) {
        segment = this.buildLastLineSegment(i, p);
      } else {
        segment = this.buildMoveOrLineSegment(i, p);
      }
      path += segment;
    }
    return path;
  }
  getBend(a, b, c, size) {
    const bendSize = Math.min(this.distance(a, b) / 2, this.distance(b, c) / 2, size);
    const {
      x,
      y
    } = b;
    if (a.x === x && x === c.x || a.y === y && y === c.y) {
      return `L${x} ${y}`;
    }
    if (a.y === y) {
      const xDir = a.x < c.x ? -1 : 1;
      const yDir = a.y < c.y ? 1 : -1;
      return `L ${x + bendSize * xDir},${y}Q ${x},${y} ${x},${y + bendSize * yDir}`;
    }
    const xDir = a.x < c.x ? 1 : -1;
    const yDir = a.y < c.y ? -1 : 1;
    return `L ${x},${y + bendSize * yDir}Q ${x},${y} ${x + bendSize * xDir},${y}`;
  }
  buildMoveOrLineSegment(index, point) {
    return `${index === 0 ? 'M' : 'L'}${point.x} ${point.y}`;
  }
  buildLastLineSegment(index, point) {
    return `L${point.x + 0.0002} ${point.y + 0.0002}`;
  }
}
class FStraightPathBuilder {
  handle(request) {
    const {
      source,
      target
    } = request;
    const path = `M ${source.x} ${source.y} L ${target.x + 0.0002} ${target.y + 0.0002}`;
    const connectionCenter = new CalculateConnectionCenterHandler().handle(new CalculateConnectionCenterRequest([source, target]));
    return {
      path,
      connectionCenter,
      penultimatePoint: source
    };
  }
}
const F_CONNECTION_IDENTIFIERS = {
  textId(connectionId) {
    return normalizeDomElementId('connection_text_' + connectionId);
  },
  connectionForSelectionId(connectionId) {
    return normalizeDomElementId('connection_for_selection_' + connectionId);
  },
  connectionId(connectionId) {
    return normalizeDomElementId('connection_' + connectionId);
  },
  gradientId(connectionId) {
    return normalizeDomElementId('connection_gradient_' + connectionId);
  },
  linkToGradient(connectionId) {
    return `url(#${F_CONNECTION_IDENTIFIERS.gradientId(connectionId)})`;
  },
  linkToConnection(connectionId) {
    return `#${F_CONNECTION_IDENTIFIERS.connectionId(connectionId)}`;
  }
};
const F_CONNECTION = new InjectionToken('F_CONNECTION');
let FConnectionTextPathDirective = /*#__PURE__*/(() => {
  class FConnectionTextPathDirective {
    elementReference;
    base;
    fBrowser;
    get linkToConnection() {
      return F_CONNECTION_IDENTIFIERS.linkToConnection(this.base.fId + this.base.fOutputId + this.base.fInputId);
    }
    get hostElement() {
      return this.elementReference.nativeElement;
    }
    symbolWidth = 8;
    fontSize = '12px';
    constructor(elementReference, base, fBrowser) {
      this.elementReference = elementReference;
      this.base = base;
      this.fBrowser = fBrowser;
    }
    ngOnInit() {
      this.hostElement.setAttribute('text-anchor', `middle`);
      this.symbolWidth = this.getSymbolWidth(this.base.fText || '');
    }
    getBBox() {
      return this.hostElement.getBBox();
    }
    redraw() {
      this.hostElement.setAttribute('startOffset', this.base.fTextStartOffset || '50%');
    }
    getFontStyles(element) {
      const computedStyles = this.fBrowser.window.getComputedStyle(element);
      return {
        fontSize: computedStyles.fontSize,
        fontFamily: computedStyles.fontFamily
      };
    }
    getSymbolWidth(name) {
      const text = name || 'connection';
      const {
        fontFamily,
        fontSize
      } = this.getFontStyles(this.hostElement);
      this.fontSize = fontSize || '12px';
      const canvas = this.fBrowser.document.createElement('canvas');
      let context;
      try {
        context = canvas.getContext('2d');
      } catch (e) {
        context = null;
      }
      if (!context) {
        return 0;
      }
      context.font = `${fontSize} ${fontFamily}`;
      const metrics = context.measureText(text);
      const symbolWidth = metrics.width / text.length;
      return symbolWidth;
    }
    static ɵfac = function FConnectionTextPathDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FConnectionTextPathDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(F_CONNECTION), i0.ɵɵdirectiveInject(i1.BrowserService));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FConnectionTextPathDirective,
      selectors: [["textPath", "f-connection-text-path", ""]],
      hostVars: 1,
      hostBindings: function FConnectionTextPathDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("href", ctx.linkToConnection);
        }
      }
    });
  }
  return FConnectionTextPathDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CONNECTION_TEXT = new InjectionToken('CONNECTION_TEXT');
let FConnectionTextComponent = /*#__PURE__*/(() => {
  class FConnectionTextComponent {
    elementReference;
    base;
    get textId() {
      return F_CONNECTION_IDENTIFIERS.textId(this.base.fId + this.base.fOutputId + this.base.fInputId);
    }
    get hostElement() {
      return this.elementReference.nativeElement;
    }
    get text() {
      return this.base.fText || '';
    }
    textPathDirective;
    constructor(elementReference, base) {
      this.elementReference = elementReference;
      this.base = base;
    }
    redraw(line) {
      this.textPathDirective.redraw();
      const isTextReverse = FConnectionTextComponent.isTextReverse(line);
      const dyValue = this.calculateDy(this.textPathDirective.fontSize, isTextReverse);
      this.hostElement.setAttribute('dy', dyValue);
      const textRect = this.textPathDirective.getBBox();
      const textRectCenter = [textRect.x + textRect.width / 2, textRect.y + textRect.height / 2];
      this.hostElement.setAttribute('transform', isTextReverse ? `rotate(180, ${textRectCenter})` : '');
      const startOffset = FConnectionTextComponent.getTextStartOffset(line, this.base.fText || '', this.textPathDirective.symbolWidth);
      if (startOffset < 0) {
        this.hostElement.style.display = 'none';
      } else {
        this.hostElement.style.display = 'unset';
      }
    }
    calculateDy(fontSize, isTextReverse) {
      const fontSizeNumber = parseFloat(fontSize);
      const dyValue = isTextReverse ? fontSizeNumber * 1.5 : fontSizeNumber * -0.8;
      return dyValue.toString();
    }
    static isTextReverse(line) {
      return line.point1.x > line.point2.x;
    }
    static getTextStartOffset(line, name, symbolWidth) {
      const vectorLength = PointExtensions.hypotenuse(line.point1, line.point2);
      return vectorLength / 2 - (name || '').length * symbolWidth / 2;
    }
    static ɵfac = function FConnectionTextComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FConnectionTextComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(F_CONNECTION));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FConnectionTextComponent,
      selectors: [["text", "f-connection-text", ""]],
      viewQuery: function FConnectionTextComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(FConnectionTextPathDirective, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textPathDirective = _t.first);
        }
      },
      hostAttrs: [1, "f-component", "f-connection-text"],
      hostVars: 1,
      hostBindings: function FConnectionTextComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.textId);
        }
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: CONNECTION_TEXT,
        useExisting: FConnectionTextComponent
      }])],
      attrs: _c0,
      decls: 3,
      vars: 1,
      consts: [[0, "xmlns", "svg", "http://www.w3.org/2000/svg"], ["f-connection-text-path", ""]],
      template: function FConnectionTextComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementContainerStart(0, 0);
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(1, "textPath", 1);
          i0.ɵɵtext(2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementContainerEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.text, " ");
        }
      },
      dependencies: [FConnectionTextPathDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return FConnectionTextComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_CSS_CLASS = {
  DRAG_AND_DROP: {
    DRAGGING: 'f-dragging',
    CONNECTIONS_DRAGGING: 'f-connections-dragging'
  },
  CONNECTOR: {
    OUTPUT_CONNECTED: 'f-node-output-connected',
    OUTPUT_NOT_CONNECTABLE: 'f-node-output-not-connectable',
    INPUT_CONNECTED: 'f-node-input-connected',
    INPUT_NOT_CONNECTABLE: 'f-node-input-not-connectable',
    INPUT_CAN_BE_CONNECTED_TO: 'f-node-input-can-be-connected-to'
  },
  CONNECTION: {
    DRAG_HANDLE: 'f-connection-drag-handle'
  }
};
let FConnectionDragHandleStartComponent = /*#__PURE__*/(() => {
  class FConnectionDragHandleStartComponent {
    _elementReference = inject(ElementRef);
    class = F_CSS_CLASS.CONNECTION.DRAG_HANDLE;
    point;
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    redraw(penultimatePoint, startPoint) {
      this.point = this._calculateCircleCenter(penultimatePoint, startPoint, 8);
      this.hostElement.setAttribute('cx', this.point.x.toString());
      this.hostElement.setAttribute('cy', this.point.y.toString());
    }
    _calculateCircleCenter(start, end, radius) {
      const direction = {
        x: end.x - start.x,
        y: end.y - start.y
      };
      const length = Math.sqrt(direction.x * direction.x + direction.y * direction.y) || 1;
      const unitDirection = {
        x: direction.x / length,
        y: direction.y / length
      };
      const scaledDirection = {
        x: unitDirection.x * radius,
        y: unitDirection.y * radius
      };
      return {
        x: end.x - scaledDirection.x,
        y: end.y - scaledDirection.y
      };
    }
    static ɵfac = function FConnectionDragHandleStartComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FConnectionDragHandleStartComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FConnectionDragHandleStartComponent,
      selectors: [["circle", "f-connection-drag-handle-start", ""]],
      hostVars: 2,
      hostBindings: function FConnectionDragHandleStartComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.class);
        }
      },
      attrs: _c1,
      decls: 0,
      vars: 0,
      template: function FConnectionDragHandleStartComponent_Template(rf, ctx) {},
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return FConnectionDragHandleStartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FConnectionDragHandleEndComponent = /*#__PURE__*/(() => {
  class FConnectionDragHandleEndComponent {
    _elementReference = inject(ElementRef);
    class = F_CSS_CLASS.CONNECTION.DRAG_HANDLE;
    point;
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    redraw(penultimatePoint, endPoint) {
      this.point = this._calculateCircleCenter(penultimatePoint, endPoint, 8);
      this.hostElement.setAttribute('cx', this.point.x.toString());
      this.hostElement.setAttribute('cy', this.point.y.toString());
    }
    _calculateCircleCenter(start, end, radius) {
      const direction = {
        x: end.x - start.x,
        y: end.y - start.y
      };
      const length = Math.sqrt(direction.x * direction.x + direction.y * direction.y) || 1;
      const unitDirection = {
        x: direction.x / length,
        y: direction.y / length
      };
      const scaledDirection = {
        x: unitDirection.x * radius,
        y: unitDirection.y * radius
      };
      return {
        x: end.x - scaledDirection.x,
        y: end.y - scaledDirection.y
      };
    }
    static ɵfac = function FConnectionDragHandleEndComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FConnectionDragHandleEndComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FConnectionDragHandleEndComponent,
      selectors: [["circle", "f-connection-drag-handle-end", ""]],
      hostVars: 2,
      hostBindings: function FConnectionDragHandleEndComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.class);
        }
      },
      attrs: _c2,
      decls: 0,
      vars: 0,
      template: function FConnectionDragHandleEndComponent_Template(rf, ctx) {},
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return FConnectionDragHandleEndComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CONNECTION_GRADIENT = new InjectionToken('CONNECTION_GRADIENT');
let FConnectionGradientComponent = /*#__PURE__*/(() => {
  class FConnectionGradientComponent {
    elementReference;
    base;
    get gradientId() {
      return F_CONNECTION_IDENTIFIERS.gradientId(this.base.fId + this.base.fOutputId + this.base.fInputId);
    }
    get hostElement() {
      return this.elementReference.nativeElement;
    }
    get stop1Element() {
      return this.elementReference.nativeElement.children.item(0);
    }
    get stop2Element() {
      return this.elementReference.nativeElement.children.item(1);
    }
    constructor(elementReference, base) {
      this.elementReference = elementReference;
      this.base = base;
    }
    initialize() {
      this.stop1Element.setAttribute('offset', '0%');
      this.stop2Element.setAttribute('offset', '100%');
    }
    updateGradient() {
      this.setFromColor(this.base.fStartColor);
      this.setToColor(this.base.fEndColor);
    }
    setFromColor(color) {
      this.stop1Element.setAttribute('stop-color', color || 'transparent');
    }
    setToColor(color) {
      this.stop2Element.setAttribute('stop-color', color || 'transparent');
    }
    redraw(line) {
      const x = line.point2.x - line.point1.x;
      const y = line.point2.y - line.point1.y;
      const distance = Math.sqrt(x * x + y * y) || 0.01;
      const from = new Point(0.5 - 0.5 * x / distance, 0.5 - 0.5 * y / distance);
      this.hostElement.setAttribute('x1', from.x.toString());
      this.hostElement.setAttribute('y1', from.y.toString());
      const to = new Point(0.5 + 0.5 * x / distance, 0.5 + 0.5 * y / distance);
      this.hostElement.setAttribute('x2', to.x.toString());
      this.hostElement.setAttribute('y2', to.y.toString());
      this.updateGradient();
    }
    static ɵfac = function FConnectionGradientComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FConnectionGradientComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(F_CONNECTION));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FConnectionGradientComponent,
      selectors: [["linearGradient", "fConnectionGradient", ""]],
      hostAttrs: [1, "f-component", "f-connection-gradient"],
      hostVars: 1,
      hostBindings: function FConnectionGradientComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.gradientId);
        }
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: CONNECTION_GRADIENT,
        useExisting: FConnectionGradientComponent
      }])],
      attrs: _c3,
      decls: 3,
      vars: 0,
      consts: [[0, "xmlns", "svg", "http://www.w3.org/2000/svg"]],
      template: function FConnectionGradientComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementContainerStart(0, 0);
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelement(1, "stop")(2, "stop");
          i0.ɵɵelementContainerEnd();
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return FConnectionGradientComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CONNECTION_PATH = new InjectionToken('CONNECTION_PATH');
function getMarkerStartId(fConnectionId) {
  return normalizeDomElementId(`f-connection-marker-start-${fConnectionId}`);
}
function getMarkerEndId(fConnectionId) {
  return normalizeDomElementId(`f-connection-marker-end-${fConnectionId}`);
}
function getMarkerSelectedStartId(fConnectionId) {
  return normalizeDomElementId(`f-connection-selected-marker-start-${fConnectionId}`);
}
function getMarkerSelectedEndId(fConnectionId) {
  return normalizeDomElementId(`f-connection-selected-marker-end-${fConnectionId}`);
}
let FConnectionPathComponent = /*#__PURE__*/(() => {
  class FConnectionPathComponent {
    elementReference;
    base;
    get fPathId() {
      return this.base.fId;
    }
    get linkToGradient() {
      return F_CONNECTION_IDENTIFIERS.linkToGradient(this.base.fId + this.base.fOutputId + this.base.fInputId);
    }
    get attrConnectionId() {
      return F_CONNECTION_IDENTIFIERS.connectionId(this.base.fId + this.base.fOutputId + this.base.fInputId);
    }
    get hostElement() {
      return this.elementReference.nativeElement;
    }
    constructor(elementReference, base) {
      this.elementReference = elementReference;
      this.base = base;
    }
    initialize() {
      this.deselect();
    }
    setPath(path) {
      this.hostElement.setAttribute("d", `${path}`);
    }
    select() {
      this.hostElement.setAttribute('marker-start', `url(#${getMarkerSelectedStartId(this.base.fId)})`);
      this.hostElement.setAttribute('marker-end', `url(#${getMarkerSelectedEndId(this.base.fId)})`);
    }
    deselect() {
      this.hostElement.setAttribute('marker-start', `url(#${getMarkerStartId(this.base.fId)})`);
      this.hostElement.setAttribute('marker-end', `url(#${getMarkerEndId(this.base.fId)})`);
    }
    static ɵfac = function FConnectionPathComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FConnectionPathComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(F_CONNECTION));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FConnectionPathComponent,
      selectors: [["path", "f-connection-path", ""]],
      hostAttrs: [1, "f-component", "f-connection-path"],
      hostVars: 3,
      hostBindings: function FConnectionPathComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.attrConnectionId)("data-f-path-id", ctx.fPathId)("stroke", ctx.linkToGradient);
        }
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: CONNECTION_PATH,
        useExisting: FConnectionPathComponent
      }])],
      attrs: _c4,
      decls: 0,
      vars: 0,
      template: function FConnectionPathComponent_Template(rf, ctx) {},
      styles: ["[_nghost-%COMP%]{fill:none;pointer-events:stroke}"],
      changeDetection: 0
    });
  }
  return FConnectionPathComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FConnectionSelectionComponent = /*#__PURE__*/(() => {
  class FConnectionSelectionComponent {
    elementReference;
    base;
    get connectionForSelectionId() {
      return F_CONNECTION_IDENTIFIERS.connectionForSelectionId(this.base.fId + this.base.fOutputId + this.base.fInputId);
    }
    get hostElement() {
      return this.elementReference.nativeElement;
    }
    constructor(elementReference, base) {
      this.elementReference = elementReference;
      this.base = base;
    }
    setPath(path) {
      this.hostElement.setAttribute("d", `${path}`);
    }
    static ɵfac = function FConnectionSelectionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FConnectionSelectionComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(F_CONNECTION));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FConnectionSelectionComponent,
      selectors: [["path", "fConnectionSelection", ""]],
      hostAttrs: [1, "f-component", "f-connection-selection"],
      hostVars: 1,
      hostBindings: function FConnectionSelectionComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.connectionForSelectionId);
        }
      },
      attrs: _c5,
      decls: 0,
      vars: 0,
      template: function FConnectionSelectionComponent_Template(rf, ctx) {},
      styles: ["[_nghost-%COMP%]{fill:none;pointer-events:stroke}"],
      changeDetection: 0
    });
  }
  return FConnectionSelectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_CONNECTION_BUILDERS = new InjectionToken('F_CONNECTION_BUILDERS');
let FConnectionFactory = /*#__PURE__*/(() => {
  class FConnectionFactory {
    builders = {
      [EFConnectionType.STRAIGHT]: new FStraightPathBuilder(),
      [EFConnectionType.BEZIER]: new FBezierPathBuilder(),
      [EFConnectionType.SEGMENT]: new FSegmentPathBuilder()
    };
    constructor(builders) {
      if (builders) {
        this.builders = {
          ...this.builders,
          ...builders
        };
      }
    }
    handle(request) {
      const builder = this.builders[request.type];
      if (!builder) {
        throw new Error(`FConnectionBuilder not found for type ${request.type}`);
      }
      return builder.handle(request.payload);
    }
    static ɵfac = function FConnectionFactory_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FConnectionFactory)(i0.ɵɵinject(F_CONNECTION_BUILDERS, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FConnectionFactory,
      factory: FConnectionFactory.ɵfac
    });
  }
  return FConnectionFactory;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MIXIN_BASE = mixinChangeSelection(mixinChangeVisibility(class {
  hostElement;
  constructor(hostElement) {
    this.hostElement = hostElement;
  }
}));
let FConnectionBase = /*#__PURE__*/(() => {
  class FConnectionBase extends MIXIN_BASE {
    cFactory;
    path = '';
    line = LineExtensions.initialize();
    penultimatePoint = PointExtensions.initialize();
    constructor(elementReference, cFactory) {
      super(elementReference.nativeElement);
      this.cFactory = cFactory;
    }
    initialize() {
      this.fPath.initialize();
      this.fGradient.initialize();
      this.redraw();
    }
    isContains(element) {
      return (this.hostElement.firstChild?.lastChild).contains(element);
    }
    setLine({
      point1,
      point2
    }, sourceSide, targetSide) {
      this.line = LineExtensions.initialize(point1, point2);
      const pathResult = this.getPathResult(point1, sourceSide, point2, targetSide);
      this.path = pathResult.path;
      this.penultimatePoint = pathResult.penultimatePoint || point1;
      this.fConnectionCenter?.nativeElement?.setAttribute('style', this.getTransform(pathResult.connectionCenter));
    }
    getPathResult(source, sourceSide, target, targetSide) {
      const radius = this.fRadius > 0 ? this.fRadius : 0;
      const offset = this.fOffset > 0 ? this.fOffset : 1;
      return this.cFactory.handle({
        type: this.fType,
        payload: {
          source,
          sourceSide,
          target,
          targetSide,
          radius,
          offset
        }
      });
    }
    getTransform(position) {
      return `position: absolute; pointerEvents: all; transform: translate(-50%, -50%); left: ${position.x}px; top: ${position.y}px`;
    }
    markChildrenAsSelected() {
      this.fPath.select();
    }
    unmarkChildrenAsSelected() {
      this.fPath.deselect();
    }
    redraw() {
      this.fPath.setPath(this.path);
      this.fSelection.setPath(this.path);
      this.fGradient.redraw(this.line);
      this.fDragHandle.redraw(this.penultimatePoint, this.line.point2);
      this.fTextComponent.redraw(this.line);
    }
    static ɵfac = function FConnectionBase_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FConnectionBase)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(FConnectionFactory));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FConnectionBase,
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return FConnectionBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var EFConnectionBehavior = /*#__PURE__*/function (EFConnectionBehavior) {
  EFConnectionBehavior["FIXED"] = "fixed";
  EFConnectionBehavior["FIXED_CENTER"] = "fixed_center";
  EFConnectionBehavior["FLOATING"] = "floating";
  return EFConnectionBehavior;
}(EFConnectionBehavior || {});
var EFConnectionType = /*#__PURE__*/function (EFConnectionType) {
  EFConnectionType["SEGMENT"] = "segment";
  EFConnectionType["STRAIGHT"] = "straight";
  EFConnectionType["BEZIER"] = "bezier";
  return EFConnectionType;
}(EFConnectionType || {});
let FConnectionCenterDirective = /*#__PURE__*/(() => {
  class FConnectionCenterDirective {
    static ɵfac = function FConnectionCenterDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FConnectionCenterDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FConnectionCenterDirective,
      selectors: [["", "fConnectionCenter", ""]]
    });
  }
  return FConnectionCenterDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let uniqueId$6 = 0;
let FConnectionForCreateComponent = /*#__PURE__*/(() => {
  class FConnectionForCreateComponent extends FConnectionBase {
    fId = `f-connection-for-create-${uniqueId$6++}`;
    fText = '';
    fTextStartOffset = '';
    fStartColor = 'black';
    fEndColor = 'black';
    fOutputId;
    fInputId;
    fRadius = 8;
    fOffset = 32;
    fBehavior = EFConnectionBehavior.FIXED;
    fType = EFConnectionType.STRAIGHT;
    fDraggingDisabled = false;
    fSelectionDisabled = false;
    fDefs;
    fPath;
    fGradient;
    fDragHandle;
    fSelection;
    fTextComponent;
    fConnectionCenter;
    fConnectionCenters;
    get boundingElement() {
      return this.fPath.hostElement;
    }
    _fMediator = inject(FMediator);
    constructor(elementReference, fConnectionFactory) {
      super(elementReference, fConnectionFactory);
    }
    ngOnInit() {
      this._fMediator.execute(new AddConnectionForCreateToStoreRequest(this));
    }
    ngAfterViewInit() {
      this.hide();
    }
    ngOnChanges() {
      this._fMediator.execute(new NotifyDataChangedRequest());
    }
    ngOnDestroy() {
      this._fMediator.execute(new RemoveConnectionForCreateFromStoreRequest());
    }
    static ɵfac = function FConnectionForCreateComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FConnectionForCreateComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(FConnectionFactory));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FConnectionForCreateComponent,
      selectors: [["f-connection-for-create"]],
      contentQueries: function FConnectionForCreateComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, FConnectionCenterDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fConnectionCenters = _t);
        }
      },
      viewQuery: function FConnectionForCreateComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c6, 7);
          i0.ɵɵviewQuery(CONNECTION_PATH, 7);
          i0.ɵɵviewQuery(CONNECTION_GRADIENT, 7);
          i0.ɵɵviewQuery(FConnectionDragHandleEndComponent, 7);
          i0.ɵɵviewQuery(FConnectionSelectionComponent, 7);
          i0.ɵɵviewQuery(CONNECTION_TEXT, 7);
          i0.ɵɵviewQuery(_c7, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fDefs = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fPath = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fGradient = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fDragHandle = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fSelection = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fTextComponent = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fConnectionCenter = _t.first);
        }
      },
      hostAttrs: [1, "f-component", "f-connection", "f-connection-for-create"],
      inputs: {
        fStartColor: "fStartColor",
        fEndColor: "fEndColor",
        fRadius: [2, "fRadius", "fRadius", numberAttribute],
        fOffset: [2, "fOffset", "fOffset", numberAttribute],
        fBehavior: [2, "fBehavior", "fBehavior", value => castToEnum(value, 'fBehavior', EFConnectionBehavior)],
        fType: "fType"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: F_CONNECTION,
        useExisting: FConnectionForCreateComponent
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c9,
      decls: 12,
      vars: 3,
      consts: [["defs", ""], ["fConnectionCenter", ""], ["xmlns", "http://www.w3.org/2000/svg"], [1, "f-connection-group"], ["fConnectionGradient", ""], ["fConnectionSelection", ""], ["f-connection-path", ""], ["f-connection-drag-handle-end", ""], ["f-connection-text", ""], ["class", "f-connection-center", 4, "ngIf"], [1, "f-connection-center"]],
      template: function FConnectionForCreateComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c8);
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(0, "svg", 2);
          i0.ɵɵelement(1, "defs", null, 0);
          i0.ɵɵelementStart(3, "g", 3);
          i0.ɵɵelement(4, "linearGradient", 4)(5, "path", 5);
          i0.ɵɵelementStart(6, "g");
          i0.ɵɵelement(7, "path", 6)(8, "circle", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(9, "text", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(10);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(11, FConnectionForCreateComponent_div_11_Template, 3, 0, "div", 9);
        }
        if (rf & 2) {
          i0.ɵɵadvance(5);
          i0.ɵɵattribute("d", ctx.path);
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("d", ctx.path);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.fConnectionCenters.length);
        }
      },
      dependencies: [i2.NgIf, FConnectionTextComponent, FConnectionDragHandleEndComponent, FConnectionGradientComponent, FConnectionPathComponent, FConnectionSelectionComponent],
      styles: ["[_nghost-%COMP%]{pointer-events:none;position:absolute}[_nghost-%COMP%]   svg[_ngcontent-%COMP%]{overflow:visible}[_nghost-%COMP%]   svg[_ngcontent-%COMP%]   .f-connection-group[_ngcontent-%COMP%]{pointer-events:all}[_nghost-%COMP%]   .f-connection-center[_ngcontent-%COMP%]{pointer-events:all}"],
      changeDetection: 0
    });
  }
  return FConnectionForCreateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let uniqueId$5 = 0;
let FConnectionComponent = /*#__PURE__*/(() => {
  class FConnectionComponent extends FConnectionBase {
    fId = `f-connection-${uniqueId$5++}`;
    fText = '';
    fTextStartOffset = '';
    fStartColor = 'black';
    fEndColor = 'black';
    fOutputId = '';
    fInputId = '';
    fRadius = 8;
    fOffset = 32;
    fBehavior = EFConnectionBehavior.FIXED;
    fType = EFConnectionType.STRAIGHT;
    fDraggingDisabled = false;
    fSelectionDisabled = false;
    fDefs;
    fPath;
    fGradient;
    fDragHandle;
    fSelection;
    fTextComponent;
    fConnectionCenter;
    fConnectionCenters;
    get boundingElement() {
      return this.fPath.hostElement;
    }
    _fMediator = inject(FMediator);
    constructor(elementReference, fConnectionFactory) {
      super(elementReference, fConnectionFactory);
    }
    ngOnInit() {
      this._fMediator.execute(new AddConnectionToStoreRequest(this));
    }
    ngOnChanges() {
      this._fMediator.execute(new NotifyDataChangedRequest());
    }
    ngOnDestroy() {
      this._fMediator.execute(new RemoveConnectionFromStoreRequest(this));
    }
    static ɵfac = function FConnectionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FConnectionComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(FConnectionFactory));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FConnectionComponent,
      selectors: [["f-connection"]],
      contentQueries: function FConnectionComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, FConnectionCenterDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fConnectionCenters = _t);
        }
      },
      viewQuery: function FConnectionComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c6, 7);
          i0.ɵɵviewQuery(CONNECTION_PATH, 7);
          i0.ɵɵviewQuery(CONNECTION_GRADIENT, 7);
          i0.ɵɵviewQuery(FConnectionDragHandleEndComponent, 7);
          i0.ɵɵviewQuery(FConnectionSelectionComponent, 7);
          i0.ɵɵviewQuery(CONNECTION_TEXT, 7);
          i0.ɵɵviewQuery(_c7, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fDefs = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fPath = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fGradient = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fDragHandle = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fSelection = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fTextComponent = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fConnectionCenter = _t.first);
        }
      },
      hostAttrs: [1, "f-component", "f-connection"],
      hostVars: 5,
      hostBindings: function FConnectionComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.fId);
          i0.ɵɵclassProp("f-connection-selection-disabled", ctx.fSelectionDisabled)("f-connection-reassign-disabled", ctx.fDraggingDisabled);
        }
      },
      inputs: {
        fId: [0, "fConnectionId", "fId"],
        fText: "fText",
        fTextStartOffset: "fTextStartOffset",
        fStartColor: "fStartColor",
        fEndColor: "fEndColor",
        fOutputId: "fOutputId",
        fInputId: "fInputId",
        fRadius: [2, "fRadius", "fRadius", numberAttribute],
        fOffset: [2, "fOffset", "fOffset", numberAttribute],
        fBehavior: [2, "fBehavior", "fBehavior", value => castToEnum(value, 'fBehavior', EFConnectionBehavior)],
        fType: "fType",
        fDraggingDisabled: [2, "fReassignDisabled", "fDraggingDisabled", booleanAttribute],
        fSelectionDisabled: [2, "fSelectionDisabled", "fSelectionDisabled", booleanAttribute]
      },
      exportAs: ["fComponent"],
      features: [i0.ɵɵProvidersFeature([{
        provide: F_CONNECTION,
        useExisting: FConnectionComponent
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c9,
      decls: 12,
      vars: 3,
      consts: [["defs", ""], ["fConnectionCenter", ""], ["xmlns", "http://www.w3.org/2000/svg", 2, "overflow", "visible", "display", "block", "vertical-align", "middle"], [1, "f-connection-group"], ["fConnectionGradient", ""], ["fConnectionSelection", ""], ["f-connection-path", ""], ["f-connection-drag-handle-end", ""], ["f-connection-text", ""], ["class", "f-connection-center", 4, "ngIf"], [1, "f-connection-center"]],
      template: function FConnectionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c8);
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(0, "svg", 2);
          i0.ɵɵelement(1, "defs", null, 0);
          i0.ɵɵprojection(3);
          i0.ɵɵelementStart(4, "g", 3);
          i0.ɵɵelement(5, "linearGradient", 4)(6, "path", 5);
          i0.ɵɵelementStart(7, "g");
          i0.ɵɵelement(8, "path", 6)(9, "circle", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(10, "text", 8);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(11, FConnectionComponent_div_11_Template, 3, 0, "div", 9);
        }
        if (rf & 2) {
          i0.ɵɵadvance(6);
          i0.ɵɵattribute("d", ctx.path);
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("d", ctx.path);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.fConnectionCenters.length);
        }
      },
      dependencies: [i2.NgIf, FConnectionTextComponent, FConnectionDragHandleEndComponent, FConnectionGradientComponent, FConnectionPathComponent, FConnectionSelectionComponent],
      styles: [_c10],
      changeDetection: 0
    });
  }
  return FConnectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var EFMarkerType = /*#__PURE__*/function (EFMarkerType) {
  EFMarkerType["START"] = "f-connection-marker-start";
  EFMarkerType["END"] = "f-connection-marker-end";
  EFMarkerType["SELECTED_START"] = "f-connection-selected-marker-start";
  EFMarkerType["SELECTED_END"] = "f-connection-selected-marker-end";
  return EFMarkerType;
}(EFMarkerType || {});
const F_MARKER = new InjectionToken('F_MARKER');
let FMarkerBase = /*#__PURE__*/(() => {
  class FMarkerBase {
    static ɵfac = function FMarkerBase_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FMarkerBase)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FMarkerBase
    });
  }
  return FMarkerBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FMarkerDirective = /*#__PURE__*/(() => {
  class FMarkerDirective extends FMarkerBase {
    elementReference;
    get hostElement() {
      return this.elementReference.nativeElement;
    }
    width = 0;
    height = 0;
    refX = 0;
    refY = 0;
    type = EFMarkerType.START;
    orient = 'auto';
    markerUnits = 'strokeWidth';
    _fMediator = inject(FMediator);
    constructor(elementReference) {
      super();
      this.elementReference = elementReference;
      this.hostElement.style.display = 'none';
    }
    ngOnInit() {
      this._fMediator.execute(new AddConnectionMarkerToStoreRequest(this));
    }
    ngOnDestroy() {
      this._fMediator.execute(new RemoveConnectionMarkerFromStoreRequest(this));
    }
    static ɵfac = function FMarkerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FMarkerDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FMarkerDirective,
      selectors: [["svg", "fMarker", ""]],
      hostAttrs: [1, "f-component", "f-marker"],
      inputs: {
        hostElement: "hostElement",
        width: "width",
        height: "height",
        refX: "refX",
        refY: "refY",
        type: "type",
        orient: "orient",
        markerUnits: "markerUnits"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: F_MARKER,
        useExisting: FMarkerDirective
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return FMarkerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let uniqueId$4 = 0;
let FSnapConnectionComponent = /*#__PURE__*/(() => {
  class FSnapConnectionComponent extends FConnectionBase {
    fId = `f-snap-connection-${uniqueId$4++}`;
    fText = '';
    fTextStartOffset = '';
    fStartColor = 'black';
    fEndColor = 'black';
    fSnapThreshold = 20;
    fOutputId;
    fInputId;
    fRadius = 8;
    fOffset = 32;
    fBehavior = EFConnectionBehavior.FIXED;
    fType = EFConnectionType.STRAIGHT;
    fDraggingDisabled = false;
    fSelectionDisabled = false;
    fDefs;
    fPath;
    fGradient;
    fDragHandle;
    fSelection;
    fTextComponent;
    fConnectionCenter;
    fConnectionCenters;
    get boundingElement() {
      return this.fPath.hostElement;
    }
    _fMediator = inject(FMediator);
    constructor(elementReference, fConnectionFactory) {
      super(elementReference, fConnectionFactory);
    }
    ngOnInit() {
      this._fMediator.execute(new AddSnapConnectionToStoreRequest(this));
    }
    ngAfterViewInit() {
      this.hide();
    }
    ngOnChanges() {
      this._fMediator.execute(new NotifyDataChangedRequest());
    }
    ngOnDestroy() {
      this._fMediator.execute(new RemoveSnapConnectionFromStoreRequest());
    }
    static ɵfac = function FSnapConnectionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FSnapConnectionComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(FConnectionFactory));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FSnapConnectionComponent,
      selectors: [["f-snap-connection"]],
      contentQueries: function FSnapConnectionComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, FConnectionCenterDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fConnectionCenters = _t);
        }
      },
      viewQuery: function FSnapConnectionComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c6, 7);
          i0.ɵɵviewQuery(CONNECTION_PATH, 7);
          i0.ɵɵviewQuery(CONNECTION_GRADIENT, 7);
          i0.ɵɵviewQuery(FConnectionDragHandleEndComponent, 7);
          i0.ɵɵviewQuery(FConnectionSelectionComponent, 7);
          i0.ɵɵviewQuery(CONNECTION_TEXT, 7);
          i0.ɵɵviewQuery(_c7, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fDefs = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fPath = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fGradient = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fDragHandle = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fSelection = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fTextComponent = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fConnectionCenter = _t.first);
        }
      },
      hostAttrs: [1, "f-component", "f-connection", "f-snap-connection"],
      inputs: {
        fStartColor: "fStartColor",
        fEndColor: "fEndColor",
        fSnapThreshold: [2, "fSnapThreshold", "fSnapThreshold", numberAttribute],
        fRadius: [2, "fRadius", "fRadius", numberAttribute],
        fOffset: [2, "fOffset", "fOffset", numberAttribute],
        fBehavior: [2, "fBehavior", "fBehavior", value => castToEnum(value, 'fBehavior', EFConnectionBehavior)],
        fType: "fType"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: F_CONNECTION,
        useExisting: FSnapConnectionComponent
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c9,
      decls: 12,
      vars: 3,
      consts: [["defs", ""], ["fConnectionCenter", ""], ["xmlns", "http://www.w3.org/2000/svg"], [1, "f-connection-group"], ["fConnectionGradient", ""], ["fConnectionSelection", ""], ["f-connection-path", ""], ["f-connection-drag-handle-end", ""], ["f-connection-text", ""], ["class", "f-connection-center", 4, "ngIf"], [1, "f-connection-center"]],
      template: function FSnapConnectionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c8);
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(0, "svg", 2);
          i0.ɵɵelement(1, "defs", null, 0);
          i0.ɵɵelementStart(3, "g", 3);
          i0.ɵɵelement(4, "linearGradient", 4)(5, "path", 5);
          i0.ɵɵelementStart(6, "g");
          i0.ɵɵelement(7, "path", 6)(8, "circle", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(9, "text", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(10);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(11, FSnapConnectionComponent_div_11_Template, 3, 0, "div", 9);
        }
        if (rf & 2) {
          i0.ɵɵadvance(5);
          i0.ɵɵattribute("d", ctx.path);
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("d", ctx.path);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.fConnectionCenters.length);
        }
      },
      dependencies: [i2.NgIf, FConnectionTextComponent, FConnectionDragHandleEndComponent, FConnectionGradientComponent, FConnectionPathComponent, FConnectionSelectionComponent],
      styles: [_c10],
      changeDetection: 0
    });
  }
  return FSnapConnectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_CONNECTION_PROVIDERS = [FConnectionTextComponent, FConnectionTextPathDirective, FConnectionDragHandleStartComponent, FConnectionDragHandleEndComponent, FConnectionGradientComponent, FConnectionPathComponent, FConnectionSelectionComponent, FConnectionComponent, FConnectionCenterDirective, FConnectionForCreateComponent, FMarkerDirective, FSnapConnectionComponent];
function floatingBehavior(payload) {
  return _getIntersectionsLine(_fromRoundedRectIntersections(payload), _toRoundedRectIntersections(payload), payload);
}
function _fromRoundedRectIntersections(payload) {
  return GetIntersections.getRoundedRectIntersections(payload.outputRect.gravityCenter, payload.inputRect.gravityCenter, payload.outputRect)[0];
}
function _toRoundedRectIntersections(payload) {
  return GetIntersections.getRoundedRectIntersections(payload.inputRect.gravityCenter, payload.outputRect.gravityCenter, payload.inputRect)[0];
}
function _getIntersectionsLine(from, to, payload) {
  return {
    point1: from ? from : payload.outputRect.gravityCenter,
    point2: to ? to : payload.inputRect.gravityCenter
  };
}
function fixedCenterBehavior(payload) {
  return {
    point1: payload.outputRect.gravityCenter,
    point2: payload.inputRect.gravityCenter
  };
}
function fixedOutboundBehavior(payload) {
  return {
    point1: _getPosition(payload.outputRect, payload.outputSide === EFConnectableSide.AUTO ? EFConnectableSide.BOTTOM : payload.outputSide),
    point2: _getPosition(payload.inputRect, payload.inputSide === EFConnectableSide.AUTO ? EFConnectableSide.TOP : payload.inputSide)
  };
}
function _getPosition(rect, side) {
  switch (side) {
    case EFConnectableSide.TOP:
      return {
        x: rect.x + rect.width / 2,
        y: rect.y
      };
    case EFConnectableSide.BOTTOM:
      return {
        x: rect.x + rect.width / 2,
        y: rect.y + rect.height
      };
    case EFConnectableSide.LEFT:
      return {
        x: rect.x,
        y: rect.y + rect.height / 2
      };
    case EFConnectableSide.RIGHT:
      return {
        x: rect.x + rect.width,
        y: rect.y + rect.height / 2
      };
    default:
      throw new Error(`Unknown side: ${side}`);
  }
}
let CalculateConnectionLineByBehaviorExecution = /*#__PURE__*/(() => {
  let CalculateConnectionLineByBehaviorExecution = class CalculateConnectionLineByBehaviorExecution {
    _handlers = {
      [EFConnectionBehavior.FLOATING.toString()]: floatingBehavior,
      [EFConnectionBehavior.FIXED_CENTER.toString()]: fixedCenterBehavior,
      [EFConnectionBehavior.FIXED.toString()]: fixedOutboundBehavior
    };
    handle(payload) {
      return this._handlers[payload.behavior](payload);
    }
    static ɵfac = function CalculateConnectionLineByBehaviorExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalculateConnectionLineByBehaviorExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CalculateConnectionLineByBehaviorExecution,
      factory: CalculateConnectionLineByBehaviorExecution.ɵfac
    });
  };
  CalculateConnectionLineByBehaviorExecution = __decorate([FExecutionRegister(CalculateConnectionLineByBehaviorRequest)], CalculateConnectionLineByBehaviorExecution);
  return CalculateConnectionLineByBehaviorExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RedrawConnectionsRequest {}
class GetNormalizedElementRectRequest {
  element;
  isRoundedRect;
  constructor(element, isRoundedRect = true) {
    this.element = element;
    this.isRoundedRect = isRoundedRect;
  }
}
let GetNormalizedElementRectExecution = /*#__PURE__*/(() => {
  let GetNormalizedElementRectExecution = class GetNormalizedElementRectExecution {
    _fComponentsStore = inject(FComponentsStore);
    _fMediator = inject(FMediator);
    get _transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    handle(request) {
      const systemRect = this._getElementRoundedRect(request);
      const position = this._normalizePosition(systemRect);
      const unscaledSize = this._unscaleSize(systemRect);
      const unscaledRect = this._getUnscaledRect(position, unscaledSize, systemRect);
      const offsetSize = this._getOffsetSize(request.element, unscaledSize);
      return RoundedRect.fromCenter(unscaledRect, offsetSize.width, offsetSize.height);
    }
    _getElementRoundedRect(request) {
      return request.isRoundedRect ? this._fMediator.execute(new GetElementRoundedRectRequest(request.element)) : RoundedRect.fromRect(RectExtensions.fromElement(request.element));
    }
    _normalizePosition(rect) {
      return Point.fromPoint(rect).elementTransform(this._fComponentsStore.flowHost).sub(this._transform.scaledPosition).sub(this._transform.position).div(this._transform.scale);
    }
    _unscaleSize(rect) {
      return SizeExtensions.initialize(rect.width / this._transform.scale, rect.height / this._transform.scale);
    }
    _getUnscaledRect(position, size, rect) {
      return new RoundedRect(position.x, position.y, size.width, size.height, rect.radius1, rect.radius2, rect.radius3, rect.radius4);
    }
    _getOffsetSize(element, size) {
      return SizeExtensions.offsetFromElement(element) || size;
    }
    static ɵfac = function GetNormalizedElementRectExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetNormalizedElementRectExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetNormalizedElementRectExecution,
      factory: GetNormalizedElementRectExecution.ɵfac
    });
  };
  GetNormalizedElementRectExecution = __decorate([FExecutionRegister(GetNormalizedElementRectRequest)], GetNormalizedElementRectExecution);
  return GetNormalizedElementRectExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RedrawConnectionsExecution = /*#__PURE__*/(() => {
  let RedrawConnectionsExecution = class RedrawConnectionsExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._resetConnectors();
      if (this._fComponentsStore.fTempConnection) {
        this._setMarkers(this._fComponentsStore.fTempConnection);
      }
      if (this._fComponentsStore.fSnapConnection) {
        this._setMarkers(this._fComponentsStore.fSnapConnection);
      }
      this._fComponentsStore.fConnections.forEach(x => {
        this._setupConnection(this._getOutput(x.fOutputId), this._getInput(x.fInputId), x);
      });
    }
    _getOutput(id) {
      const result = this._fComponentsStore.fOutputs.find(x => x.fId === id);
      if (!result) {
        throw new Error(`Output with id ${id} not found`);
      }
      return result;
    }
    _getInput(id) {
      const result = this._fComponentsStore.fInputs.find(x => x.fId === id);
      if (!result) {
        throw new Error(`Input with id ${id} not found`);
      }
      return result;
    }
    _resetConnectors() {
      this._fComponentsStore.fOutputs.forEach(x => x.resetConnected());
      this._fComponentsStore.fInputs.forEach(x => x.resetConnected());
    }
    _setupConnection(fOutput, fInput, fConnection) {
      fOutput.setConnected(fInput);
      fInput.setConnected(fOutput);
      const line = this._getLine(fOutput, fInput, fConnection);
      this._setMarkers(fConnection);
      fConnection.setLine(line, fOutput.fConnectableSide, fInput.fConnectableSide);
      fConnection.initialize();
      fConnection.isSelected() ? fConnection.markAsSelected() : null;
    }
    _getLine(output, input, connection) {
      return this._fMediator.execute(new CalculateConnectionLineByBehaviorRequest(this._fMediator.execute(new GetNormalizedElementRectRequest(output.hostElement, true)), this._fMediator.execute(new GetNormalizedElementRectRequest(input.hostElement, true)), connection.fBehavior, output.fConnectableSide, input.fConnectableSide));
    }
    _setMarkers(connection) {
      this._fMediator.execute(new CreateConnectionMarkersRequest(connection));
    }
    static ɵfac = function RedrawConnectionsExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RedrawConnectionsExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RedrawConnectionsExecution,
      factory: RedrawConnectionsExecution.ɵfac
    });
  };
  RedrawConnectionsExecution = __decorate([FExecutionRegister(RedrawConnectionsRequest)], RedrawConnectionsExecution);
  return RedrawConnectionsExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RemoveConnectionForCreateFromStoreRequest {}
let RemoveConnectionForCreateFromStoreExecution = /*#__PURE__*/(() => {
  let RemoveConnectionForCreateFromStoreExecution = class RemoveConnectionForCreateFromStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fTempConnection = undefined;
    }
    static ɵfac = function RemoveConnectionForCreateFromStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveConnectionForCreateFromStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RemoveConnectionForCreateFromStoreExecution,
      factory: RemoveConnectionForCreateFromStoreExecution.ɵfac
    });
  };
  RemoveConnectionForCreateFromStoreExecution = __decorate([FExecutionRegister(RemoveConnectionForCreateFromStoreRequest)], RemoveConnectionForCreateFromStoreExecution);
  return RemoveConnectionForCreateFromStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RemoveConnectionFromStoreRequest {
  fConnection;
  constructor(fConnection) {
    this.fConnection = fConnection;
  }
}
let RemoveConnectionFromStoreExecution = /*#__PURE__*/(() => {
  let RemoveConnectionFromStoreExecution = class RemoveConnectionFromStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fConnections.splice(this._getIndexOfConnection(request.fConnection), 1);
      this._fComponentsStore.dataChanged();
    }
    _getIndexOfConnection(fConnection) {
      const result = this._fComponentsStore.fConnections.indexOf(fConnection);
      if (result === -1) {
        throw new Error(`Connection not found in store`);
      }
      return result;
    }
    static ɵfac = function RemoveConnectionFromStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveConnectionFromStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RemoveConnectionFromStoreExecution,
      factory: RemoveConnectionFromStoreExecution.ɵfac
    });
  };
  RemoveConnectionFromStoreExecution = __decorate([FExecutionRegister(RemoveConnectionFromStoreRequest)], RemoveConnectionFromStoreExecution);
  return RemoveConnectionFromStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RemoveConnectionMarkerFromStoreRequest {
  fComponent;
  constructor(fComponent) {
    this.fComponent = fComponent;
  }
}
let RemoveConnectionMarkerFromStoreExecution = /*#__PURE__*/(() => {
  let RemoveConnectionMarkerFromStoreExecution = class RemoveConnectionMarkerFromStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.removeComponent(this._fComponentsStore.fMarkers, request.fComponent);
    }
    static ɵfac = function RemoveConnectionMarkerFromStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveConnectionMarkerFromStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RemoveConnectionMarkerFromStoreExecution,
      factory: RemoveConnectionMarkerFromStoreExecution.ɵfac
    });
  };
  RemoveConnectionMarkerFromStoreExecution = __decorate([FExecutionRegister(RemoveConnectionMarkerFromStoreRequest)], RemoveConnectionMarkerFromStoreExecution);
  return RemoveConnectionMarkerFromStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RemoveSnapConnectionFromStoreRequest {}
let RemoveSnapConnectionFromStoreExecution = /*#__PURE__*/(() => {
  let RemoveSnapConnectionFromStoreExecution = class RemoveSnapConnectionFromStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fSnapConnection = undefined;
    }
    static ɵfac = function RemoveSnapConnectionFromStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveSnapConnectionFromStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RemoveSnapConnectionFromStoreExecution,
      factory: RemoveSnapConnectionFromStoreExecution.ɵfac
    });
  };
  RemoveSnapConnectionFromStoreExecution = __decorate([FExecutionRegister(RemoveSnapConnectionFromStoreRequest)], RemoveSnapConnectionFromStoreExecution);
  return RemoveSnapConnectionFromStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_CONNECTION_FEATURES = [AddConnectionForCreateToStoreExecution, AddConnectionMarkerToStoreExecution, AddConnectionToStoreExecution, AddSnapConnectionToStoreExecution, CreateConnectionMarkersExecution, CalculateConnectionLineByBehaviorExecution, RedrawConnectionsExecution, RemoveConnectionForCreateFromStoreExecution, RemoveConnectionFromStoreExecution, RemoveConnectionMarkerFromStoreExecution, RemoveSnapConnectionFromStoreExecution];
class AddInputToStoreRequest {
  fComponent;
  constructor(fComponent) {
    this.fComponent = fComponent;
  }
}
let AddInputToStoreExecution = /*#__PURE__*/(() => {
  let AddInputToStoreExecution = class AddInputToStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.addComponent(this._fComponentsStore.fInputs, request.fComponent);
    }
    static ɵfac = function AddInputToStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddInputToStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddInputToStoreExecution,
      factory: AddInputToStoreExecution.ɵfac
    });
  };
  AddInputToStoreExecution = __decorate([FExecutionRegister(AddInputToStoreRequest)], AddInputToStoreExecution);
  return AddInputToStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class AddOutletToStoreRequest {
  fComponent;
  constructor(fComponent) {
    this.fComponent = fComponent;
  }
}
let AddOutletToStoreExecution = /*#__PURE__*/(() => {
  let AddOutletToStoreExecution = class AddOutletToStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.addComponent(this._fComponentsStore.fOutlets, request.fComponent);
    }
    static ɵfac = function AddOutletToStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddOutletToStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddOutletToStoreExecution,
      factory: AddOutletToStoreExecution.ɵfac
    });
  };
  AddOutletToStoreExecution = __decorate([FExecutionRegister(AddOutletToStoreRequest)], AddOutletToStoreExecution);
  return AddOutletToStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class AddOutputToStoreRequest {
  fComponent;
  constructor(fComponent) {
    this.fComponent = fComponent;
  }
}
let AddOutputToStoreExecution = /*#__PURE__*/(() => {
  let AddOutputToStoreExecution = class AddOutputToStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.addComponent(this._fComponentsStore.fOutputs, request.fComponent);
    }
    static ɵfac = function AddOutputToStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddOutputToStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddOutputToStoreExecution,
      factory: AddOutputToStoreExecution.ɵfac
    });
  };
  AddOutputToStoreExecution = __decorate([FExecutionRegister(AddOutputToStoreRequest)], AddOutputToStoreExecution);
  return AddOutputToStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CalculateClosestInputRequest {
  position;
  canBeConnectedInputs;
  constructor(position, canBeConnectedInputs) {
    this.position = position;
    this.canBeConnectedInputs = canBeConnectedInputs;
  }
}
let CalculateClosestInputExecution = /*#__PURE__*/(() => {
  let CalculateClosestInputExecution = class CalculateClosestInputExecution {
    handle(payload) {
      let result;
      let minDistance = Infinity;
      for (const element of payload.canBeConnectedInputs) {
        const distance = this._distanceToRectangle(payload.position, element);
        if (distance < minDistance) {
          minDistance = distance;
          result = element;
        }
      }
      return result ? {
        ...result,
        distance: minDistance
      } : undefined;
    }
    _distanceToRectangle(point, inputWithRect) {
      const closestX = this._clamp(point.x, inputWithRect.fRect.x, inputWithRect.fRect.x + inputWithRect.fRect.width);
      const closestY = this._clamp(point.y, inputWithRect.fRect.y, inputWithRect.fRect.y + inputWithRect.fRect.height);
      const dx = point.x - closestX;
      const dy = point.y - closestY;
      return Math.sqrt(dx * dx + dy * dy);
    }
    _clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }
    static ɵfac = function CalculateClosestInputExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalculateClosestInputExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CalculateClosestInputExecution,
      factory: CalculateClosestInputExecution.ɵfac
    });
  };
  CalculateClosestInputExecution = __decorate([FExecutionRegister(CalculateClosestInputRequest)], CalculateClosestInputExecution);
  return CalculateClosestInputExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FindInputAtPositionRequest {
  pointerPosition;
  toConnectorRect;
  canBeConnectedInputs;
  constructor(pointerPosition, toConnectorRect, canBeConnectedInputs) {
    this.pointerPosition = pointerPosition;
    this.toConnectorRect = toConnectorRect;
    this.canBeConnectedInputs = canBeConnectedInputs;
  }
}
let FindInputAtPositionExecution = /*#__PURE__*/(() => {
  let FindInputAtPositionExecution = class FindInputAtPositionExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fBrowser = inject(BrowserService);
    get _transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    get _fHost() {
      return this._fComponentsStore.fFlow.hostElement;
    }
    get _fNodes() {
      return this._fComponentsStore.fNodes;
    }
    get _fSnapConnection() {
      return this._fComponentsStore.fSnapConnection;
    }
    handle(payload) {
      const fInputs = this._findInputsAtPosition(payload);
      return fInputs.length > 0 ? fInputs[0] : undefined;
    }
    _findInputsAtPosition(request) {
      const result = [];
      result.push(...this._getConnectableInputsAtPosition(request));
      const fClosestInput = this._calculateClosetInput(request);
      if (fClosestInput) {
        result.unshift(fClosestInput.fConnector);
      }
      const fInput = this._getFirstConnectableInputOfNodeAtPosition(request);
      if (fInput) {
        result.push(fInput);
      }
      return result;
    }
    _getConnectableInputsAtPosition(request) {
      return request.canBeConnectedInputs.filter(x => {
        return RectExtensions.isIncludePoint(x.fRect, this._getPointInFlow(request.pointerPosition));
      }).map(x => x.fConnector);
    }
    _getPointInFlow(position) {
      return Point.fromPoint(position).elementTransform(this._fHost).sub(this._transform.scaledPosition).sub(this._transform.position).div(this._transform.scale);
    }
    //if the closest input is valid, return it
    _calculateClosetInput(request) {
      if (!this._fSnapConnection) {
        return undefined;
      }
      const fClosestInput = this._fMediator.execute(new CalculateClosestInputRequest(this._getPointInFlow(request.pointerPosition), request.canBeConnectedInputs));
      return this._isValidClosestInput(fClosestInput) ? fClosestInput : undefined;
    }
    _isValidClosestInput(fClosestInput) {
      return !!fClosestInput && fClosestInput.distance < this._fSnapConnection.fSnapThreshold;
    }
    //if node placed in position and fConnectOnNode is true, return the first connectable input of the node
    _getFirstConnectableInputOfNodeAtPosition(request) {
      return this._getElementsFromPoint(request.pointerPosition).map(x => this._findConnectableNode(x)).filter(x => !!x).map(x => this._findFirstConnectableInputOfNode(request.canBeConnectedInputs, x)).find(x => !!x);
    }
    _getElementsFromPoint(position) {
      return this._fBrowser.document.elementsFromPoint(position.x, position.y);
    }
    _findConnectableNode(element) {
      return this._fNodes.find(x => x.isContains(element) && x.fConnectOnNode);
    }
    _findFirstConnectableInputOfNode(connectableInputs, fNode) {
      return connectableInputs.find(x => x.fConnector.fNodeId === fNode.fId)?.fConnector;
    }
    static ɵfac = function FindInputAtPositionExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FindInputAtPositionExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FindInputAtPositionExecution,
      factory: FindInputAtPositionExecution.ɵfac
    });
  };
  FindInputAtPositionExecution = __decorate([FExecutionRegister(FindInputAtPositionRequest)], FindInputAtPositionExecution);
  return FindInputAtPositionExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetAllCanBeConnectedInputsAndRectsRequest {
  fOutputOrOutlet;
  constructor(fOutputOrOutlet) {
    this.fOutputOrOutlet = fOutputOrOutlet;
  }
}
class GetConnectorAndRectRequest {
  fConnector;
  constructor(fConnector) {
    this.fConnector = fConnector;
  }
}
let GetConnectorAndRectExecution = /*#__PURE__*/(() => {
  let GetConnectorAndRectExecution = class GetConnectorAndRectExecution {
    _fMediator = inject(FMediator);
    handle(request) {
      return {
        fConnector: request.fConnector,
        fRect: this._getConnectorRect(request.fConnector)
      };
    }
    _getConnectorRect(fConnector) {
      return this._fMediator.execute(new GetNormalizedElementRectRequest(fConnector.hostElement, true));
    }
    static ɵfac = function GetConnectorAndRectExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetConnectorAndRectExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetConnectorAndRectExecution,
      factory: GetConnectorAndRectExecution.ɵfac
    });
  };
  GetConnectorAndRectExecution = __decorate([FExecutionRegister(GetConnectorAndRectRequest)], GetConnectorAndRectExecution);
  return GetConnectorAndRectExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GetAllCanBeConnectedInputsAndRectsExecution = /*#__PURE__*/(() => {
  let GetAllCanBeConnectedInputsAndRectsExecution = class GetAllCanBeConnectedInputsAndRectsExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    get _fInputs() {
      return this._fComponentsStore.fInputs;
    }
    handle(payload) {
      return this._getCanBeConnectedInputs(payload.fOutputOrOutlet).map(x => {
        return this._fMediator.execute(new GetConnectorAndRectRequest(x));
      });
    }
    _getCanBeConnectedInputs(fOutputOrOutlet) {
      let fInputs = [];
      if (fOutputOrOutlet.canBeConnectedInputs?.length) {
        fInputs = this._fInputs.filter(x => fOutputOrOutlet.canBeConnectedInputs.includes(x.fId));
      } else {
        fInputs = this._fInputs.filter(x => x.canBeConnected);
        if (!fOutputOrOutlet.isSelfConnectable) {
          fInputs = this._filterSelfConnectable(fInputs, fOutputOrOutlet);
        }
      }
      return fInputs;
    }
    _filterSelfConnectable(fInputs, fOutputOrOutlet) {
      return fInputs.filter(x => fOutputOrOutlet.fNodeId !== x.fNodeId);
    }
    static ɵfac = function GetAllCanBeConnectedInputsAndRectsExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetAllCanBeConnectedInputsAndRectsExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetAllCanBeConnectedInputsAndRectsExecution,
      factory: GetAllCanBeConnectedInputsAndRectsExecution.ɵfac
    });
  };
  GetAllCanBeConnectedInputsAndRectsExecution = __decorate([FExecutionRegister(GetAllCanBeConnectedInputsAndRectsRequest)], GetAllCanBeConnectedInputsAndRectsExecution);
  return GetAllCanBeConnectedInputsAndRectsExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class MarkAllCanBeConnectedInputsRequest {
  fInputs;
  constructor(fInputs) {
    this.fInputs = fInputs;
  }
}
let MarkAllCanBeConnectedInputsExecution = /*#__PURE__*/(() => {
  let MarkAllCanBeConnectedInputsExecution = class MarkAllCanBeConnectedInputsExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(payload) {
      this._fComponentsStore.flowHost.classList.add(F_CSS_CLASS.DRAG_AND_DROP.CONNECTIONS_DRAGGING);
      payload.fInputs.forEach(fInput => this._markCanBeConnectedTo(fInput));
    }
    _markCanBeConnectedTo(fInput) {
      fInput.hostElement.classList.add(F_CSS_CLASS.CONNECTOR.INPUT_CAN_BE_CONNECTED_TO);
    }
    static ɵfac = function MarkAllCanBeConnectedInputsExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MarkAllCanBeConnectedInputsExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MarkAllCanBeConnectedInputsExecution,
      factory: MarkAllCanBeConnectedInputsExecution.ɵfac
    });
  };
  MarkAllCanBeConnectedInputsExecution = __decorate([FExecutionRegister(MarkAllCanBeConnectedInputsRequest)], MarkAllCanBeConnectedInputsExecution);
  return MarkAllCanBeConnectedInputsExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RemoveInputFromStoreRequest {
  fComponent;
  constructor(fComponent) {
    this.fComponent = fComponent;
  }
}
let RemoveInputFromStoreExecution = /*#__PURE__*/(() => {
  let RemoveInputFromStoreExecution = class RemoveInputFromStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.removeComponent(this._fComponentsStore.fInputs, request.fComponent);
    }
    static ɵfac = function RemoveInputFromStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveInputFromStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RemoveInputFromStoreExecution,
      factory: RemoveInputFromStoreExecution.ɵfac
    });
  };
  RemoveInputFromStoreExecution = __decorate([FExecutionRegister(RemoveInputFromStoreRequest)], RemoveInputFromStoreExecution);
  return RemoveInputFromStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RemoveOutletFromStoreRequest {
  fComponent;
  constructor(fComponent) {
    this.fComponent = fComponent;
  }
}
let RemoveOutletFromStoreExecution = /*#__PURE__*/(() => {
  let RemoveOutletFromStoreExecution = class RemoveOutletFromStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.removeComponent(this._fComponentsStore.fOutlets, request.fComponent);
    }
    static ɵfac = function RemoveOutletFromStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveOutletFromStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RemoveOutletFromStoreExecution,
      factory: RemoveOutletFromStoreExecution.ɵfac
    });
  };
  RemoveOutletFromStoreExecution = __decorate([FExecutionRegister(RemoveOutletFromStoreRequest)], RemoveOutletFromStoreExecution);
  return RemoveOutletFromStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RemoveOutputFromStoreRequest {
  fComponent;
  constructor(fComponent) {
    this.fComponent = fComponent;
  }
}
let RemoveOutputFromStoreExecution = /*#__PURE__*/(() => {
  let RemoveOutputFromStoreExecution = class RemoveOutputFromStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.removeComponent(this._fComponentsStore.fOutputs, request.fComponent);
    }
    static ɵfac = function RemoveOutputFromStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveOutputFromStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RemoveOutputFromStoreExecution,
      factory: RemoveOutputFromStoreExecution.ɵfac
    });
  };
  RemoveOutputFromStoreExecution = __decorate([FExecutionRegister(RemoveOutputFromStoreRequest)], RemoveOutputFromStoreExecution);
  return RemoveOutputFromStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class UnmarkAllCanBeConnectedInputsRequest {
  fInputs;
  constructor(fInputs) {
    this.fInputs = fInputs;
  }
}
let UnmarkAllCanBeConnectedInputsExecution = /*#__PURE__*/(() => {
  let UnmarkAllCanBeConnectedInputsExecution = class UnmarkAllCanBeConnectedInputsExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(payload) {
      this._fComponentsStore.flowHost.classList.remove(F_CSS_CLASS.DRAG_AND_DROP.CONNECTIONS_DRAGGING);
      payload.fInputs.forEach(fInput => this._unmarkCanBeConnectedTo(fInput));
    }
    _unmarkCanBeConnectedTo(fInput) {
      fInput.hostElement.classList.remove(F_CSS_CLASS.CONNECTOR.INPUT_CAN_BE_CONNECTED_TO);
    }
    static ɵfac = function UnmarkAllCanBeConnectedInputsExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UnmarkAllCanBeConnectedInputsExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UnmarkAllCanBeConnectedInputsExecution,
      factory: UnmarkAllCanBeConnectedInputsExecution.ɵfac
    });
  };
  UnmarkAllCanBeConnectedInputsExecution = __decorate([FExecutionRegister(UnmarkAllCanBeConnectedInputsRequest)], UnmarkAllCanBeConnectedInputsExecution);
  return UnmarkAllCanBeConnectedInputsExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_CONNECTORS_FEATURES = [AddInputToStoreExecution, AddOutletToStoreExecution, AddOutputToStoreExecution, CalculateClosestInputExecution, FindInputAtPositionExecution, GetAllCanBeConnectedInputsAndRectsExecution, GetConnectorAndRectExecution, MarkAllCanBeConnectedInputsExecution, RemoveInputFromStoreExecution, RemoveOutletFromStoreExecution, RemoveOutputFromStoreExecution, UnmarkAllCanBeConnectedInputsExecution];
class AddDndToStoreRequest {
  fComponent;
  constructor(fComponent) {
    this.fComponent = fComponent;
  }
}
let AddDndToStoreExecution = /*#__PURE__*/(() => {
  let AddDndToStoreExecution = class AddDndToStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fDraggable = request.fComponent;
    }
    static ɵfac = function AddDndToStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddDndToStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddDndToStoreExecution,
      factory: AddDndToStoreExecution.ɵfac
    });
  };
  AddDndToStoreExecution = __decorate([FExecutionRegister(AddDndToStoreRequest)], AddDndToStoreExecution);
  return AddDndToStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class EmitSelectionChangeEventRequest {}
class GetNormalizedParentNodeRectRequest {
  fNode;
  constructor(fNode) {
    this.fNode = fNode;
  }
}
let GetNormalizedParentNodeRectExecution = /*#__PURE__*/(() => {
  let GetNormalizedParentNodeRectExecution = class GetNormalizedParentNodeRectExecution {
    fComponentsStore;
    fMediator;
    constructor(fComponentsStore, fMediator) {
      this.fComponentsStore = fComponentsStore;
      this.fMediator = fMediator;
    }
    handle(request) {
      let result = RectExtensions.initialize(-Infinity, -Infinity, Infinity, Infinity);
      const parentNode = this.getNode(request.fNode.fParentId);
      if (parentNode) {
        result = this.getParentRect(parentNode);
      }
      return result;
    }
    getNode(fId) {
      return this.fComponentsStore.fNodes.find(x => x.fId === fId);
    }
    getParentRect(node) {
      const rect = this._getNodeRect(node);
      const padding = this.getNodePadding(node, rect);
      return RectExtensions.initialize(rect.x + padding[0], rect.y + padding[1], rect.width - padding[0] - padding[2], rect.height - padding[1] - padding[3]);
    }
    _getNodeRect(fNode) {
      return this.fMediator.execute(new GetNormalizedElementRectRequest(fNode.hostElement, false));
    }
    getNodePadding(node, rect) {
      return this.fMediator.execute(new GetNodePaddingRequest(node, rect));
    }
    static ɵfac = function GetNormalizedParentNodeRectExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetNormalizedParentNodeRectExecution)(i0.ɵɵinject(FComponentsStore), i0.ɵɵinject(i2$1.FMediator));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetNormalizedParentNodeRectExecution,
      factory: GetNormalizedParentNodeRectExecution.ɵfac
    });
  };
  GetNormalizedParentNodeRectExecution = __decorate([FExecutionRegister(GetNormalizedParentNodeRectRequest)], GetNormalizedParentNodeRectExecution);
  return GetNormalizedParentNodeRectExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class IsArrayHasParentNodeRequest {
  fParentNodes;
  fDraggedNodes;
  constructor(fParentNodes, fDraggedNodes) {
    this.fParentNodes = fParentNodes;
    this.fDraggedNodes = fDraggedNodes;
  }
}
let IsArrayHasParentNodeExecution = /*#__PURE__*/(() => {
  let IsArrayHasParentNodeExecution = class IsArrayHasParentNodeExecution {
    handle(request) {
      return this._isParentNodeInArray(this._getParentNodeIds(request.fParentNodes), request.fDraggedNodes);
    }
    _getParentNodeIds(fParentNodes) {
      return fParentNodes.map(x => x.fId);
    }
    _isParentNodeInArray(parentNodeIds, fDraggedNodes) {
      return fDraggedNodes.some(x => parentNodeIds.includes(x.fId));
    }
    static ɵfac = function IsArrayHasParentNodeExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IsArrayHasParentNodeExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IsArrayHasParentNodeExecution,
      factory: IsArrayHasParentNodeExecution.ɵfac
    });
  };
  IsArrayHasParentNodeExecution = __decorate([FExecutionRegister(IsArrayHasParentNodeRequest)], IsArrayHasParentNodeExecution);
  return IsArrayHasParentNodeExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FNodeIntersectedWithConnections {
  fNodeId;
  fConnectionIds;
  constructor(fNodeId, fConnectionIds) {
    this.fNodeId = fNodeId;
    this.fConnectionIds = fConnectionIds;
  }
}
class IsConnectionUnderNodeRequest {
  fNode;
  constructor(fNode) {
    this.fNode = fNode;
  }
}
let IsConnectionUnderNodeExecution = /*#__PURE__*/(() => {
  let IsConnectionUnderNodeExecution = class IsConnectionUnderNodeExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      const fOutputConnectors = this._getOutputConnectors(request.fNode);
      const fInputConnectors = this._getInputConnectors(request.fNode);
      if (!fOutputConnectors.length || !fInputConnectors.length) {
        return;
      }
      const fOutputConnections = this._getOutputConnectionsId(fOutputConnectors);
      const fInputConnections = this._getInputConnectionsId(fInputConnectors);
      const fConnectionsUnderNode = this._calculateConnectionsUnderNode(request.fNode).filter(x => {
        return !fOutputConnections.includes(x.fId) && !fInputConnections.includes(x.fId);
      });
      if (!fConnectionsUnderNode.length) {
        return;
      }
      this._emitNodeIntersectedWithConnections(request.fNode, fConnectionsUnderNode);
    }
    _getOutputConnectors(fNode) {
      return this._fComponentsStore.fOutputs.filter(x => {
        return fNode.isContains(x.hostElement) && x.canBeConnected;
      });
    }
    _getInputConnectors(fNode) {
      return this._fComponentsStore.fInputs.filter(x => {
        return fNode.isContains(x.hostElement) && x.canBeConnected;
      });
    }
    _getOutputConnectionsId(connectors) {
      const connectorsId = this._getConnectorsId(connectors);
      return this._fComponentsStore.fConnections.filter(x => connectorsId.includes(x.fOutputId)).map(x => x.fId);
    }
    _getInputConnectionsId(connectors) {
      const connectorsId = this._getConnectorsId(connectors);
      return this._fComponentsStore.fConnections.filter(x => connectorsId.includes(x.fInputId)).map(x => x.fId);
    }
    _getConnectorsId(connectors) {
      return connectors.map(x => x.fId);
    }
    _calculateConnectionsUnderNode(fNode) {
      const fNodeRect = this._fMediator.execute(new GetNormalizedElementRectRequest(fNode.hostElement, true));
      return this._fComponentsStore.fConnections.filter(x => this._isConnectionHasIntersectionsWithNode(x, fNodeRect));
    }
    _isConnectionHasIntersectionsWithNode(fConnection, fNodeRect) {
      return GetIntersections.getRoundedRectIntersectionsWithSVGPath(fConnection.fPath.hostElement, fNodeRect).length > 0;
    }
    _emitNodeIntersectedWithConnections(fNode, fConnections) {
      this._fComponentsStore.fDraggable?.fNodeIntersectedWithConnections.emit(new FNodeIntersectedWithConnections(fNode.fId, fConnections.map(x => x.fId)));
    }
    static ɵfac = function IsConnectionUnderNodeExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IsConnectionUnderNodeExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IsConnectionUnderNodeExecution,
      factory: IsConnectionUnderNodeExecution.ɵfac
    });
  };
  IsConnectionUnderNodeExecution = __decorate([FExecutionRegister(IsConnectionUnderNodeRequest)], IsConnectionUnderNodeExecution);
  return IsConnectionUnderNodeExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FDragStartedEvent {
  fEventType;
  fData;
  constructor(fEventType, fData) {
    this.fEventType = fEventType;
    this.fData = fData;
  }
}
const DRAG_AND_DROP_COMMON_PROVIDERS = [GetNormalizedParentNodeRectExecution, IsArrayHasParentNodeExecution, IsConnectionUnderNodeExecution];
class FCanvasMoveFinalizeRequest {
  event;
  constructor(event) {
    this.event = event;
  }
}
let FDraggableDataContext = /*#__PURE__*/(() => {
  class FDraggableDataContext {
    selectedItems = [];
    isSelectedChanged = false;
    onPointerDownScale = 1;
    onPointerDownPosition = new Point(0, 0);
    draggableItems = [];
    reset() {
      this.draggableItems = [];
      this.onPointerDownScale = 1;
      this.onPointerDownPosition = new Point(0, 0);
    }
    markSelectionAsChanged() {
      this.isSelectedChanged = true;
    }
    isEmpty() {
      return !this.draggableItems.length;
    }
    static ɵfac = function FDraggableDataContext_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FDraggableDataContext)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FDraggableDataContext,
      factory: FDraggableDataContext.ɵfac
    });
  }
  return FDraggableDataContext;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FCanvasDragHandler {
  fEventType = 'canvas-move';
  _fComponentsStore;
  _onPointerDownPosition = PointExtensions.initialize();
  constructor(_injector) {
    this._fComponentsStore = _injector.get(FComponentsStore);
  }
  prepareDragSequence() {
    this._onPointerDownPosition = this._fComponentsStore.fCanvas.transform.position;
  }
  onPointerMove(difference) {
    this._fComponentsStore.fCanvas.setPosition(Point.fromPoint(this._onPointerDownPosition).add(difference));
    this._fComponentsStore.fCanvas.redraw();
  }
  onPointerUp() {
    this._fComponentsStore.fCanvas.emitCanvasChangeEvent();
  }
}
let FCanvasMoveFinalizeExecution = /*#__PURE__*/(() => {
  let FCanvasMoveFinalizeExecution = class FCanvasMoveFinalizeExecution {
    _fDraggableDataContext = inject(FDraggableDataContext);
    handle(request) {
      if (!this._isValid()) {
        return;
      }
      this._fDraggableDataContext.draggableItems.forEach(x => x.onPointerUp?.());
    }
    _isValid() {
      return this._fDraggableDataContext.draggableItems.some(x => x instanceof FCanvasDragHandler);
    }
    static ɵfac = function FCanvasMoveFinalizeExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FCanvasMoveFinalizeExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FCanvasMoveFinalizeExecution,
      factory: FCanvasMoveFinalizeExecution.ɵfac
    });
  };
  FCanvasMoveFinalizeExecution = __decorate([FExecutionRegister(FCanvasMoveFinalizeRequest)], FCanvasMoveFinalizeExecution);
  return FCanvasMoveFinalizeExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FCanvasMovePreparationRequest {
  event;
  fTrigger;
  constructor(event, fTrigger) {
    this.event = event;
    this.fTrigger = fTrigger;
  }
}
let FCanvasMovePreparationExecution = /*#__PURE__*/(() => {
  let FCanvasMovePreparationExecution = class FCanvasMovePreparationExecution {
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    _injector = inject(Injector);
    get _fHost() {
      return this._fComponentsStore.fFlow.hostElement;
    }
    handle(request) {
      if (!this._isValid(request) || !this._isValidTrigger(request)) {
        return;
      }
      this._fDraggableDataContext.onPointerDownScale = 1;
      this._fDraggableDataContext.onPointerDownPosition = Point.fromPoint(request.event.getPosition()).elementTransform(this._fHost);
      this._fDraggableDataContext.draggableItems = [new FCanvasDragHandler(this._injector)];
    }
    _isValid(request) {
      return this._fDraggableDataContext.isEmpty() && (this._isBackgroundElement(request.event.targetElement) || this._isDragOnHost(request.event.targetElement));
    }
    _isBackgroundElement(targetElement) {
      return this._fComponentsStore.fBackground?.hostElement.contains(targetElement);
    }
    _isDragOnHost(targetElement) {
      return this._fHost.contains(targetElement) && !this._getNode(targetElement);
    }
    _getNode(targetElement) {
      let result = this._fComponentsStore.fNodes.find(x => x.isContains(targetElement));
      if (result && result.fDraggingDisabled) {
        result = undefined;
      }
      return result;
    }
    _isValidTrigger(request) {
      return isValidEventTrigger(request.event.originalEvent, request.fTrigger);
    }
    static ɵfac = function FCanvasMovePreparationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FCanvasMovePreparationExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FCanvasMovePreparationExecution,
      factory: FCanvasMovePreparationExecution.ɵfac
    });
  };
  FCanvasMovePreparationExecution = __decorate([FExecutionRegister(FCanvasMovePreparationRequest)], FCanvasMovePreparationExecution);
  return FCanvasMovePreparationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CANVAS_PROVIDERS = [FCanvasMoveFinalizeExecution, FCanvasMovePreparationExecution];
class FCreateConnectionFinalizeRequest {
  event;
  constructor(event) {
    this.event = event;
  }
}
class GetFirstConnectableOutputRequest {
  fOutlet;
  constructor(fOutlet) {
    this.fOutlet = fOutlet;
  }
}
let GetFirstConnectableOutputExecution = /*#__PURE__*/(() => {
  let GetFirstConnectableOutputExecution = class GetFirstConnectableOutputExecution {
    _fComponentStore = inject(FComponentsStore);
    get _fNodes() {
      return this._fComponentStore.fNodes;
    }
    get _fOutputs() {
      return this._fComponentStore.fOutputs;
    }
    _fNode;
    handle(request) {
      if (!this._isValid(request)) {
        return;
      }
      const fOutputs = this._getConnectableOutputs();
      if (!fOutputs.length) {
        throw new Error('The fNode must contain at least one fOutput if there is an fOutlet');
      }
      return fOutputs[0];
    }
    _isValid(request) {
      return !!this._getNode(request.fOutlet);
    }
    _getNode(fOutlet) {
      this._fNode = this._fNodes.find(x => x.isContains(fOutlet.hostElement));
      return this._fNode;
    }
    _getConnectableOutputs() {
      return this._fOutputs.filter(x => this._fNode.isContains(x.hostElement) && x.canBeConnected);
    }
    static ɵfac = function GetFirstConnectableOutputExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetFirstConnectableOutputExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetFirstConnectableOutputExecution,
      factory: GetFirstConnectableOutputExecution.ɵfac
    });
  };
  GetFirstConnectableOutputExecution = __decorate([FExecutionRegister(GetFirstConnectableOutputRequest)], GetFirstConnectableOutputExecution);
  return GetFirstConnectableOutputExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FCreateConnectionEvent {
  fOutputId;
  fInputId;
  fDropPosition;
  constructor(fOutputId, fInputId, fDropPosition) {
    this.fOutputId = fOutputId;
    this.fInputId = fInputId;
    this.fDropPosition = fDropPosition;
  }
}
let FDragHandlerResult = /*#__PURE__*/(() => {
  class FDragHandlerResult {
    _data;
    setData(data) {
      this._data = {
        ...this._data,
        ...data
      };
    }
    getData() {
      return this._data;
    }
    clear() {
      this._data = undefined;
    }
    static ɵfac = function FDragHandlerResult_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FDragHandlerResult)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FDragHandlerResult,
      factory: FDragHandlerResult.ɵfac
    });
  }
  return FDragHandlerResult;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FCreateConnectionDragHandler {
  _fOutputOrOutlet;
  fEventType = 'create-connection';
  fData;
  _fResult;
  _fMediator;
  _fComponentsStore;
  _toConnectorRect = new RoundedRect();
  get _fConnection() {
    return this._fComponentsStore.fTempConnection;
  }
  get _fSnapConnection() {
    return this._fComponentsStore.fSnapConnection;
  }
  _fOutputWithRect;
  _canBeConnectedInputs = [];
  constructor(_injector, _fOutputOrOutlet, _onPointerDownPosition) {
    this._fOutputOrOutlet = _fOutputOrOutlet;
    this._fResult = _injector.get(FDragHandlerResult);
    this._fMediator = _injector.get(FMediator);
    this._fComponentsStore = _injector.get(FComponentsStore);
    this._toConnectorRect = RoundedRect.fromRect(RectExtensions.initialize(_onPointerDownPosition.x, _onPointerDownPosition.y));
    this.fData = {
      fOutputOrOutletId: this._fOutputOrOutlet.fId
    };
  }
  prepareDragSequence() {
    this._getAndMarkCanBeConnectedInputs();
    this._initializeSnapConnection();
    this._initializeConnectionForCreate();
    this._fOutputWithRect = this._fMediator.execute(new GetConnectorAndRectRequest(this._fOutputOrOutlet));
    this._fConnection.show();
    this.onPointerMove(PointExtensions.initialize());
    this._fResult.setData({
      toConnectorRect: this._toConnectorRect,
      canBeConnectedInputs: this._canBeConnectedInputs,
      fOutputId: this._fOutputOrOutlet.fId
    });
  }
  _getAndMarkCanBeConnectedInputs() {
    this._canBeConnectedInputs = this._fMediator.execute(new GetAllCanBeConnectedInputsAndRectsRequest(this._fOutputOrOutlet));
    this._fMediator.execute(new MarkAllCanBeConnectedInputsRequest(this._canBeConnectedInputs.map(x => x.fConnector)));
  }
  _initializeSnapConnection() {
    if (!this._fSnapConnection) {
      return;
    }
    this._fSnapConnection.fOutputId = this._fOutputOrOutlet.fId;
    this._fSnapConnection.initialize();
  }
  _initializeConnectionForCreate() {
    this._fConnection.fOutputId = this._fOutputOrOutlet.fId;
    this._fConnection.initialize();
  }
  onPointerMove(difference) {
    const fClosestInput = this._findClosestInput(difference);
    this._drawConnectionForCreate(this._toConnectorRect.addPoint(difference), fClosestInput?.fConnector.fConnectableSide || EFConnectableSide.TOP);
    if (this._fSnapConnection) {
      this._drawSnapConnection(this._getClosestInputForSnapConnection(fClosestInput));
    }
  }
  _drawConnectionForCreate(toConnectorRect, fSide) {
    const line = this._fMediator.execute(new CalculateConnectionLineByBehaviorRequest(this._fOutputWithRect.fRect, toConnectorRect, this._fConnection.fBehavior, this._fOutputWithRect.fConnector.fConnectableSide, fSide));
    this._fConnection.setLine(line, this._fOutputWithRect.fConnector.fConnectableSide, fSide);
    this._fConnection.redraw();
  }
  _drawSnapConnection(fClosestInput) {
    if (fClosestInput) {
      const line = this._fMediator.execute(new CalculateConnectionLineByBehaviorRequest(this._fOutputWithRect.fRect, fClosestInput.fRect, this._fSnapConnection.fBehavior, this._fOutputWithRect.fConnector.fConnectableSide, fClosestInput.fConnector.fConnectableSide));
      this._fSnapConnection.show();
      this._fSnapConnection.setLine(line, this._fOutputWithRect.fConnector.fConnectableSide, fClosestInput.fConnector.fConnectableSide);
      this._fSnapConnection.redraw();
    } else {
      this._fSnapConnection?.hide();
    }
  }
  _findClosestInput(difference) {
    return this._fMediator.execute(new CalculateClosestInputRequest(this._toConnectorRect.addPoint(difference), this._canBeConnectedInputs));
  }
  _getClosestInputForSnapConnection(fClosestInput) {
    return fClosestInput && fClosestInput.distance < this._fSnapConnection.fSnapThreshold ? fClosestInput : undefined;
  }
  onPointerUp() {
    this._fConnection.redraw();
    this._fConnection.hide();
    this._fSnapConnection?.hide();
    this._fMediator.execute(new UnmarkAllCanBeConnectedInputsRequest(this._canBeConnectedInputs.map(x => x.fConnector)));
  }
}
let FCreateConnectionFinalizeExecution = /*#__PURE__*/(() => {
  let FCreateConnectionFinalizeExecution = class FCreateConnectionFinalizeExecution {
    _fResult = inject(FDragHandlerResult);
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    get _fDragHandler() {
      return this._fDraggableDataContext.draggableItems[0];
    }
    handle(request) {
      if (!this._isValid()) {
        return;
      }
      this.emitEvent(request.event);
      this._fDragHandler.onPointerUp();
    }
    _isValid() {
      return this._fDraggableDataContext.draggableItems.some(x => x instanceof FCreateConnectionDragHandler);
    }
    getTargetOutput(output) {
      if (!output) {
        throw new Error(`Output with fOutputId ${this._fResult.getData().fOutputId} not found. Make sure there is no f-connection to a non-existent fOutput.`);
      }
      return isNodeOutlet(output.hostElement) ? this._fMediator.execute(new GetFirstConnectableOutputRequest(output)) : output;
    }
    getOutput() {
      return this._fComponentsStore.fOutputs.find(x => x.fId === this._fResult.getData().fOutputId);
    }
    getOutlet() {
      return this._fComponentsStore.fOutlets.find(x => x.fId === this._fResult.getData().fOutputId);
    }
    emitEvent(event) {
      this._fComponentsStore.fDraggable?.fCreateConnection.emit(new FCreateConnectionEvent(this.getTargetOutput(this.getOutput() || this.getOutlet()).fId, this._getInputUnderPointer(event)?.fId, event.getPosition()));
    }
    _getInputUnderPointer(event) {
      return this._fMediator.execute(new FindInputAtPositionRequest(event.getPosition(), this._fResult.getData().toConnectorRect, this._fResult.getData().canBeConnectedInputs));
    }
    static ɵfac = function FCreateConnectionFinalizeExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FCreateConnectionFinalizeExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FCreateConnectionFinalizeExecution,
      factory: FCreateConnectionFinalizeExecution.ɵfac
    });
  };
  FCreateConnectionFinalizeExecution = __decorate([FExecutionRegister(FCreateConnectionFinalizeRequest)], FCreateConnectionFinalizeExecution);
  return FCreateConnectionFinalizeExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FCreateConnectionDragHandlerPreparationRequest {
  onPointerDownPosition;
  fOutputOrOutlet;
  constructor(onPointerDownPosition, fOutputOrOutlet) {
    this.onPointerDownPosition = onPointerDownPosition;
    this.fOutputOrOutlet = fOutputOrOutlet;
  }
}
let FCreateConnectionDragHandlerPreparationExecution = /*#__PURE__*/(() => {
  let FCreateConnectionDragHandlerPreparationExecution = class FCreateConnectionDragHandlerPreparationExecution {
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    _injector = inject(Injector);
    get _fHost() {
      return this._fComponentsStore.fFlow.hostElement;
    }
    get _transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    handle(request) {
      this._fDraggableDataContext.onPointerDownScale = this._transform.scale;
      const positionRelativeToFlowComponent = Point.fromPoint(request.onPointerDownPosition).elementTransform(this._fHost).div(this._transform.scale);
      this._fDraggableDataContext.onPointerDownPosition = positionRelativeToFlowComponent;
      const positionRelativeToCanvasComponent = Point.fromPoint(positionRelativeToFlowComponent).mult(this._transform.scale).sub(this._transform.position).sub(this._transform.scaledPosition).div(this._transform.scale);
      this._fDraggableDataContext.draggableItems = [new FCreateConnectionDragHandler(this._injector, request.fOutputOrOutlet, positionRelativeToCanvasComponent)];
    }
    static ɵfac = function FCreateConnectionDragHandlerPreparationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FCreateConnectionDragHandlerPreparationExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FCreateConnectionDragHandlerPreparationExecution,
      factory: FCreateConnectionDragHandlerPreparationExecution.ɵfac
    });
  };
  FCreateConnectionDragHandlerPreparationExecution = __decorate([FExecutionRegister(FCreateConnectionDragHandlerPreparationRequest)], FCreateConnectionDragHandlerPreparationExecution);
  return FCreateConnectionDragHandlerPreparationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FCreateConnectionFromOutletPreparationRequest {
  event;
  fNode;
  constructor(event, fNode) {
    this.event = event;
    this.fNode = fNode;
  }
}
let FCreateConnectionFromOutletPreparationExecution = /*#__PURE__*/(() => {
  let FCreateConnectionFromOutletPreparationExecution = class FCreateConnectionFromOutletPreparationExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      const fOutlet = this._getNodeOutlet(request.fNode);
      const fOutputs = this._getNodeOutputs(request.fNode);
      fOutlet.setOutputs(fOutputs);
      if (!fOutlet.canBeConnected) {
        return;
      }
      if (fOutlet.isConnectionFromOutlet) {
        this._createDragHandler(request.event.getPosition(), fOutlet);
      } else {
        this._createDragHandler(request.event.getPosition(), this._getConnectableOutput(fOutlet));
      }
    }
    _getNodeOutlet(fNode) {
      const result = this._fComponentsStore.fOutlets.find(x => fNode.isContains(x.hostElement));
      if (!result) {
        throw new Error('Outlet not found');
      }
      return result;
    }
    _getNodeOutputs(fNode) {
      return this._fComponentsStore.fOutputs.filter(x => fNode.isContains(x.hostElement));
    }
    _createDragHandler(position, fOutputOrOutlet) {
      this._fMediator.execute(new FCreateConnectionDragHandlerPreparationRequest(position, fOutputOrOutlet));
    }
    _getConnectableOutput(fOutlet) {
      return this._fMediator.execute(new GetFirstConnectableOutputRequest(fOutlet));
    }
    static ɵfac = function FCreateConnectionFromOutletPreparationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FCreateConnectionFromOutletPreparationExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FCreateConnectionFromOutletPreparationExecution,
      factory: FCreateConnectionFromOutletPreparationExecution.ɵfac
    });
  };
  FCreateConnectionFromOutletPreparationExecution = __decorate([FExecutionRegister(FCreateConnectionFromOutletPreparationRequest)], FCreateConnectionFromOutletPreparationExecution);
  return FCreateConnectionFromOutletPreparationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FCreateConnectionFromOutputPreparationRequest {
  event;
  fNode;
  constructor(event, fNode) {
    this.event = event;
    this.fNode = fNode;
  }
}
let FCreateConnectionFromOutputPreparationExecution = /*#__PURE__*/(() => {
  let FCreateConnectionFromOutputPreparationExecution = class FCreateConnectionFromOutputPreparationExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      if (!this._isValid(request)) {
        return;
      }
      const fOutput = this._getOutput(request.event.targetElement);
      if (fOutput.canBeConnected) {
        this._fMediator.execute(new FCreateConnectionDragHandlerPreparationRequest(request.event.getPosition(), fOutput));
      }
    }
    _isValid(request) {
      return this._isNodeOutput(request.event.targetElement, request.fNode);
    }
    _isNodeOutput(element, fNode) {
      return isNodeOutput(element) && !this._getNodeOutlets(fNode).length;
    }
    _getNodeOutlets(node) {
      return this._fComponentsStore.fOutlets.filter(x => node.isContains(x.hostElement));
    }
    _getOutput(element) {
      const result = this._fComponentsStore.fOutputs.find(x => x.hostElement.contains(element));
      if (!result) {
        throw new Error('Output not found');
      }
      return result;
    }
    static ɵfac = function FCreateConnectionFromOutputPreparationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FCreateConnectionFromOutputPreparationExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FCreateConnectionFromOutputPreparationExecution,
      factory: FCreateConnectionFromOutputPreparationExecution.ɵfac
    });
  };
  FCreateConnectionFromOutputPreparationExecution = __decorate([FExecutionRegister(FCreateConnectionFromOutputPreparationRequest)], FCreateConnectionFromOutputPreparationExecution);
  return FCreateConnectionFromOutputPreparationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FCreateConnectionPreparationRequest {
  event;
  fTrigger;
  constructor(event, fTrigger) {
    this.event = event;
    this.fTrigger = fTrigger;
  }
}
let FCreateConnectionPreparationExecution = /*#__PURE__*/(() => {
  let FCreateConnectionPreparationExecution = class FCreateConnectionPreparationExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    _fNode;
    handle(request) {
      if (!this._isValid(request) || !this._isValidTrigger(request)) {
        return;
      }
      if (isNodeOutlet(request.event.targetElement)) {
        this._fMediator.execute(new FCreateConnectionFromOutletPreparationRequest(request.event, this._fNode));
      } else if (isNodeOutput(request.event.targetElement)) {
        this._fMediator.execute(new FCreateConnectionFromOutputPreparationRequest(request.event, this._fNode));
      }
    }
    _isValid(request) {
      return !!this._getNode(request.event) && this._isValidConditions();
    }
    _getNode(event) {
      this._fNode = this._fComponentsStore.fNodes.find(n => n.isContains(event.targetElement));
      return this._fNode;
    }
    _isValidConditions() {
      return this._fDraggableDataContext.isEmpty() && !!this._fComponentsStore.fTempConnection;
    }
    _isValidTrigger(request) {
      return isValidEventTrigger(request.event.originalEvent, request.fTrigger);
    }
    static ɵfac = function FCreateConnectionPreparationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FCreateConnectionPreparationExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FCreateConnectionPreparationExecution,
      factory: FCreateConnectionPreparationExecution.ɵfac
    });
  };
  FCreateConnectionPreparationExecution = __decorate([FExecutionRegister(FCreateConnectionPreparationRequest)], FCreateConnectionPreparationExecution);
  return FCreateConnectionPreparationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FReassignConnectionFinalizeRequest {
  event;
  constructor(event) {
    this.event = event;
  }
}
class FReassignConnectionDragHandler {
  _fConnection;
  fEventType = 'reassign-connection';
  fData;
  _fResult;
  _fMediator;
  _fComponentsStore;
  _toConnectorRect = new RoundedRect();
  get _fSnapConnection() {
    return this._fComponentsStore.fSnapConnection;
  }
  _fOutputWithRect;
  _fInputWithRect;
  _canBeConnectedInputs = [];
  get _fOutput() {
    const result = this._fComponentsStore.fOutputs.find(x => x.fId === this._fConnection.fOutputId);
    if (!result) {
      throw new Error('Connection output not found');
    }
    return result;
  }
  get _fInput() {
    const result = this._fComponentsStore.fInputs.find(x => x.fId === this._fConnection.fInputId);
    if (!result) {
      throw new Error('Connection input not found');
    }
    return result;
  }
  constructor(_injector, _fConnection) {
    this._fConnection = _fConnection;
    this._fResult = _injector.get(FDragHandlerResult);
    this._fMediator = _injector.get(FMediator);
    this._fComponentsStore = _injector.get(FComponentsStore);
    this._toConnectorRect = RoundedRect.fromRect(RectExtensions.initialize(this._fConnection.line.point2.x, this._fConnection.line.point2.y));
    this.fData = {
      fConnectionId: this._fConnection.fId
    };
  }
  prepareDragSequence() {
    this._getAndMarkCanBeConnectedInputs();
    this._initializeSnapConnection();
    this._fOutputWithRect = this._fMediator.execute(new GetConnectorAndRectRequest(this._fOutput));
    this._fInputWithRect = this._fMediator.execute(new GetConnectorAndRectRequest(this._fInput));
    this._fResult.setData({
      toConnectorRect: this._toConnectorRect,
      canBeConnectedInputs: this._canBeConnectedInputs,
      fConnection: this._fConnection
    });
  }
  _getAndMarkCanBeConnectedInputs() {
    this._canBeConnectedInputs = this._fMediator.execute(new GetAllCanBeConnectedInputsAndRectsRequest(this._fOutput));
    this._fMediator.execute(new MarkAllCanBeConnectedInputsRequest(this._canBeConnectedInputs.map(x => x.fConnector)));
  }
  _initializeSnapConnection() {
    if (!this._fSnapConnection) {
      return;
    }
    this._fSnapConnection.fOutputId = this._fConnection.fOutputId;
    this._fSnapConnection.initialize();
  }
  onPointerMove(difference) {
    const fClosestInput = this._findClosestInput(difference);
    this._drawConnection(this._toConnectorRect.addPoint(difference), fClosestInput?.fConnector.fConnectableSide || this._fInputWithRect.fConnector.fConnectableSide);
    if (this._fSnapConnection) {
      this._drawSnapConnection(this._getClosestInputForSnapConnection(fClosestInput));
    }
  }
  _drawConnection(difference, fSide) {
    const line = this._getLineToPointer(difference, fSide);
    this._fConnection.setLine(line, this._fOutputWithRect.fConnector.fConnectableSide, fSide);
    this._fConnection.redraw();
  }
  _getLineToPointer(difference, fSide) {
    return this._fMediator.execute(new CalculateConnectionLineByBehaviorRequest(this._fOutputWithRect.fRect, RoundedRect.fromRect(RectExtensions.initialize(difference.x, difference.y)), this._fConnection.fBehavior, this._fOutputWithRect.fConnector.fConnectableSide, fSide));
  }
  _drawSnapConnection(fClosestInput) {
    if (fClosestInput) {
      const line = this._getLineToClosestInput(fClosestInput);
      this._fSnapConnection.show();
      this._fSnapConnection.setLine(line, this._fOutputWithRect.fConnector.fConnectableSide, fClosestInput.fConnector.fConnectableSide);
      this._fSnapConnection.redraw();
    } else {
      this._fSnapConnection?.hide();
    }
  }
  _getLineToClosestInput(fClosestInput) {
    return this._fMediator.execute(new CalculateConnectionLineByBehaviorRequest(this._fOutputWithRect.fRect, fClosestInput.fRect, this._fSnapConnection.fBehavior, this._fOutputWithRect.fConnector.fConnectableSide, fClosestInput.fConnector.fConnectableSide));
  }
  _findClosestInput(difference) {
    return this._fMediator.execute(new CalculateClosestInputRequest(this._toConnectorRect.addPoint(difference), this._canBeConnectedInputs));
  }
  _getClosestInputForSnapConnection(fClosestInput) {
    return fClosestInput && fClosestInput.distance < this._fSnapConnection.fSnapThreshold ? fClosestInput : undefined;
  }
  onPointerUp() {
    this._drawConnection(this._toConnectorRect, this._fInputWithRect.fConnector.fConnectableSide);
    this._fSnapConnection?.hide();
    this._fMediator.execute(new UnmarkAllCanBeConnectedInputsRequest(this._canBeConnectedInputs.map(x => x.fConnector)));
  }
}
class FReassignConnectionEvent {
  fConnectionId;
  fOutputId;
  oldFInputId;
  newFInputId;
  fDropPosition;
  constructor(fConnectionId, fOutputId, oldFInputId, newFInputId, fDropPosition) {
    this.fConnectionId = fConnectionId;
    this.fOutputId = fOutputId;
    this.oldFInputId = oldFInputId;
    this.newFInputId = newFInputId;
    this.fDropPosition = fDropPosition;
  }
}
let FReassignConnectionFinalizeExecution = /*#__PURE__*/(() => {
  let FReassignConnectionFinalizeExecution = class FReassignConnectionFinalizeExecution {
    _fResult = inject(FDragHandlerResult);
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    get _fDraggable() {
      return this._fComponentsStore.fDraggable;
    }
    get _fDragHandler() {
      return this._fDraggableDataContext.draggableItems[0];
    }
    handle(request) {
      if (!this._isDroppedConnectionReassignEvent()) {
        return;
      }
      this._applyReassignEvent(request.event);
      this._fDragHandler.onPointerUp();
    }
    _isDroppedConnectionReassignEvent() {
      return this._fDraggableDataContext.draggableItems.some(x => x instanceof FReassignConnectionDragHandler);
    }
    _applyReassignEvent(event) {
      const fInput = this._getInputUnderPointer(event);
      if (!!fInput && !this._isReassignToDifferentInput(fInput)) {
        return;
      }
      this._emitReassignConnectionEvent(event, fInput);
    }
    _getInputUnderPointer(event) {
      return this._fMediator.execute(new FindInputAtPositionRequest(event.getPosition(), this._fResult.getData().toConnectorRect, this._fResult.getData().canBeConnectedInputs));
    }
    _isReassignToDifferentInput(fInput) {
      return this._fResult.getData().fConnection.fInputId !== fInput.fId;
    }
    _emitReassignConnectionEvent(event, fInput) {
      this._fDraggable.fReassignConnection.emit(this._getEventData(event, fInput));
    }
    _getEventData(event, fInput) {
      const fConnection = this._fResult.getData().fConnection;
      return new FReassignConnectionEvent(fConnection.fId, fConnection.fOutputId, fConnection.fInputId, fInput?.fId, event.getPosition());
    }
    static ɵfac = function FReassignConnectionFinalizeExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FReassignConnectionFinalizeExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FReassignConnectionFinalizeExecution,
      factory: FReassignConnectionFinalizeExecution.ɵfac
    });
  };
  FReassignConnectionFinalizeExecution = __decorate([FExecutionRegister(FReassignConnectionFinalizeRequest)], FReassignConnectionFinalizeExecution);
  return FReassignConnectionFinalizeExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FReassignConnectionPreparationRequest {
  event;
  fTrigger;
  constructor(event, fTrigger) {
    this.event = event;
    this.fTrigger = fTrigger;
  }
}
let FReassignConnectionPreparationExecution = /*#__PURE__*/(() => {
  let FReassignConnectionPreparationExecution = class FReassignConnectionPreparationExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    _injector = inject(Injector);
    _fConnection;
    get _transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    get _fHost() {
      return this._fComponentsStore.fFlow.hostElement;
    }
    get _fConnections() {
      return this._fComponentsStore.fConnections;
    }
    handle(request) {
      if (!this._isValid(request) || !this._isValidTrigger(request)) {
        return;
      }
      this._fDraggableDataContext.onPointerDownScale = this._transform.scale;
      this._fDraggableDataContext.onPointerDownPosition = Point.fromPoint(request.event.getPosition()).elementTransform(this._fHost).div(this._transform.scale);
      this._fDraggableDataContext.draggableItems = [new FReassignConnectionDragHandler(this._injector, this._fConnection)];
      setTimeout(() => this._updateConnectionLayer());
    }
    _isValid(request) {
      this._fConnection = this._getConnectionToReassign(this._getPointInFlow(request));
      return !!this._fConnection && !this._fDraggableDataContext.draggableItems.length;
    }
    _isValidTrigger(request) {
      return isValidEventTrigger(request.event.originalEvent, request.fTrigger);
    }
    _getPointInFlow(request) {
      return Point.fromPoint(request.event.getPosition()).elementTransform(this._fHost).sub(this._transform.scaledPosition).sub(this._transform.position).div(this._transform.scale);
    }
    _getConnectionToReassign(position) {
      const connections = this._getConnectionsFromPoint(position);
      return connections.length ? connections[0] : undefined;
    }
    _getConnectionsFromPoint(position) {
      return this._fConnections.filter(x => {
        return x.fDragHandle?.point && this._isPointInsideCircle(position, x.fDragHandle.point) && !x.fDraggingDisabled;
      });
    }
    _isPointInsideCircle(point, circleCenter) {
      return (point.x - circleCenter.x) ** 2 + (point.y - circleCenter.y) ** 2 <= 8 ** 2;
    }
    _updateConnectionLayer() {
      this._fMediator.execute(new UpdateItemAndChildrenLayersRequest(this._fConnection, this._fComponentsStore.fCanvas.fConnectionsContainer().nativeElement));
    }
    static ɵfac = function FReassignConnectionPreparationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FReassignConnectionPreparationExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FReassignConnectionPreparationExecution,
      factory: FReassignConnectionPreparationExecution.ɵfac
    });
  };
  FReassignConnectionPreparationExecution = __decorate([FExecutionRegister(FReassignConnectionPreparationRequest)], FReassignConnectionPreparationExecution);
  return FReassignConnectionPreparationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CONNECTIONS_PROVIDERS = [FCreateConnectionFinalizeExecution, FCreateConnectionDragHandlerPreparationExecution, FCreateConnectionFromOutletPreparationExecution, GetFirstConnectableOutputExecution, FCreateConnectionFromOutputPreparationExecution, FCreateConnectionPreparationExecution, FReassignConnectionFinalizeExecution, FReassignConnectionPreparationExecution];
class FNodeDropToGroupFinalizeRequest {
  event;
  constructor(event) {
    this.event = event;
  }
}
let FNodeDropToGroupDragHandler = /*#__PURE__*/(() => {
  class FNodeDropToGroupDragHandler {
    notDraggedNodesRects;
    _fComponentsStore;
    _fDraggableDataContext;
    fEventType = 'move-node-to-parent';
    _DEBOUNCE_TIME = 15;
    get _transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    _onPointerDownPosition = PointExtensions.initialize();
    _debounceTimer = null;
    fNodeWithRect = null;
    constructor(_injector, notDraggedNodesRects) {
      this.notDraggedNodesRects = notDraggedNodesRects;
      this._fComponentsStore = _injector.get(FComponentsStore);
      this._fDraggableDataContext = _injector.get(FDraggableDataContext);
      this._onPointerDownPosition = this._fDraggableDataContext.onPointerDownPosition;
    }
    _toggleParentNode(difference) {
      const isInclude = this._isNodeInsideAnotherNode(this._getNewPosition(difference));
      if (isInclude) {
        this._markIncludeNode(isInclude);
      } else {
        this._unmarkIncludeNode();
      }
    }
    _getNewPosition(difference) {
      return Point.fromPoint(this._onPointerDownPosition).add(difference).mult(this._transform.scale);
    }
    _isNodeInsideAnotherNode(point) {
      return this.notDraggedNodesRects.find(x => RectExtensions.isIncludePoint(x.rect, point));
    }
    onPointerMove(difference) {
      if (this._debounceTimer) {
        clearTimeout(this._debounceTimer);
      }
      this._debounceTimer = setTimeout(() => this._toggleParentNode(difference), this._DEBOUNCE_TIME);
    }
    _markIncludeNode(nodeWithRect) {
      this._unmarkIncludeNode();
      this.fNodeWithRect = nodeWithRect;
      nodeWithRect.node.setClass('f-parent-for-drop');
    }
    _unmarkIncludeNode() {
      this.fNodeWithRect?.node.removeClass('f-parent-for-drop');
      this.fNodeWithRect = null;
    }
    onPointerUp() {
      this._unmarkIncludeNode();
      if (this._debounceTimer) {
        clearTimeout(this._debounceTimer);
        this._debounceTimer = null;
      }
    }
    static ɵfac = function FNodeDropToGroupDragHandler_Factory(__ngFactoryType__) {
      i0.ɵɵinvalidFactory();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FNodeDropToGroupDragHandler
    });
  }
  return FNodeDropToGroupDragHandler;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class BaseConnectionDragHandler {
  fConnection;
  _fMediator;
  _fComponentsStore;
  _fOutputWithRect;
  _fInputWithRect;
  get _fOutput() {
    const result = this._fComponentsStore.fOutputs.find(x => x.fId === this.fConnection.fOutputId);
    if (!result) {
      throw new Error(this._connectorNotFoundPrefix(`fOutput with id ${this.fConnection.fOutputId} not found`));
    }
    return result;
  }
  get _fInput() {
    const result = this._fComponentsStore.fInputs.find(x => x.fId === this.fConnection.fInputId);
    if (!result) {
      throw new Error(this._connectorNotFoundPrefix(`fInput with id ${this.fConnection.fInputId} not found`));
    }
    return result;
  }
  _sourceDifference = PointExtensions.initialize();
  _targetDifference = PointExtensions.initialize();
  constructor(_injector, fConnection) {
    this.fConnection = fConnection;
    this._fMediator = _injector.get(FMediator);
    this._fComponentsStore = _injector.get(FComponentsStore);
    this._initialize();
  }
  _initialize() {
    this._fOutputWithRect = this._fMediator.execute(new GetConnectorAndRectRequest(this._fOutput));
    this._fInputWithRect = this._fMediator.execute(new GetConnectorAndRectRequest(this._fInput));
  }
  setSourceDifference(difference) {
    this._sourceDifference = difference;
  }
  setTargetDifference(difference) {
    this._targetDifference = difference;
  }
  redraw() {
    this._redrawConnection(this._recalculateConnection());
  }
  _recalculateConnection() {
    return this._fMediator.execute(new CalculateConnectionLineByBehaviorRequest(RoundedRect.fromRoundedRect(this._fOutputWithRect.fRect).addPoint(this._sourceDifference), RoundedRect.fromRoundedRect(this._fInputWithRect.fRect).addPoint(this._targetDifference), this.fConnection.fBehavior, this._fOutputWithRect.fConnector.fConnectableSide, this._fInputWithRect.fConnector.fConnectableSide));
  }
  _redrawConnection(line) {
    this.fConnection.setLine(line, this._fOutputWithRect.fConnector.fConnectableSide, this._fInputWithRect.fConnector.fConnectableSide);
    this.fConnection.redraw();
  }
  _connectorNotFoundPrefix(message) {
    return `ConnectionDragHandler Error: Connection From (fOutput)${this.fConnection.fOutputId} To (fInput)${this.fConnection.fInputId}. ${message}. Please ensure that all f-connections are associated with existing connectors`;
  }
}
class SourceConnectionDragHandler extends BaseConnectionDragHandler {
  constructor(injector, fConnection) {
    super(injector, fConnection);
  }
  setSourceDifference(difference) {
    super.setSourceDifference(difference);
    this.redraw();
  }
}
class SourceTargetConnectionDragHandler extends BaseConnectionDragHandler {
  _callTracker = new Map();
  constructor(injector, fConnection) {
    super(injector, fConnection);
  }
  setSourceDifference(difference) {
    super.setSourceDifference(difference);
    this._checkAndTriggerAction();
  }
  setTargetDifference(difference) {
    super.setTargetDifference(difference);
    this._checkAndTriggerAction();
  }
  _checkAndTriggerAction() {
    if ([...this._callTracker.values()].every(Boolean)) {
      this._callTracker.clear();
      this.redraw();
    }
  }
}
class TargetConnectionDragHandler extends BaseConnectionDragHandler {
  constructor(injector, fConnection) {
    super(injector, fConnection);
  }
  setTargetDifference(difference) {
    super.setTargetDifference(difference);
    this.redraw();
  }
}
class CalculateCommonNodeMoveLimitsRequest {
  limits;
  constructor(limits) {
    this.limits = limits;
  }
}
let CalculateCommonNodeMoveLimitsExecution = /*#__PURE__*/(() => {
  let CalculateCommonNodeMoveLimitsExecution = class CalculateCommonNodeMoveLimitsExecution {
    _fComponentsStore = inject(FComponentsStore);
    get _vCellSize() {
      return this._fComponentsStore.fDraggable.vCellSize;
    }
    get _hCellSize() {
      return this._fComponentsStore.fDraggable.hCellSize;
    }
    handle(request) {
      return this._calculateCommonLimits(request.limits);
    }
    _calculateCommonLimits(limits) {
      this._snapLimitToGrid(limits[0]);
      return limits.reduce((result, x) => {
        this._snapLimitToGrid(x);
        return this._clampRestrictions(result, x);
      }, limits[0]);
    }
    _clampRestrictions(common, x) {
      common.min = this._clampMinRestrictions(common.min, x.min);
      common.max = this._clampMaxRestrictions(common.max, x.max);
      return common;
    }
    _clampMinRestrictions(common, node) {
      return {
        x: Math.max(common.x, node.x),
        y: Math.max(common.y, node.y)
      };
    }
    _clampMaxRestrictions(common, node) {
      return {
        x: Math.min(common.x, node.x),
        y: Math.min(common.y, node.y)
      };
    }
    _snapLimitToGrid(restriction) {
      const {
        min,
        max,
        position
      } = restriction;
      restriction.min = {
        x: this._snapLimitToGridMinimum(position.x + min.x, this._hCellSize) - position.x,
        y: this._snapLimitToGridMinimum(position.y + min.y, this._vCellSize) - position.y
      };
      restriction.max = {
        x: this._snapLimitToGridMaximum(position.x + max.x, this._hCellSize) - position.x,
        y: this._snapLimitToGridMaximum(position.y + max.y, this._vCellSize) - position.y
      };
    }
    _snapLimitToGridMinimum(value, cellSize) {
      return Math.ceil(value / cellSize) * cellSize;
    }
    _snapLimitToGridMaximum(value, cellSize) {
      return Math.floor(value / cellSize) * cellSize;
    }
    static ɵfac = function CalculateCommonNodeMoveLimitsExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalculateCommonNodeMoveLimitsExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CalculateCommonNodeMoveLimitsExecution,
      factory: CalculateCommonNodeMoveLimitsExecution.ɵfac
    });
  };
  CalculateCommonNodeMoveLimitsExecution = __decorate([FExecutionRegister(CalculateCommonNodeMoveLimitsRequest)], CalculateCommonNodeMoveLimitsExecution);
  return CalculateCommonNodeMoveLimitsExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PutInputConnectionHandlersToArrayRequest {
  fDragHandler;
  outputIds;
  result;
  constructor(fDragHandler, outputIds, result) {
    this.fDragHandler = fDragHandler;
    this.outputIds = outputIds;
    this.result = result;
  }
}
let PutInputConnectionHandlersToArrayExecution = /*#__PURE__*/(() => {
  let PutInputConnectionHandlersToArrayExecution = class PutInputConnectionHandlersToArrayExecution {
    _fComponentsStore = inject(FComponentsStore);
    _injector = inject(Injector);
    get _fConnections() {
      return this._fComponentsStore.fConnections;
    }
    handle(request) {
      this._getInputConnections(request.fDragHandler.fNode).forEach(fConnection => {
        this._createAndSetConnectionToNodeHandler(fConnection, request);
      });
    }
    _getInputConnections(fNode) {
      const ids = new Set(this._getNodeInputIds(fNode));
      return this._fConnections.filter(x => ids.has(x.fInputId));
    }
    _getNodeInputIds(fNode) {
      return this._fComponentsStore.fInputs.filter(x => fNode.isContains(x.hostElement)).map(x => x.fId);
    }
    _createAndSetConnectionToNodeHandler(fConnection, request) {
      let fHandler = this._getExistingConnectionHandler(request.result, fConnection);
      if (!fHandler) {
        fHandler = this._createConnectionHandler(request.outputIds, fConnection);
        request.result.push(fHandler);
      }
      request.fDragHandler.fTargetHandlers.push(fHandler);
    }
    _getExistingConnectionHandler(fHandlers, fConnection) {
      return fHandlers.find(x => x.fConnection.fId === fConnection.fId);
    }
    _createConnectionHandler(outputIds, fConnection) {
      let result;
      if (outputIds.includes(fConnection.fOutputId)) {
        result = new SourceTargetConnectionDragHandler(this._injector, fConnection);
      } else {
        result = new TargetConnectionDragHandler(this._injector, fConnection);
      }
      return result;
    }
    static ɵfac = function PutInputConnectionHandlersToArrayExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PutInputConnectionHandlersToArrayExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PutInputConnectionHandlersToArrayExecution,
      factory: PutInputConnectionHandlersToArrayExecution.ɵfac
    });
  };
  PutInputConnectionHandlersToArrayExecution = __decorate([FExecutionRegister(PutInputConnectionHandlersToArrayRequest)], PutInputConnectionHandlersToArrayExecution);
  return PutInputConnectionHandlersToArrayExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PutOutputConnectionHandlersToArrayRequest {
  fDragHandler;
  inputIds;
  result;
  constructor(fDragHandler, inputIds, result) {
    this.fDragHandler = fDragHandler;
    this.inputIds = inputIds;
    this.result = result;
  }
}
let PutOutputConnectionHandlersToArrayExecution = /*#__PURE__*/(() => {
  let PutOutputConnectionHandlersToArrayExecution = class PutOutputConnectionHandlersToArrayExecution {
    _fComponentsStore = inject(FComponentsStore);
    _injector = inject(Injector);
    get _fConnections() {
      return this._fComponentsStore.fConnections;
    }
    handle(request) {
      this._getOutputConnections(request.fDragHandler.fNode).forEach(fConnection => {
        this._createAndSetConnectionToNodeHandler(fConnection, request);
      });
    }
    _getOutputConnections(node) {
      const ids = new Set(this._getNodeOutputIds(node));
      return this._fConnections.filter(x => ids.has(x.fOutputId));
    }
    _getNodeOutputIds(node) {
      return this._fComponentsStore.fOutputs.filter(x => node.isContains(x.hostElement)).map(x => x.fId);
    }
    _createAndSetConnectionToNodeHandler(fConnection, request) {
      let fHandler = this._getExistingConnectionHandler(request.result, fConnection);
      if (!fHandler) {
        fHandler = this._createConnectionHandler(request.inputIds, fConnection);
        request.result.push(fHandler);
      }
      request.fDragHandler.fSourceHandlers.push(fHandler);
    }
    _getExistingConnectionHandler(fHandlers, fConnection) {
      return fHandlers.find(x => x.fConnection.fId === fConnection.fId);
    }
    _createConnectionHandler(inputIds, fConnection) {
      let result;
      if (inputIds.includes(fConnection.fInputId)) {
        result = new SourceTargetConnectionDragHandler(this._injector, fConnection);
      } else {
        result = new SourceConnectionDragHandler(this._injector, fConnection);
      }
      return result;
    }
    static ɵfac = function PutOutputConnectionHandlersToArrayExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PutOutputConnectionHandlersToArrayExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PutOutputConnectionHandlersToArrayExecution,
      factory: PutOutputConnectionHandlersToArrayExecution.ɵfac
    });
  };
  PutOutputConnectionHandlersToArrayExecution = __decorate([FExecutionRegister(PutOutputConnectionHandlersToArrayRequest)], PutOutputConnectionHandlersToArrayExecution);
  return PutOutputConnectionHandlersToArrayExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CalculateNodeMoveLimitsRequest {
  fNode;
  hasParentNodeInSelected;
  constructor(fNode, hasParentNodeInSelected) {
    this.fNode = fNode;
    this.hasParentNodeInSelected = hasParentNodeInSelected;
  }
}
let CalculateNodeMoveLimitsExecution = /*#__PURE__*/(() => {
  let CalculateNodeMoveLimitsExecution = class CalculateNodeMoveLimitsExecution {
    _fMediator = inject(FMediator);
    handle(request) {
      if (!request.fNode.fParentId || request.hasParentNodeInSelected) {
        return {
          ...DEFAULT_LIMITS
        };
      }
      return this._calculateDifference(this._fParentRect(request.fNode), this._fNodeRect(request.fNode));
    }
    _fNodeRect(fNode) {
      return this._fMediator.execute(new GetNormalizedElementRectRequest(fNode.hostElement, false));
    }
    _fParentRect(fNode) {
      return this._fMediator.execute(new GetNormalizedParentNodeRectRequest(fNode));
    }
    _calculateDifference(fParentRect, fRect) {
      return {
        min: this._calculateMinimumDifference(fParentRect, fRect),
        max: this._calculateMaximumDifference(fParentRect, fRect)
      };
    }
    _calculateMinimumDifference(fParentRect, fRect) {
      return PointExtensions.initialize(fParentRect.x - fRect.x, fParentRect.y - fRect.y);
    }
    _calculateMaximumDifference(fParentRect, fRect) {
      return PointExtensions.initialize(fParentRect.x + fParentRect.width - (fRect.x + fRect.width), fParentRect.y + fParentRect.height - (fRect.y + fRect.height));
    }
    static ɵfac = function CalculateNodeMoveLimitsExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalculateNodeMoveLimitsExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CalculateNodeMoveLimitsExecution,
      factory: CalculateNodeMoveLimitsExecution.ɵfac
    });
  };
  CalculateNodeMoveLimitsExecution = __decorate([FExecutionRegister(CalculateNodeMoveLimitsRequest)], CalculateNodeMoveLimitsExecution);
  return CalculateNodeMoveLimitsExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DEFAULT_LIMITS = {
  min: PointExtensions.initialize(-Infinity, -Infinity),
  max: PointExtensions.initialize(Infinity, Infinity)
};
class CreateMoveNodesDragModelFromSelectionRequest {
  nodeWithDisabledSelection;
  constructor(nodeWithDisabledSelection) {
    this.nodeWithDisabledSelection = nodeWithDisabledSelection;
  }
}
class FNodeMoveDragHandler {
  fNode;
  fSourceHandlers;
  fTargetHandlers;
  fEventType = 'move-node';
  _onPointerDownPosition = PointExtensions.initialize();
  constructor(fNode, fSourceHandlers = [], fTargetHandlers = []) {
    this.fNode = fNode;
    this.fSourceHandlers = fSourceHandlers;
    this.fTargetHandlers = fTargetHandlers;
    this._onPointerDownPosition = {
      ...fNode.position
    };
  }
  onPointerMove(difference) {
    this._redraw(this._calculateNewPosition(difference));
    this.fSourceHandlers.forEach(x => x.setSourceDifference(difference));
    this.fTargetHandlers.forEach(x => x.setTargetDifference(difference));
  }
  _calculateNewPosition(difference) {
    return PointExtensions.sum(this._onPointerDownPosition, difference);
  }
  _redraw(position) {
    this.fNode.updatePosition(position);
    this.fNode.redraw();
  }
  onPointerUp() {
    this.fNode.positionChange.emit(this.fNode.position);
  }
}
class PointBoundsLimiter {
  _onPointerDown;
  _limit;
  _fComponentsStore;
  _vCellSize;
  _hCellSize;
  constructor(_injector, _onPointerDown, _limit) {
    this._onPointerDown = _onPointerDown;
    this._limit = _limit;
    this._fComponentsStore = _injector.get(FComponentsStore);
    this._vCellSize = this._fComponentsStore.fDraggable.vCellSize;
    this._hCellSize = this._fComponentsStore.fDraggable.hCellSize;
  }
  limit(difference, adjustCellSize) {
    const {
      min,
      max
    } = this._limit;
    const {
      x,
      y
    } = this._cellSizeStrategies[+adjustCellSize](difference);
    return {
      x: this._clamp(x, min.x, max.x),
      y: this._clamp(y, min.y, max.y)
    };
  }
  _cellSizeStrategies = {
    0: this._skipCellSize.bind(this),
    1: this._applyCellSize.bind(this)
  };
  _applyCellSize(difference) {
    return {
      x: this._snapToGrid(this._onPointerDown.x + difference.x, this._hCellSize) - this._onPointerDown.x,
      y: this._snapToGrid(this._onPointerDown.y + difference.y, this._vCellSize) - this._onPointerDown.y
    };
  }
  _skipCellSize(difference) {
    return difference;
  }
  _clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }
  _snapToGrid(value, cellSize) {
    return Math.round(value / cellSize) * cellSize;
  }
}
class FSummaryNodeMoveDragHandler {
  limits;
  fHandlers;
  commonRect;
  fEventType = 'move-node';
  fData;
  _fComponentStore;
  _fBoundsLimiter;
  constructor(_injector, limits, fHandlers, commonRect) {
    this.limits = limits;
    this.fHandlers = fHandlers;
    this.commonRect = commonRect;
    this._fComponentStore = _injector.get(FComponentsStore);
    this._fBoundsLimiter = new PointBoundsLimiter(_injector, this.commonRect, limits);
    this.fData = {
      fNodeIds: this.fHandlers.map(x => x.fNode.fId)
    };
  }
  onPointerMove(difference) {
    const adjustCellSize = this._fComponentStore.fDraggable.fCellSizeWhileDragging;
    const differenceWithRestrictions = this._fBoundsLimiter.limit(difference, adjustCellSize);
    this.fHandlers.forEach(x => x.onPointerMove(differenceWithRestrictions));
  }
  onPointerUp() {
    this.fHandlers.forEach(x => x.onPointerUp());
  }
  calculateRestrictedDifference(difference) {
    return this._fBoundsLimiter.limit(difference, true);
  }
}
let CreateMoveNodesDragModelFromSelectionExecution = /*#__PURE__*/(() => {
  let CreateMoveNodesDragModelFromSelectionExecution = class CreateMoveNodesDragModelFromSelectionExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    _injector = inject(Injector);
    handle(request) {
      const fDraggedNodes = this._getDraggedNodes(request.nodeWithDisabledSelection);
      const fNodesToDrag = this._getNodesToDragWithCommonLimits(fDraggedNodes);
      const fDragHandlers = this._mapToNodeDragHandlers(fNodesToDrag);
      this._setConnectionsHandlersToNodes(fDragHandlers, this._getAllOutputIds(fNodesToDrag), this._getAllInputIds(fNodesToDrag));
      const commonLimits = this._calculateCommonLimits(this._getNodesMoveLimits(fNodesToDrag, [], fDraggedNodes));
      return new FSummaryNodeMoveDragHandler(this._injector, commonLimits, fDragHandlers, this._getDraggedNodesBoundingRect(fNodesToDrag));
    }
    _getDraggedNodes(nodeWithDisabledSelection) {
      const result = this._getNodesFromSelection();
      if (nodeWithDisabledSelection) {
        result.push(nodeWithDisabledSelection);
      }
      return result;
    }
    _getNodesFromSelection() {
      return this._fDraggableDataContext.selectedItems.map(x => this._findNode(x.hostElement)).filter(x => !!x);
    }
    _findNode(hostElement) {
      return this._fComponentsStore.fNodes.find(n => n.isContains(hostElement));
    }
    _getNodesToDragWithCommonLimits(fDraggedNodes) {
      return fDraggedNodes.reduce((result, x) => {
        result.push(x);
        return result.concat(this._getChildrenNodes(x.fId));
      }, []);
    }
    _getNodesMoveLimits(fNodes, fParentNodes, fDraggedNodes) {
      return fDraggedNodes.map(x => {
        const fParentNodes = this._fMediator.execute(new GetParentNodesRequest(x));
        return {
          position: x.position,
          ...this._getNodeMoveLimits(x, fParentNodes, fDraggedNodes)
        };
      });
    }
    _getNodeMoveLimits(fNode, fParentNodes, fDraggedNodes) {
      return this._fMediator.execute(new CalculateNodeMoveLimitsRequest(fNode, this._isParentNodeInArray(fParentNodes, fDraggedNodes)));
    }
    _isParentNodeInArray(fParentNodes, fDraggedNodes) {
      return this._fMediator.execute(new IsArrayHasParentNodeRequest(fParentNodes, fDraggedNodes));
    }
    _getChildrenNodes(fId) {
      return this._fMediator.execute(new GetDeepChildrenNodesAndGroupsRequest(fId));
    }
    _calculateCommonLimits(limits) {
      return this._fMediator.execute(new CalculateCommonNodeMoveLimitsRequest(limits));
    }
    _getAllOutputIds(fNodes) {
      return flatMap(fNodes, fNode => this._getNodeOutputIds(fNode));
    }
    _getNodeOutputIds(fNode) {
      return this._fComponentsStore.fOutputs.filter(x => fNode.fId === x.fNodeId).map(x => x.fId);
    }
    _getAllInputIds(fNodes) {
      return flatMap(fNodes, fNode => this._getNodeInputIds(fNode));
    }
    _getNodeInputIds(fNode) {
      return this._fComponentsStore.fInputs.filter(x => fNode.fId === x.fNodeId).map(x => x.fId);
    }
    _mapToNodeDragHandlers(items) {
      return items.map(x => new FNodeMoveDragHandler(x));
    }
    _setConnectionsHandlersToNodes(handlers, outputIds, inputIds) {
      const fConnectionHandlers = [];
      handlers.forEach(fNodeHandler => {
        this._fMediator.execute(new PutOutputConnectionHandlersToArrayRequest(fNodeHandler, inputIds, fConnectionHandlers));
        this._fMediator.execute(new PutInputConnectionHandlersToArrayRequest(fNodeHandler, outputIds, fConnectionHandlers));
      });
    }
    _getDraggedNodesBoundingRect(fNodes) {
      return RectExtensions.union(fNodes.map(x => {
        return this._fMediator.execute(new GetNormalizedElementRectRequest(x.hostElement, false));
      })) || RectExtensions.initialize();
    }
    static ɵfac = function CreateMoveNodesDragModelFromSelectionExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CreateMoveNodesDragModelFromSelectionExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CreateMoveNodesDragModelFromSelectionExecution,
      factory: CreateMoveNodesDragModelFromSelectionExecution.ɵfac
    });
  };
  CreateMoveNodesDragModelFromSelectionExecution = __decorate([FExecutionRegister(CreateMoveNodesDragModelFromSelectionRequest)], CreateMoveNodesDragModelFromSelectionExecution);
  return CreateMoveNodesDragModelFromSelectionExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CREATE_MOVE_NODE_DRAG_MODEL_FROM_SELECTION_PROVIDERS = [CalculateCommonNodeMoveLimitsExecution, CalculateNodeMoveLimitsExecution, PutInputConnectionHandlersToArrayExecution, PutOutputConnectionHandlersToArrayExecution, CreateMoveNodesDragModelFromSelectionExecution];
class LineAlignmentPreparationRequest {
  fNodes;
  commonRect;
  constructor(fNodes, commonRect) {
    this.fNodes = fNodes;
    this.commonRect = commonRect;
  }
}
class FLineAlignmentDragHandler {
  _lineService;
  _size;
  _draggedNodeRect;
  _rects;
  _restrictions;
  fEventType = 'line-alignment';
  _fComponentsStore;
  _debounceTimer = null;
  _transform;
  constructor(_injector, _lineService, _size, _draggedNodeRect, _rects, _restrictions) {
    this._lineService = _lineService;
    this._size = _size;
    this._draggedNodeRect = _draggedNodeRect;
    this._rects = _rects;
    this._restrictions = _restrictions;
    this._fComponentsStore = _injector.get(FComponentsStore);
    this._transform = this._fComponentsStore.fCanvas?.transform;
  }
  onPointerMove(difference) {
    const restrictedDifference = this._getDifference(difference);
    if (this._debounceTimer) {
      clearTimeout(this._debounceTimer);
    }
    this._debounceTimer = setTimeout(() => this._drawIntersectingLines(restrictedDifference), 15);
  }
  _drawIntersectingLines(difference) {
    const intersect = this.findNearestCoordinate(difference);
    if (intersect.xResult.value !== undefined) {
      this._lineService.drawVerticalLine(intersect.xResult.value, this._size, this._transform);
    } else {
      this._lineService.hideVerticalLine();
    }
    if (intersect.yResult.value !== undefined) {
      this._lineService.drawHorizontalLine(intersect.yResult.value, this._size, this._transform);
    } else {
      this._lineService.hideHorizontalLine();
    }
  }
  _getDifference(difference) {
    return {
      x: Math.min(Math.max(difference.x, this._restrictions.min.x), this._restrictions.max.x),
      y: Math.min(Math.max(difference.y, this._restrictions.min.y), this._restrictions.max.y)
    };
  }
  findNearestCoordinate(difference) {
    const rect = RectExtensions.addPoint(this._draggedNodeRect, difference);
    return findClosestAlignment(this._rects, rect, this._fComponentsStore.fLineAlignment.fAlignThreshold());
  }
  onPointerUp() {
    this._lineService.hideVerticalLine();
    this._lineService.hideHorizontalLine();
    if (this._debounceTimer) {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = null;
    }
  }
}
class LineElement {
  hostElement;
  element;
  constructor(fBrowser, hostElement) {
    this.hostElement = hostElement;
    this.element = fBrowser.document.createElement('div');
    this.hostElement.appendChild(this.element);
    this.element.classList.add('f-line');
  }
  hide() {
    this.element.style.display = 'none';
  }
  show() {
    this.element.style.display = 'block';
  }
  draw(object) {
    this.element.style.position = 'absolute';
    Object.keys(object).forEach(key => {
      // @ts-ignore
      this.element.style[key] = object[key] + 'px';
    });
  }
}
class LineService {
  hostElement;
  fHorizontalLine;
  fVerticalLine;
  constructor(fBrowser, hostElement) {
    this.hostElement = hostElement;
    this.fHorizontalLine = new LineElement(fBrowser, this.hostElement);
    this.fVerticalLine = new LineElement(fBrowser, this.hostElement);
    this.fHorizontalLine.hide();
    this.fVerticalLine.hide();
  }
  drawVerticalLine(x, size, transform) {
    this.fVerticalLine.show();
    this.fVerticalLine.draw({
      left: x * transform.scale + transform.position.x + transform.scaledPosition.x,
      top: 0,
      width: 1,
      height: size.height
    });
  }
  drawHorizontalLine(y, size, transform) {
    this.fHorizontalLine.show();
    this.fHorizontalLine.draw({
      left: 0,
      top: y * transform.scale + transform.position.y + transform.scaledPosition.y,
      width: size.width,
      height: 1
    });
  }
  hideVerticalLine() {
    this.fVerticalLine.hide();
  }
  hideHorizontalLine() {
    this.fHorizontalLine.hide();
  }
}
const F_LINE_ALIGNMENT = new InjectionToken('F_LINE_ALIGNMENT');
let FLineAlignmentBase = /*#__PURE__*/(() => {
  class FLineAlignmentBase {
    static ɵfac = function FLineAlignmentBase_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FLineAlignmentBase)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FLineAlignmentBase
    });
  }
  return FLineAlignmentBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FLineAlignmentComponent = /*#__PURE__*/(() => {
  class FLineAlignmentComponent extends FLineAlignmentBase {
    fAlignThreshold = input(10, {
      transform: numberAttribute
    });
    _fMediator = inject(FMediator);
    _elementReference = inject(ElementRef);
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    ngOnInit() {
      this._fMediator.execute(new AddLineAlignmentToStoreRequest(this));
    }
    ngOnDestroy() {
      this._fMediator.execute(new RemoveLineAlignmentFromStoreRequest());
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFLineAlignmentComponent_BaseFactory;
      return function FLineAlignmentComponent_Factory(__ngFactoryType__) {
        return (ɵFLineAlignmentComponent_BaseFactory || (ɵFLineAlignmentComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FLineAlignmentComponent)))(__ngFactoryType__ || FLineAlignmentComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FLineAlignmentComponent,
      selectors: [["f-line-alignment"]],
      hostAttrs: [1, "f-line-alignment", "f-component"],
      inputs: {
        fAlignThreshold: [1, "fAlignThreshold"]
      },
      exportAs: ["fComponent"],
      features: [i0.ɵɵProvidersFeature([{
        provide: F_LINE_ALIGNMENT,
        useExisting: FLineAlignmentComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function FLineAlignmentComponent_Template(rf, ctx) {},
      styles: ["[_nghost-%COMP%]{display:block;position:absolute;left:0;top:0;width:100%;height:100%;overflow:hidden;pointer-events:none;-webkit-user-select:none;user-select:none}"]
    });
  }
  return FLineAlignmentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_LINE_ALIGNMENT_PROVIDERS = [FLineAlignmentComponent];
let LineAlignmentPreparationExecution = /*#__PURE__*/(() => {
  let LineAlignmentPreparationExecution = class LineAlignmentPreparationExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    _fBrowser = inject(BrowserService);
    _injector = inject(Injector);
    _lineService;
    handle(request) {
      this._addLineAlignmentDragHandler(request.fNodes, request.commonRect);
    }
    _addLineAlignmentDragHandler(fNodes, commonRect) {
      this._fDraggableDataContext.draggableItems.push(new FLineAlignmentDragHandler(this._injector, this._lineService || this._createLineService(), this._getFlowHostSize(), commonRect, this._getStaticNodeRects(fNodes), this._getCommonRestrictions()));
    }
    _getFlowHostSize() {
      return this._fMediator.execute(new GetFlowHostElementRequest()).getBoundingClientRect();
    }
    _createLineService() {
      this._lineService = new LineService(this._fBrowser, this._fComponentsStore.fLineAlignment.hostElement);
      return this._lineService;
    }
    _getStaticNodeRects(fNodes) {
      return this._getStaticNodes(fNodes).map(x => {
        return this._fMediator.execute(new GetNormalizedElementRectRequest(x.hostElement, false));
      });
    }
    _getStaticNodes(fNodes) {
      return this._fComponentsStore.fNodes.filter(x => !fNodes.includes(x));
    }
    _getCommonRestrictions() {
      return this._fDraggableDataContext.draggableItems.filter(x => x instanceof FSummaryNodeMoveDragHandler)[0].limits;
    }
    static ɵfac = function LineAlignmentPreparationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LineAlignmentPreparationExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LineAlignmentPreparationExecution,
      factory: LineAlignmentPreparationExecution.ɵfac
    });
  };
  LineAlignmentPreparationExecution = __decorate([FExecutionRegister(LineAlignmentPreparationRequest)], LineAlignmentPreparationExecution);
  return LineAlignmentPreparationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FNodeMovePreparationRequest {
  event;
  fTrigger;
  constructor(event, fTrigger) {
    this.event = event;
    this.fTrigger = fTrigger;
  }
}
let FNodeMovePreparationExecution = /*#__PURE__*/(() => {
  let FNodeMovePreparationExecution = class FNodeMovePreparationExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    get _transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    get _fHost() {
      return this._fComponentsStore.fFlow.hostElement;
    }
    _fNode;
    handle(request) {
      if (!this._isValid(request) || !this._isValidTrigger(request)) {
        return;
      }
      const summaryDragHandler = this._calculateDraggedItems(this._fNode);
      this._fDraggableDataContext.onPointerDownScale = this._transform.scale;
      this._fDraggableDataContext.onPointerDownPosition = Point.fromPoint(request.event.getPosition()).elementTransform(this._fHost).div(this._transform.scale);
      this._fDraggableDataContext.draggableItems = [summaryDragHandler];
      if (this._fComponentsStore.fLineAlignment) {
        this._fMediator.execute(new LineAlignmentPreparationRequest(summaryDragHandler.fHandlers.map(x => x.fNode), summaryDragHandler.commonRect));
      }
    }
    _isValid(request) {
      return this._fDraggableDataContext.isEmpty() && this._isDragHandleElement(request.event.targetElement) && !!this._getNode(request.event.targetElement);
    }
    _isDragHandleElement(element) {
      return isClosestElementHasClass(element, '.f-drag-handle');
    }
    _getNode(element) {
      this._fNode = this._fComponentsStore.fNodes.find(x => x.isContains(element) && !x.fDraggingDisabled);
      return this._fNode;
    }
    _isValidTrigger(request) {
      return isValidEventTrigger(request.event.originalEvent, request.fTrigger);
    }
    //We drag nodes from selection model
    _calculateDraggedItems(fNode) {
      let result;
      if (!fNode.fSelectionDisabled) {
        // Need to select node before drag
        this._fMediator.execute(new SelectAndUpdateNodeLayerRequest(fNode));
        result = this._dragModelFromSelection();
      } else {
        // User can drag node that can't be selected
        result = this._dragModelFromSelection(fNode);
      }
      return result;
    }
    _dragModelFromSelection(nodeWithDisabledSelection) {
      return this._fMediator.execute(new CreateMoveNodesDragModelFromSelectionRequest(nodeWithDisabledSelection));
    }
    static ɵfac = function FNodeMovePreparationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FNodeMovePreparationExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FNodeMovePreparationExecution,
      factory: FNodeMovePreparationExecution.ɵfac
    });
  };
  FNodeMovePreparationExecution = __decorate([FExecutionRegister(FNodeMovePreparationRequest)], FNodeMovePreparationExecution);
  return FNodeMovePreparationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FNodeMoveFinalizeRequest {
  event;
  constructor(event) {
    this.event = event;
  }
}
let FNodeMoveFinalizeExecution = /*#__PURE__*/(() => {
  let FNodeMoveFinalizeExecution = class FNodeMoveFinalizeExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    get _fHost() {
      return this._fComponentsStore.fFlow.hostElement;
    }
    handle(request) {
      if (!this._isValid()) {
        return;
      }
      const difference = this._getDifferenceWithLineAlignment(this._getDifferenceBetweenPreparationAndFinalize(request.event.getPosition()));
      const firstNodeOrGroup = this._fDraggableDataContext.draggableItems.find(x => x instanceof FSummaryNodeMoveDragHandler);
      this._finalizeMove(firstNodeOrGroup.calculateRestrictedDifference(difference));
      this._applyConnectionUnderDroppedNode();
    }
    _isValid() {
      return this._fDraggableDataContext.draggableItems.some(x => x instanceof FSummaryNodeMoveDragHandler);
    }
    _finalizeMove(difference) {
      this._getItems().forEach(x => {
        x.onPointerMove({
          ...difference
        });
        x.onPointerUp?.();
      });
    }
    _getItems() {
      return this._fDraggableDataContext.draggableItems.filter(x => !(x instanceof FNodeDropToGroupDragHandler));
    }
    _getDifferenceBetweenPreparationAndFinalize(position) {
      return Point.fromPoint(position).elementTransform(this._fHost).div(this._fDraggableDataContext.onPointerDownScale).sub(this._fDraggableDataContext.onPointerDownPosition);
    }
    _getDifferenceWithLineAlignment(difference) {
      return this._applyLineAlignmentDifference(difference, this._getLineAlignmentDifference(difference));
    }
    _getLineAlignmentDifference(difference) {
      return this._fDraggableDataContext.draggableItems.find(x => x instanceof FLineAlignmentDragHandler)?.findNearestCoordinate(difference);
    }
    _applyLineAlignmentDifference(difference, intersection) {
      if (intersection) {
        difference.x = this._isIntersectValue(intersection.xResult) ? difference.x - intersection.xResult.distance : difference.x;
        difference.y = this._isIntersectValue(intersection.yResult) ? difference.y - intersection.yResult.distance : difference.y;
      }
      return difference;
    }
    _isIntersectValue(result) {
      return result.value !== undefined && result.value !== null;
    }
    _applyConnectionUnderDroppedNode() {
      if (this._isDraggedJustOneNode() && this._fComponentsStore.fDraggable?.fEmitOnNodeIntersect) {
        const fNode = this._getFirstNodeOrGroup();
        setTimeout(() => this._fMediator.execute(new IsConnectionUnderNodeRequest(fNode)));
      }
    }
    _isDraggedJustOneNode() {
      return this._fDraggableDataContext.draggableItems[0].fHandlers.length === 1;
    }
    _getFirstNodeOrGroup() {
      return this._fDraggableDataContext.draggableItems[0].fHandlers[0].fNode;
    }
    static ɵfac = function FNodeMoveFinalizeExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FNodeMoveFinalizeExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FNodeMoveFinalizeExecution,
      factory: FNodeMoveFinalizeExecution.ɵfac
    });
  };
  FNodeMoveFinalizeExecution = __decorate([FExecutionRegister(FNodeMoveFinalizeRequest)], FNodeMoveFinalizeExecution);
  return FNodeMoveFinalizeExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NODE_PROVIDERS = [...CREATE_MOVE_NODE_DRAG_MODEL_FROM_SELECTION_PROVIDERS, LineAlignmentPreparationExecution, FNodeMoveFinalizeExecution, FNodeMovePreparationExecution];
class FDropToGroupEvent {
  fTargetNode;
  fNodes;
  fDropPosition;
  constructor(fTargetNode, fNodes, fDropPosition) {
    this.fTargetNode = fTargetNode;
    this.fNodes = fNodes;
    this.fDropPosition = fDropPosition;
  }
}
let FNodeDropToGroupFinalizeExecution = /*#__PURE__*/(() => {
  let FNodeDropToGroupFinalizeExecution = class FNodeDropToGroupFinalizeExecution {
    _fDraggableDataContext = inject(FDraggableDataContext);
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      if (!this._isValid()) {
        return;
      }
      const item = this._getDragHandleItem();
      if (item.fNodeWithRect) {
        this._emitDroppedChildrenEvent(item.fNodeWithRect.node.fId, request.event);
      }
      item.onPointerUp?.();
    }
    _isValid() {
      return this._fDraggableDataContext.draggableItems.some(x => x instanceof FNodeDropToGroupDragHandler);
    }
    _emitDroppedChildrenEvent(fTargetId, event) {
      this._fComponentsStore.fDraggable?.fDropToGroup.emit(new FDropToGroupEvent(fTargetId, this._getDraggedNodeIds(), event.getPosition()));
    }
    _getDragHandleItem() {
      const result = this._findDragHandleItem();
      if (!result) {
        throw new Error('NodeDragToParentDragHandler not found');
      }
      return result;
    }
    _findDragHandleItem() {
      return this._fDraggableDataContext.draggableItems.find(x => x instanceof FNodeDropToGroupDragHandler);
    }
    _getDraggedNodeIds() {
      return this._fDraggableDataContext.draggableItems.find(x => x instanceof FSummaryNodeMoveDragHandler).fHandlers.map(x => x.fNode.fId);
    }
    static ɵfac = function FNodeDropToGroupFinalizeExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FNodeDropToGroupFinalizeExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FNodeDropToGroupFinalizeExecution,
      factory: FNodeDropToGroupFinalizeExecution.ɵfac
    });
  };
  FNodeDropToGroupFinalizeExecution = __decorate([FExecutionRegister(FNodeDropToGroupFinalizeRequest)], FNodeDropToGroupFinalizeExecution);
  return FNodeDropToGroupFinalizeExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FNodeDropToGroupPreparationRequest {
  event;
  constructor(event) {
    this.event = event;
  }
}
let FNodeDropToGroupPreparationExecution = /*#__PURE__*/(() => {
  let FNodeDropToGroupPreparationExecution = class FNodeDropToGroupPreparationExecution {
    _fMediator = inject(FMediator);
    _fDraggableDataContext = inject(FDraggableDataContext);
    _fComponentsStore = inject(FComponentsStore);
    _injector = inject(Injector);
    get _fNodes() {
      return this._fComponentsStore.fNodes;
    }
    get _transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    get _fCanvasPosition() {
      return PointExtensions.sum(this._transform.position, this._transform.scaledPosition);
    }
    handle(request) {
      if (!this._isValid()) {
        return;
      }
      const fNode = this._fComponentsStore.fNodes.find(n => n.isContains(request.event.targetElement));
      if (!fNode) {
        throw new Error('Node not found');
      }
      this._fDraggableDataContext.draggableItems.push(new FNodeDropToGroupDragHandler(this._injector, this._getNotDraggedNodesRects()));
    }
    _isValid() {
      return this._fDraggableDataContext.draggableItems.some(x => x instanceof FSummaryNodeMoveDragHandler);
    }
    _getNotDraggedNodesRects() {
      const draggedNodes = this._addParentNodes(this._getNodesBeingDragged());
      return this._getNotDraggedNodes(draggedNodes).map(x => {
        const rect = this._fMediator.execute(new GetNormalizedElementRectRequest(x.hostElement, false));
        return {
          node: x,
          rect: RectExtensions.initialize(rect.x + this._fCanvasPosition.x, rect.y + this._fCanvasPosition.y, rect.width * this._transform.scale, rect.height * this._transform.scale)
        };
      });
    }
    _getNodesBeingDragged() {
      return this._fDraggableDataContext.draggableItems.find(x => x instanceof FSummaryNodeMoveDragHandler).fHandlers.map(x => x.fNode);
    }
    _addParentNodes(fNodes) {
      return fNodes.reduce((result, x) => {
        result.push(x, ...this._fMediator.execute(new GetParentNodesRequest(x)));
        return result;
      }, []);
    }
    _getNotDraggedNodes(draggedNodes) {
      return this._fNodes.filter(x => !draggedNodes.includes(x));
    }
    static ɵfac = function FNodeDropToGroupPreparationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FNodeDropToGroupPreparationExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FNodeDropToGroupPreparationExecution,
      factory: FNodeDropToGroupPreparationExecution.ɵfac
    });
  };
  FNodeDropToGroupPreparationExecution = __decorate([FExecutionRegister(FNodeDropToGroupPreparationRequest)], FNodeDropToGroupPreparationExecution);
  return FNodeDropToGroupPreparationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NODE_DROP_TO_GROUP_PROVIDERS = [FNodeDropToGroupPreparationExecution, FNodeDropToGroupFinalizeExecution];
class ApplyChildResizeRestrictionsRequest {
  rect;
  restrictions;
  constructor(rect, restrictions) {
    this.rect = rect;
    this.restrictions = restrictions;
  }
}
const CHILD_RESIZE_OFFSET = 0;
let ApplyChildResizeRestrictionsExecution = /*#__PURE__*/(() => {
  let ApplyChildResizeRestrictionsExecution = class ApplyChildResizeRestrictionsExecution {
    handle(request) {
      this._apply(request.rect, request.restrictions.childrenBounds);
    }
    _apply(rect, restrictionsRect) {
      this._restrictLeft(rect, restrictionsRect);
      this._restrictTop(rect, restrictionsRect);
      this._restrictRight(rect, restrictionsRect);
      this._restrictBottom(rect, restrictionsRect);
    }
    _restrictLeft(rect, restrictions) {
      const delta = rect.x - (restrictions.x - CHILD_RESIZE_OFFSET);
      if (delta > 0) {
        rect.x -= delta;
        rect.width += delta;
      }
    }
    _restrictTop(rect, restrictions) {
      const delta = rect.y - (restrictions.y - CHILD_RESIZE_OFFSET);
      if (delta > 0) {
        rect.y -= delta;
        rect.height += delta;
      }
    }
    _restrictRight(rect, restrictions) {
      const maxRight = restrictions.x + restrictions.width + CHILD_RESIZE_OFFSET;
      if (rect.x + rect.width <= maxRight) {
        rect.width = maxRight - rect.x;
      }
    }
    _restrictBottom(rect, restrictions) {
      const maxBottom = restrictions.y + restrictions.height + CHILD_RESIZE_OFFSET;
      if (rect.y + rect.height <= maxBottom) {
        rect.height = maxBottom - rect.y;
      }
    }
    static ɵfac = function ApplyChildResizeRestrictionsExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ApplyChildResizeRestrictionsExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ApplyChildResizeRestrictionsExecution,
      factory: ApplyChildResizeRestrictionsExecution.ɵfac
    });
  };
  ApplyChildResizeRestrictionsExecution = __decorate([FExecutionRegister(ApplyChildResizeRestrictionsRequest)], ApplyChildResizeRestrictionsExecution);
  return ApplyChildResizeRestrictionsExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ApplyParentResizeRestrictionsRequest {
  rect;
  restrictionsRect;
  constructor(rect, restrictionsRect) {
    this.rect = rect;
    this.restrictionsRect = restrictionsRect;
  }
}
const OFFSET = 0;
let ApplyParentResizeRestrictionsExecution = /*#__PURE__*/(() => {
  let ApplyParentResizeRestrictionsExecution = class ApplyParentResizeRestrictionsExecution {
    handle(request) {
      this.applyRestrictions(request.rect, request.restrictionsRect);
    }
    applyRestrictions(rect, restrictionsRect) {
      this.left(rect, restrictionsRect);
      this.top(rect, restrictionsRect);
      this.right(rect, restrictionsRect);
      this.bottom(rect, restrictionsRect);
    }
    left(rect, restrictionsRect) {
      if (rect.x <= restrictionsRect.x + OFFSET) {
        rect.width -= restrictionsRect.x - rect.x + OFFSET;
        rect.x = restrictionsRect.x + OFFSET;
      }
    }
    top(rect, restrictionsRect) {
      if (rect.y <= restrictionsRect.y + OFFSET) {
        rect.height -= restrictionsRect.y - rect.y + OFFSET;
        rect.y = restrictionsRect.y + OFFSET;
      }
    }
    right(rect, restrictionsRect) {
      if (rect.x + rect.width > restrictionsRect.x + restrictionsRect.width - OFFSET) {
        rect.width = restrictionsRect.x + restrictionsRect.width - rect.x - OFFSET;
      }
    }
    bottom(rect, restrictionsRect) {
      if (rect.y + rect.height > restrictionsRect.y + restrictionsRect.height - OFFSET) {
        rect.height = restrictionsRect.y + restrictionsRect.height - rect.y - OFFSET;
      }
    }
    static ɵfac = function ApplyParentResizeRestrictionsExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ApplyParentResizeRestrictionsExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ApplyParentResizeRestrictionsExecution,
      factory: ApplyParentResizeRestrictionsExecution.ɵfac
    });
  };
  ApplyParentResizeRestrictionsExecution = __decorate([FExecutionRegister(ApplyParentResizeRestrictionsRequest)], ApplyParentResizeRestrictionsExecution);
  return ApplyParentResizeRestrictionsExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CalculateChangedPositionRequest {
  originalRect;
  changedRect;
  difference;
  fResizeHandleType;
  constructor(originalRect, changedRect, difference, fResizeHandleType) {
    this.originalRect = originalRect;
    this.changedRect = changedRect;
    this.difference = difference;
    this.fResizeHandleType = fResizeHandleType;
  }
}
const RESIZE_DIRECTIONS = {
  [EFResizeHandleType.LEFT]: {
    x: -1,
    y: 0
  },
  [EFResizeHandleType.LEFT_TOP]: {
    x: -1,
    y: -1
  },
  [EFResizeHandleType.TOP]: {
    x: 0,
    y: -1
  },
  [EFResizeHandleType.RIGHT_TOP]: {
    x: 1,
    y: -1
  },
  [EFResizeHandleType.RIGHT]: {
    x: 1,
    y: 0
  },
  [EFResizeHandleType.RIGHT_BOTTOM]: {
    x: 1,
    y: 1
  },
  [EFResizeHandleType.BOTTOM]: {
    x: 0,
    y: 1
  },
  [EFResizeHandleType.LEFT_BOTTOM]: {
    x: -1,
    y: 1
  }
};
let CalculateChangedPositionExecution = /*#__PURE__*/(() => {
  let CalculateChangedPositionExecution = class CalculateChangedPositionExecution {
    handle(request) {
      return this.change(request.originalRect, request.difference, RESIZE_DIRECTIONS[request.fResizeHandleType], request.changedRect);
    }
    change(originalRect, difference, direction, changedRect) {
      return RectExtensions.initialize(originalRect.x + (direction.x === -1 ? difference.x : 0) + changedRect.x, originalRect.y + (direction.y === -1 ? difference.y : 0) + changedRect.y, changedRect.width, changedRect.height);
    }
    static ɵfac = function CalculateChangedPositionExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalculateChangedPositionExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CalculateChangedPositionExecution,
      factory: CalculateChangedPositionExecution.ɵfac
    });
  };
  CalculateChangedPositionExecution = __decorate([FExecutionRegister(CalculateChangedPositionRequest)], CalculateChangedPositionExecution);
  return CalculateChangedPositionExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CalculateChangedSizeRequest {
  originalRect;
  difference;
  fResizeHandleType;
  constructor(originalRect, difference, fResizeHandleType) {
    this.originalRect = originalRect;
    this.difference = difference;
    this.fResizeHandleType = fResizeHandleType;
  }
}
let CalculateChangedSizeExecution = /*#__PURE__*/(() => {
  let CalculateChangedSizeExecution = class CalculateChangedSizeExecution {
    handle(request) {
      return this.change(request.originalRect, request.difference, RESIZE_DIRECTIONS[request.fResizeHandleType]);
    }
    change(rect, difference, direction) {
      const result = RectExtensions.initialize(0, 0, rect.width + direction.x * difference.x, rect.height + direction.y * difference.y);
      if (result.width < 0) {
        result.x = result.width;
        result.width = Math.abs(result.width);
      }
      if (result.height < 0) {
        result.y = result.height;
        result.height = Math.abs(result.height);
      }
      return RectExtensions.copy(result);
    }
    static ɵfac = function CalculateChangedSizeExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalculateChangedSizeExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CalculateChangedSizeExecution,
      factory: CalculateChangedSizeExecution.ɵfac
    });
  };
  CalculateChangedSizeExecution = __decorate([FExecutionRegister(CalculateChangedSizeRequest)], CalculateChangedSizeExecution);
  return CalculateChangedSizeExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetNormalizedChildrenNodesRectRequest {
  fNode;
  paddings;
  constructor(fNode, paddings) {
    this.fNode = fNode;
    this.paddings = paddings;
  }
}
let GetNormalizedChildrenNodesRectExecution = /*#__PURE__*/(() => {
  let GetNormalizedChildrenNodesRectExecution = class GetNormalizedChildrenNodesRectExecution {
    fMediator;
    constructor(fMediator) {
      this.fMediator = fMediator;
    }
    handle(request) {
      const childNodeRect = RectExtensions.union(this.getChildrenNodes(request.fNode.fId).map(x => this.normalizeRect(x)));
      return childNodeRect ? this.concatRectWithParentPadding(childNodeRect, request.paddings) : null;
    }
    getChildrenNodes(fId) {
      return this.fMediator.execute(new GetDeepChildrenNodesAndGroupsRequest(fId));
    }
    normalizeRect(fNode) {
      return this.fMediator.execute(new GetNormalizedElementRectRequest(fNode.hostElement, false));
    }
    concatRectWithParentPadding(rect, padding) {
      return RectExtensions.initialize(rect.x - padding[0], rect.y - padding[1], rect.width + padding[0] + padding[2], rect.height + +padding[1] + padding[3]);
    }
    static ɵfac = function GetNormalizedChildrenNodesRectExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetNormalizedChildrenNodesRectExecution)(i0.ɵɵinject(i2$1.FMediator));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetNormalizedChildrenNodesRectExecution,
      factory: GetNormalizedChildrenNodesRectExecution.ɵfac
    });
  };
  GetNormalizedChildrenNodesRectExecution = __decorate([FExecutionRegister(GetNormalizedChildrenNodesRectRequest)], GetNormalizedChildrenNodesRectExecution);
  return GetNormalizedChildrenNodesRectExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetNodeResizeRestrictionsRequest {
  fNode;
  rect;
  constructor(fNode, rect) {
    this.fNode = fNode;
    this.rect = rect;
  }
}
let GetNodeResizeRestrictionsExecution = /*#__PURE__*/(() => {
  let GetNodeResizeRestrictionsExecution = class GetNodeResizeRestrictionsExecution {
    _fMediator = inject(FMediator);
    handle(request) {
      const paddings = this._calculateNodePaddings(request.fNode, request.rect);
      return {
        parentBounds: this._getNormalizedParentBounds(request.fNode),
        childrenBounds: this._getNormalizedChildrenBounds(request.fNode, paddings),
        minimumSize: SizeExtensions.initialize(paddings[0] + paddings[2], paddings[1] + paddings[3])
      };
    }
    _calculateNodePaddings(node, rect) {
      return this._fMediator.execute(new GetNodePaddingRequest(node, rect));
    }
    _getNormalizedParentBounds(fNode) {
      return this._fMediator.execute(new GetNormalizedParentNodeRectRequest(fNode));
    }
    _getNormalizedChildrenBounds(fNode, fNodePaddings) {
      return this._fMediator.execute(new GetNormalizedChildrenNodesRectRequest(fNode, fNodePaddings));
    }
    static ɵfac = function GetNodeResizeRestrictionsExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetNodeResizeRestrictionsExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetNodeResizeRestrictionsExecution,
      factory: GetNodeResizeRestrictionsExecution.ɵfac
    });
  };
  GetNodeResizeRestrictionsExecution = __decorate([FExecutionRegister(GetNodeResizeRestrictionsRequest)], GetNodeResizeRestrictionsExecution);
  return GetNodeResizeRestrictionsExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FNodeResizeFinalizeRequest {
  event;
  constructor(event) {
    this.event = event;
  }
}
class FNodeResizeDragHandler {
  _fNode;
  _fResizeHandleType;
  fEventType = 'node-resize';
  fData;
  _fMediator;
  _originalRect;
  _resizeRestrictions;
  constructor(_injector, _fNode, _fResizeHandleType) {
    this._fNode = _fNode;
    this._fResizeHandleType = _fResizeHandleType;
    this.fData = {
      fNodeId: _fNode.fId
    };
    this._fMediator = _injector.get(FMediator);
  }
  prepareDragSequence() {
    this._originalRect = this._getOriginalNodeRect();
    this._resizeRestrictions = this._getNodeResizeRestrictions();
  }
  _getOriginalNodeRect() {
    return this._fMediator.execute(new GetNormalizedElementRectRequest(this._fNode.hostElement, false));
  }
  _getNodeResizeRestrictions() {
    return this._fMediator.execute(new GetNodeResizeRestrictionsRequest(this._fNode, this._originalRect));
  }
  onPointerMove(difference) {
    this._applyResizeChanges(this._calculateChangedRect(difference));
  }
  _calculateChangedRect(difference) {
    const changedSize = this._calculateSize(difference);
    return this._calculatePosition(difference, changedSize);
  }
  _calculateSize(difference) {
    return this._fMediator.execute(new CalculateChangedSizeRequest(this._originalRect, difference, this._fResizeHandleType));
  }
  _calculatePosition(difference, changedSize) {
    return this._fMediator.execute(new CalculateChangedPositionRequest(this._originalRect, changedSize, difference, this._fResizeHandleType));
  }
  _applyResizeChanges(changedRect) {
    if (this._resizeRestrictions.childrenBounds) {
      this._applyChildRestrictions(changedRect);
    }
    this._applyParentRestrictions(changedRect, this._resizeRestrictions.parentBounds);
    this._updateNodeRendering(changedRect);
  }
  _updateNodeRendering(changedRect) {
    this._fNode.updatePosition(changedRect);
    this._fNode.updateSize(changedRect);
    this._fNode.redraw();
  }
  _applyChildRestrictions(changedRect) {
    this._fMediator.execute(new ApplyChildResizeRestrictionsRequest(changedRect, this._resizeRestrictions));
  }
  _applyParentRestrictions(changedRect, restrictions) {
    this._fMediator.execute(new ApplyParentResizeRestrictionsRequest(changedRect, restrictions));
  }
  onPointerUp() {
    this._fNode.sizeChange.emit(this._getNewRect());
  }
  _getNewRect() {
    return RectExtensions.initialize(this._fNode.position.x, this._fNode.position.y, this._fNode.size?.width, this._fNode.size?.height);
  }
}
let FNodeResizeFinalizeExecution = /*#__PURE__*/(() => {
  let FNodeResizeFinalizeExecution = class FNodeResizeFinalizeExecution {
    _fDraggableDataContext = inject(FDraggableDataContext);
    handle(request) {
      if (!this._isValid()) {
        return;
      }
      this._fDraggableDataContext.draggableItems.forEach(x => {
        x.onPointerUp?.();
      });
    }
    _isValid() {
      return this._fDraggableDataContext.draggableItems.some(x => x instanceof FNodeResizeDragHandler);
    }
    static ɵfac = function FNodeResizeFinalizeExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FNodeResizeFinalizeExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FNodeResizeFinalizeExecution,
      factory: FNodeResizeFinalizeExecution.ɵfac
    });
  };
  FNodeResizeFinalizeExecution = __decorate([FExecutionRegister(FNodeResizeFinalizeRequest)], FNodeResizeFinalizeExecution);
  return FNodeResizeFinalizeExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FNodeResizePreparationRequest {
  event;
  fTrigger;
  constructor(event, fTrigger) {
    this.event = event;
    this.fTrigger = fTrigger;
  }
}
let FNodeResizePreparationExecution = /*#__PURE__*/(() => {
  let FNodeResizePreparationExecution = class FNodeResizePreparationExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    _injector = inject(Injector);
    get _transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    get _fHost() {
      return this._fComponentsStore.fFlow.hostElement;
    }
    _fNode;
    handle(request) {
      if (!this._isValid(request) || !this._isValidTrigger(request)) {
        return;
      }
      this._selectAndUpdateNodeLayer();
      this._fDraggableDataContext.onPointerDownScale = this._transform.scale;
      this._fDraggableDataContext.onPointerDownPosition = Point.fromPoint(request.event.getPosition()).elementTransform(this._fHost).div(this._transform.scale);
      const resizeHandleType = EFResizeHandleType[this._getHandleType(request.event.targetElement)];
      this._fDraggableDataContext.draggableItems = [new FNodeResizeDragHandler(this._injector, this._fNode, resizeHandleType)];
    }
    _isValid(request) {
      return this._fDraggableDataContext.isEmpty() && this._isDragHandleElement(request.event.targetElement) && this._isNodeCanBeDragged(this._getNode(request.event.targetElement));
    }
    _isDragHandleElement(element) {
      return isClosestElementHasClass(element, '.f-resize-handle');
    }
    _isNodeCanBeDragged(fNode) {
      return !!fNode && !fNode.fDraggingDisabled;
    }
    _getNode(element) {
      this._fNode = this._fComponentsStore.fNodes.find(x => x.isContains(element));
      return this._fNode;
    }
    _isValidTrigger(request) {
      return isValidEventTrigger(request.event.originalEvent, request.fTrigger);
    }
    _selectAndUpdateNodeLayer() {
      this._fMediator.execute(new SelectAndUpdateNodeLayerRequest(this._fNode));
    }
    _getHandleType(element) {
      return getDataAttrValueFromClosestElementWithClass(element, 'fResizeHandleType', '.f-resize-handle');
    }
    static ɵfac = function FNodeResizePreparationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FNodeResizePreparationExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FNodeResizePreparationExecution,
      factory: FNodeResizePreparationExecution.ɵfac
    });
  };
  FNodeResizePreparationExecution = __decorate([FExecutionRegister(FNodeResizePreparationRequest)], FNodeResizePreparationExecution);
  return FNodeResizePreparationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NODE_RESIZE_PROVIDERS = [ApplyChildResizeRestrictionsExecution, ApplyParentResizeRestrictionsExecution, CalculateChangedPositionExecution, CalculateChangedSizeExecution, GetNormalizedChildrenNodesRectExecution, GetNodeResizeRestrictionsExecution, FNodeResizeFinalizeExecution, FNodeResizePreparationExecution];
class FNodeRotateFinalizeRequest {
  event;
  constructor(event) {
    this.event = event;
  }
}
function calculateDifferenceAfterRotation(position, rotation, pivot) {
  const {
    x: newX,
    y: newY
  } = calculatePositionAfterRotation(position, rotation, pivot);
  const dx = newX - position.x;
  const dy = newY - position.y;
  return {
    x: dx,
    y: dy
  };
}
function calculatePositionAfterRotation(position, rotation, pivot) {
  const translatedX = position.x - pivot.x;
  const translatedY = position.y - pivot.y;
  const theta = rotation * Math.PI / 180;
  const cosTheta = Math.cos(theta);
  const sinTheta = Math.sin(theta);
  const rotatedX = translatedX * cosTheta - translatedY * sinTheta;
  const rotatedY = translatedX * sinTheta + translatedY * cosTheta;
  const newX = rotatedX + pivot.x;
  const newY = rotatedY + pivot.y;
  return {
    x: newX,
    y: newY
  };
}
class FNodeRotateDragHandler {
  _fNode;
  _fSourceHandlers;
  _fTargetHandlers;
  _fComponentsStore;
  _fMediator;
  _fDraggableDataContext;
  fEventType = 'node-rotate';
  fData;
  _initialRotationToX = 0;
  _startRotation = 0;
  _onDownPoint;
  _fNodeRect;
  get _transform() {
    return this._fComponentsStore.fCanvas.transform;
  }
  constructor(_injector, _fNode, _fSourceHandlers, _fTargetHandlers) {
    this._fNode = _fNode;
    this._fSourceHandlers = _fSourceHandlers;
    this._fTargetHandlers = _fTargetHandlers;
    this._startRotation = this._fNode.rotate;
    this.fData = {
      fNodeId: _fNode.fId
    };
    this._fComponentsStore = _injector.get(FComponentsStore);
    this._fMediator = _injector.get(FMediator);
    this._fDraggableDataContext = _injector.get(FDraggableDataContext);
  }
  prepareDragSequence() {
    this._fNodeRect = this._getOriginalNodeRect();
    this._onDownPoint = this._calculateDownPoint();
    this._initialRotationToX = this._calculateAngleBetweenVectors(this._onDownPoint) - this._startRotation;
  }
  _getOriginalNodeRect() {
    return this._fMediator.execute(new GetNormalizedElementRectRequest(this._fNode.hostElement, false));
  }
  _calculateDownPoint() {
    return PointExtensions.sub(this._fDraggableDataContext.onPointerDownPosition, PointExtensions.sum(this._transform.position, this._transform.scaledPosition));
  }
  _calculateAngleBetweenVectors(position) {
    return Math.atan2(position.y - this._fNodeRect.gravityCenter.y, position.x - this._fNodeRect.gravityCenter.x) * (180 / Math.PI);
  }
  onPointerMove(difference) {
    const position = PointExtensions.sum(this._onDownPoint, difference);
    const rotation = this._calculateAngleBetweenVectors(position) - this._initialRotationToX;
    this._updateNodeRendering(rotation);
    this._fSourceHandlers.forEach(x => {
      x.connection.setSourceDifference(this._calculateDifferenceAfterRotation(x.connector, rotation));
    });
    this._fTargetHandlers.forEach(x => {
      x.connection.setTargetDifference(this._calculateDifferenceAfterRotation(x.connector, rotation));
    });
  }
  _updateNodeRendering(rotation) {
    this._fNode.updateRotate(rotation);
    this._fNode.redraw();
  }
  _calculateDifferenceAfterRotation(position, rotation) {
    return calculateDifferenceAfterRotation(position, rotation - this._startRotation, this._fNodeRect.gravityCenter);
  }
  onPointerUp() {
    this._fNode.rotateChange.emit(this._fNode.rotate);
  }
}
let FNodeRotateFinalizeExecution = /*#__PURE__*/(() => {
  let FNodeRotateFinalizeExecution = class FNodeRotateFinalizeExecution {
    _fDraggableDataContext = inject(FDraggableDataContext);
    handle(request) {
      if (!this._isValid()) {
        return;
      }
      this._fDraggableDataContext.draggableItems.forEach(x => {
        x.onPointerUp?.();
      });
    }
    _isValid() {
      return this._fDraggableDataContext.draggableItems.some(x => x instanceof FNodeRotateDragHandler);
    }
    static ɵfac = function FNodeRotateFinalizeExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FNodeRotateFinalizeExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FNodeRotateFinalizeExecution,
      factory: FNodeRotateFinalizeExecution.ɵfac
    });
  };
  FNodeRotateFinalizeExecution = __decorate([FExecutionRegister(FNodeRotateFinalizeRequest)], FNodeRotateFinalizeExecution);
  return FNodeRotateFinalizeExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FNodeRotatePreparationRequest {
  event;
  fTrigger;
  constructor(event, fTrigger) {
    this.event = event;
    this.fTrigger = fTrigger;
  }
}
let FNodeRotatePreparationExecution = /*#__PURE__*/(() => {
  let FNodeRotatePreparationExecution = class FNodeRotatePreparationExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    _injector = inject(Injector);
    get _transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    get _fHost() {
      return this._fComponentsStore.fFlow.hostElement;
    }
    _fNode;
    handle(request) {
      if (!this._isValid(request) || !this._isValidTrigger(request)) {
        return;
      }
      this._selectAndUpdateNodeLayer();
      this._fDraggableDataContext.onPointerDownScale = this._transform.scale;
      this._fDraggableDataContext.onPointerDownPosition = Point.fromPoint(request.event.getPosition()).elementTransform(this._fHost).div(this._transform.scale);
      this._fDraggableDataContext.draggableItems = [new FNodeRotateDragHandler(this._injector, this._fNode, this._calculateOutputConnectionsDragHandlers(), this._calculateInputConnectionsDragHandlers())];
    }
    _isValid(request) {
      return this._fDraggableDataContext.isEmpty() && isRotateHandle(request.event.targetElement) && this._isNodeCanBeDragged(this._getNode(request.event.targetElement));
    }
    _isNodeCanBeDragged(fNode) {
      return !!fNode && !fNode.fDraggingDisabled;
    }
    _getNode(element) {
      this._fNode = this._fComponentsStore.fNodes.find(x => x.isContains(element));
      return this._fNode;
    }
    _isValidTrigger(request) {
      return isValidEventTrigger(request.event.originalEvent, request.fTrigger);
    }
    _selectAndUpdateNodeLayer() {
      this._fMediator.execute(new SelectAndUpdateNodeLayerRequest(this._fNode));
    }
    _calculateInputConnectionsDragHandlers() {
      return this._fMediator.execute(new CalculateInputConnectionsRequest(this._fNode)).map(x => {
        const connector = this._fComponentsStore.fInputs.find(y => y.fId === x.fInputId).hostElement;
        return {
          connection: new TargetConnectionDragHandler(this._injector, x),
          connector: this._fMediator.execute(new GetNormalizedElementRectRequest(connector, false)).gravityCenter
        };
      });
    }
    _calculateOutputConnectionsDragHandlers() {
      return this._fMediator.execute(new CalculateOutputConnectionsRequest(this._fNode)).map(x => {
        const connector = this._fComponentsStore.fOutputs.find(y => y.fId === x.fOutputId).hostElement;
        return {
          connection: new SourceConnectionDragHandler(this._injector, x),
          connector: this._fMediator.execute(new GetNormalizedElementRectRequest(connector, false)).gravityCenter
        };
      });
    }
    _getOriginalNodeRect() {
      return this._fMediator.execute(new GetNormalizedElementRectRequest(this._fNode.hostElement, false));
    }
    static ɵfac = function FNodeRotatePreparationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FNodeRotatePreparationExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FNodeRotatePreparationExecution,
      factory: FNodeRotatePreparationExecution.ɵfac
    });
  };
  FNodeRotatePreparationExecution = __decorate([FExecutionRegister(FNodeRotatePreparationRequest)], FNodeRotatePreparationExecution);
  return FNodeRotatePreparationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NODE_ROTATE_PROVIDERS = [FNodeRotateFinalizeExecution, FNodeRotatePreparationExecution];
class FSingleSelectRequest {
  event;
  fMultiSelectTrigger;
  constructor(event, fMultiSelectTrigger) {
    this.event = event;
    this.fMultiSelectTrigger = fMultiSelectTrigger;
  }
}

/**
 * Implements the functionality for selecting elements in a graphical interface.
 * This class handles both single and multi-selection, updating the selection state
 * of elements and managing related data.
 *
 * Logic flow:
 * 1. **Validate the selection event**:
 *    - The event is considered valid if it occurs within the flow boundaries
 *      and there are no active draggable data operations.
 *
 * 2. **Determine the target element to select**:
 *    - The target element is determined based on the event’s target.
 *      It can be a node, a group of nodes, or a connection.
 *    - If no element is found, the current selection state is cleared.
 *
 * 3. **Update element layers**:
 *    - If an element is found, its visual layer and the layers of its child elements are updated.
 *
 * 4. **Single or multi-selection**:
 *    - If the event meets the criteria for multi-selection (e.g., a modifier key is pressed),
 *      multi-selection logic is applied.
 *    - Otherwise, single-selection logic is used.
 *
 * 5. **Single-selection logic**:
 *    - If the element is not selected and can be selected:
 *      - Clear the selection of all other elements.
 *      - Mark the current element as selected.
 *    - If the element cannot be selected, the current selection is cleared.
 *
 * 6. **Multi-selection logic**:
 *    - If the element is already selected, it is removed from the selection.
 *    - If the element is not selected and can be selected, it is added to the selection.
 *
 * 7. **Manage selection state**:
 *    - Adding or removing an element from the selection triggers the corresponding methods.
 *    - Selection state is tracked in the shared context for future use.
 */
let FSingleSelectExecution = /*#__PURE__*/(() => {
  let FSingleSelectExecution = class FSingleSelectExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    handle(request) {
      if (!this._isValid(request)) {
        return;
      }
      const fItem = this._getItemToSelect(request.event);
      setTimeout(() => this._updateItemAndChildrenLayers(fItem));
      this._isMultiSelect(request) ? this._multiSelect(fItem) : this._singleSelect(fItem);
    }
    _isValid(request) {
      return this._isEventInFlowBounds(request.event) && this._fDraggableDataContext.isEmpty();
    }
    _isEventInFlowBounds(event) {
      return this._fComponentsStore.fFlow.hostElement.contains(event.targetElement);
    }
    _getItemToSelect(event) {
      return this._getNodeOrGroup(event.targetElement) || this._getConnection(event.targetElement);
    }
    _getNodeOrGroup(targetElement) {
      return this._fComponentsStore.fNodes.find(x => x.isContains(targetElement));
    }
    _getConnection(element) {
      return this._fComponentsStore.fConnections.find(c => c.isContains(element) || c.fConnectionCenter?.nativeElement?.contains(element));
    }
    _updateItemAndChildrenLayers(fItem) {
      if (fItem) {
        this._fMediator.execute(new UpdateItemAndChildrenLayersRequest(fItem, fItem.hostElement.parentElement));
      }
    }
    _isMultiSelect(request) {
      return isValidEventTrigger(request.event.originalEvent, request.fMultiSelectTrigger);
    }
    _singleSelect(fItem) {
      if (fItem) {
        if (this._isItemNotSelectedAndSelectable(fItem)) {
          this._clearSelection();
          this._selectItem(fItem);
        } else if (fItem.fSelectionDisabled) {
          this._clearSelection();
        }
      } else {
        this._clearSelection();
      }
    }
    _isItemNotSelectedAndSelectable(item) {
      return !item.isSelected() && !item.fSelectionDisabled;
    }
    _clearSelection() {
      this._fDraggableDataContext.selectedItems.forEach(x => {
        x.unmarkAsSelected();
        this._fDraggableDataContext.markSelectionAsChanged();
      });
      this._fDraggableDataContext.selectedItems = [];
    }
    _multiSelect(fItem) {
      if (fItem && !fItem.fSelectionDisabled) {
        fItem.isSelected() ? this._deselectItem(fItem) : this._selectItem(fItem);
      }
    }
    _deselectItem(fItem) {
      this._removeItemFromSelectedItems(fItem);
      fItem.unmarkAsSelected();
      this._fDraggableDataContext.markSelectionAsChanged();
    }
    _removeItemFromSelectedItems(fItem) {
      const indexInSelection = this._fDraggableDataContext.selectedItems.indexOf(fItem);
      if (indexInSelection > -1) {
        this._fDraggableDataContext.selectedItems.splice(indexInSelection, 1);
      }
    }
    _selectItem(fItem) {
      this._fDraggableDataContext.selectedItems.push(fItem);
      fItem.markAsSelected();
      this._fDraggableDataContext.markSelectionAsChanged();
    }
    static ɵfac = function FSingleSelectExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FSingleSelectExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FSingleSelectExecution,
      factory: FSingleSelectExecution.ɵfac
    });
  };
  FSingleSelectExecution = __decorate([FExecutionRegister(FSingleSelectRequest)], FSingleSelectExecution);
  return FSingleSelectExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SINGLE_SELECT_PROVIDERS = [FSingleSelectExecution];
let FDraggableBase = /*#__PURE__*/(() => {
  class FDraggableBase extends DragAndDropBase {
    constructor(ngZone) {
      super(ngZone);
    }
    static ɵfac = function FDraggableBase_Factory(__ngFactoryType__) {
      i0.ɵɵinvalidFactory();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FDraggableBase,
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return FDraggableBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FExternalItemCreatePlaceholderRequest {
  fExternalItem;
  constructor(fExternalItem) {
    this.fExternalItem = fExternalItem;
  }
}
let FExternalItemCreatePlaceholderExecution = /*#__PURE__*/(() => {
  let FExternalItemCreatePlaceholderExecution = class FExternalItemCreatePlaceholderExecution {
    _fBrowser = inject(BrowserService);
    _containerRef = inject(ViewContainerRef);
    handle(request) {
      const {
        hostElement,
        fPlaceholder
      } = request.fExternalItem;
      const result = fPlaceholder ? this._fromTemplate(fPlaceholder) : this._fromHost(hostElement);
      result.classList.add('f-external-item-placeholder');
      result.style.pointerEvents = 'none';
      return result;
    }
    _fromTemplate(template) {
      return getOrCreateRootNodeForViewRef(this._createViewRef(template), this._fBrowser.document);
    }
    _fromHost(element) {
      return deepCloneNode(element);
    }
    _createViewRef(template) {
      const result = this._containerRef.createEmbeddedView(template);
      result.detectChanges();
      return result;
    }
    static ɵfac = function FExternalItemCreatePlaceholderExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FExternalItemCreatePlaceholderExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FExternalItemCreatePlaceholderExecution,
      factory: FExternalItemCreatePlaceholderExecution.ɵfac
    });
  };
  FExternalItemCreatePlaceholderExecution = __decorate([FExecutionRegister(FExternalItemCreatePlaceholderRequest)], FExternalItemCreatePlaceholderExecution);
  return FExternalItemCreatePlaceholderExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FExternalItemCreatePreviewRequest {
  fExternalItem;
  constructor(fExternalItem) {
    this.fExternalItem = fExternalItem;
  }
}
let FExternalItemCreatePreviewExecution = /*#__PURE__*/(() => {
  let FExternalItemCreatePreviewExecution = class FExternalItemCreatePreviewExecution {
    _fBrowser = inject(BrowserService);
    _containerRef = inject(ViewContainerRef);
    handle(request) {
      const {
        hostElement,
        fPreview
      } = request.fExternalItem;
      const result = fPreview ? this._fromTemplate(fPreview) : this._fromHost(hostElement);
      this._setPreviewStyles(result);
      disableDragInteractions(result);
      result.classList.add('f-external-item-preview');
      return result;
    }
    _fromTemplate(template) {
      return getOrCreateRootNodeForViewRef(this._createViewRef(template), this._fBrowser.document);
    }
    _fromHost(element) {
      return deepCloneNode(element);
    }
    _createViewRef(template) {
      const result = this._containerRef.createEmbeddedView(template);
      result.detectChanges();
      return result;
    }
    _setPreviewStyles(element) {
      extendStyles(element.style, {
        'pointer-events': 'none',
        'margin': 'showPopover' in element ? '0 auto 0 0' : '0',
        'position': 'fixed',
        'top': '0',
        'left': '0',
        'z-index': '1000'
      }, new Set(['position']));
    }
    static ɵfac = function FExternalItemCreatePreviewExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FExternalItemCreatePreviewExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FExternalItemCreatePreviewExecution,
      factory: FExternalItemCreatePreviewExecution.ɵfac
    });
  };
  FExternalItemCreatePreviewExecution = __decorate([FExecutionRegister(FExternalItemCreatePreviewRequest)], FExternalItemCreatePreviewExecution);
  return FExternalItemCreatePreviewExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FExternalItemFinalizeRequest {
  event;
  constructor(event) {
    this.event = event;
  }
}
class FExternalItemDragHandler {
  _fExternalItem;
  fEventType = 'external-item';
  fData;
  _fResult;
  _fMediator;
  _fBrowser;
  _preview;
  _placeholder;
  _onPointerDownRect = RectExtensions.initialize();
  get _fItemHost() {
    return this._fExternalItem.hostElement;
  }
  constructor(_injector, _fExternalItem) {
    this._fExternalItem = _fExternalItem;
    this.fData = {
      fData: _fExternalItem.fData
    };
    this._fResult = _injector.get(FDragHandlerResult);
    this._fMediator = _injector.get(FMediator);
    this._fBrowser = _injector.get(BrowserService);
  }
  prepareDragSequence() {
    this._onPointerDownRect = this._getExternalItemRect();
    this._createAndAppendPreview();
    this._createAndAppendPlaceholder();
    this._setFResultData();
  }
  _createAndAppendPreview() {
    this._preview = this._fMediator.execute(new FExternalItemCreatePreviewRequest(this._fExternalItem));
    if (this._fExternalItem.fPreviewMatchSize) {
      this._matchElementSize(this._preview, this._onPointerDownRect);
    }
    this._preview.style.transform = setTransform(this._onPointerDownRect);
    this._fBrowser.document.body.appendChild(this._preview);
  }
  _createAndAppendPlaceholder() {
    this._placeholder = this._fMediator.execute(new FExternalItemCreatePlaceholderRequest(this._fExternalItem));
    this._fBrowser.document.body.appendChild(this._fItemHost.parentElement.replaceChild(this._placeholder, this._fItemHost));
  }
  _matchElementSize(target, sourceRect) {
    target.style.width = `${sourceRect.width}px`;
    target.style.height = `${sourceRect.height}px`;
  }
  _setFResultData() {
    this._fResult.setData({
      preview: this._preview,
      fExternalItem: this._fExternalItem
    });
  }
  _getExternalItemRect() {
    const rect = this._fExternalItem.hostElement.getBoundingClientRect();
    const scrollTop = this._fBrowser.window.pageYOffset || this._fBrowser.document.documentElement.scrollTop;
    const scrollLeft = this._fBrowser.window.pageXOffset || this._fBrowser.document.documentElement.scrollLeft;
    const offsetTop = rect.top + scrollTop;
    const offsetLeft = rect.left + scrollLeft;
    return RectExtensions.initialize(offsetLeft, offsetTop, rect.width, rect.height);
  }
  onPointerMove(difference) {
    const position = Point.fromPoint(this._onPointerDownRect).add(difference);
    this._preview.style.transform = setTransform(position);
  }
  onPointerUp() {
    this._fBrowser.document.body.removeChild(this._preview);
    this._placeholder.parentElement.replaceChild(this._fItemHost, this._placeholder);
  }
}
function setTransform({
  x,
  y
}) {
  return `translate3d(${Math.round(x)}px, ${Math.round(y)}px, 0)`;
}
class FCreateNodeEvent {
  rect;
  data;
  constructor(rect, data) {
    this.rect = rect;
    this.data = data;
  }
}
let FExternalItemFinalizeExecution = /*#__PURE__*/(() => {
  let FExternalItemFinalizeExecution = class FExternalItemFinalizeExecution {
    _fResult = inject(FDragHandlerResult);
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    _fBrowser = inject(BrowserService);
    get _fHost() {
      return this._fComponentsStore.fFlow.hostElement;
    }
    get _fCreateNode() {
      return this._fComponentsStore.fDraggable.fCreateNode;
    }
    get _fDragHandler() {
      return this._fDraggableDataContext.draggableItems[0];
    }
    handle(request) {
      if (!this._isValid()) {
        return;
      }
      this._emitEvent(this._getElementsFromPoint(request.event.getPosition()));
      this._fDragHandler.onPointerUp();
    }
    _isValid() {
      return this._fDraggableDataContext.draggableItems.some(x => x instanceof FExternalItemDragHandler);
    }
    _getElementsFromPoint(position) {
      return this._fBrowser.document.elementsFromPoint(position.x, position.y).filter(x => !x.closest('.f-external-item') && !x.closest('.f-external-item-preview'));
    }
    _emitEvent(elements) {
      if (this.isPointerInCanvasRect(elements)) {
        this._fCreateNode.emit(new FCreateNodeEvent(this._getPreviewRect(), this._fResult.getData().fExternalItem.fData));
      }
    }
    isPointerInCanvasRect(elements) {
      return elements.length ? this._fHost.contains(elements[0]) : false;
    }
    _getPreviewRect() {
      return this._fMediator.execute(new GetNormalizedElementRectRequest(this._fResult.getData().preview, false));
    }
    static ɵfac = function FExternalItemFinalizeExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FExternalItemFinalizeExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FExternalItemFinalizeExecution,
      factory: FExternalItemFinalizeExecution.ɵfac
    });
  };
  FExternalItemFinalizeExecution = __decorate([FExecutionRegister(FExternalItemFinalizeRequest)], FExternalItemFinalizeExecution);
  return FExternalItemFinalizeExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FExternalItemPreparationRequest {
  event;
  fTrigger;
  constructor(event, fTrigger) {
    this.event = event;
    this.fTrigger = fTrigger;
  }
}
let FExternalItemPreparationExecution = /*#__PURE__*/(() => {
  let FExternalItemPreparationExecution = class FExternalItemPreparationExecution {
    _fExternalItemService = inject(FExternalItemService);
    _fDraggableDataContext = inject(FDraggableDataContext);
    _fComponentsStore = inject(FComponentsStore);
    _injector = inject(Injector);
    get _fHost() {
      return this._fComponentsStore.fFlow.hostElement;
    }
    handle(request) {
      if (!this._isValid(request) || !this._isValidTrigger(request)) {
        return;
      }
      this._fDraggableDataContext.onPointerDownScale = 1;
      this._fDraggableDataContext.onPointerDownPosition = Point.fromPoint(request.event.getPosition()).elementTransform(this._fHost);
      this._fDraggableDataContext.draggableItems = [new FExternalItemDragHandler(this._injector, this._getExternalItem(request.event.targetElement))];
    }
    _isValid(request) {
      return this._isValidExternalItem(request.event.targetElement, this._getExternalItem(request.event.targetElement));
    }
    _isValidExternalItem(element, fExternalItem) {
      return isExternalItem(element) && !!fExternalItem && !fExternalItem.fDisabled;
    }
    _getExternalItem(targetElement) {
      return this._fExternalItemService.getItem(getExternalItem(targetElement));
    }
    _isValidTrigger(request) {
      return isValidEventTrigger(request.event.originalEvent, request.fTrigger);
    }
    static ɵfac = function FExternalItemPreparationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FExternalItemPreparationExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FExternalItemPreparationExecution,
      factory: FExternalItemPreparationExecution.ɵfac
    });
  };
  FExternalItemPreparationExecution = __decorate([FExecutionRegister(FExternalItemPreparationRequest)], FExternalItemPreparationExecution);
  return FExternalItemPreparationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PreventDefaultIsExternalItemRequest {
  event;
  constructor(event) {
    this.event = event;
  }
}
function isExternalItem(element) {
  return !!element.closest('[fExternalItem]');
}
function getExternalItem(element) {
  return element.closest('[fExternalItem]');
}
let PreventDefaultIsExternalItemExecution = /*#__PURE__*/(() => {
  let PreventDefaultIsExternalItemExecution = class PreventDefaultIsExternalItemExecution {
    handle(request) {
      if (this._isTargetItemExternal(request.event)) {
        request.event.preventDefault();
      }
    }
    _isTargetItemExternal(event) {
      let isTargetItemExternal = this._isExternalItem(event.target);
      let isTargetParentItemExternal = this._isExternalItem(event.target.parentNode);
      return isTargetItemExternal || isTargetParentItemExternal;
    }
    _isExternalItem(target) {
      let result = false;
      try {
        result = isExternalItem(target);
      } catch (e) {}
      return result;
    }
    static ɵfac = function PreventDefaultIsExternalItemExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PreventDefaultIsExternalItemExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PreventDefaultIsExternalItemExecution,
      factory: PreventDefaultIsExternalItemExecution.ɵfac
    });
  };
  PreventDefaultIsExternalItemExecution = __decorate([FExecutionRegister(PreventDefaultIsExternalItemRequest)], PreventDefaultIsExternalItemExecution);
  return PreventDefaultIsExternalItemExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_EXTERNAL_ITEM_DRAG_AND_DROP_PROVIDERS = [FExternalItemCreatePlaceholderExecution, FExternalItemCreatePreviewExecution, FExternalItemFinalizeExecution, FExternalItemPreparationExecution, PreventDefaultIsExternalItemExecution];
let FExternalItemBase = /*#__PURE__*/(() => {
  class FExternalItemBase {
    static ɵfac = function FExternalItemBase_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FExternalItemBase)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FExternalItemBase
    });
  }
  return FExternalItemBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FExternalItemService = /*#__PURE__*/(() => {
  class FExternalItemService {
    _items = [];
    registerItem(item) {
      this._items.push(item);
    }
    getItem(element) {
      return this._items.find(item => item.hostElement === element);
    }
    removeItem(item) {
      const index = this._items.indexOf(item);
      if (index !== -1) {
        this._items.splice(index, 1);
      }
    }
    static ɵfac = function FExternalItemService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FExternalItemService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FExternalItemService,
      factory: FExternalItemService.ɵfac,
      providedIn: 'root'
    });
  }
  return FExternalItemService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_EXTERNAL_ITEM = new InjectionToken('F_EXTERNAL_ITEM');
let uniqueId$3 = 0;
let FExternalItemDirective = /*#__PURE__*/(() => {
  class FExternalItemDirective extends FExternalItemBase {
    _elementReference = inject(ElementRef);
    _fExternalItemService = inject(FExternalItemService);
    fExternalItemId = `f-external-item-${uniqueId$3++}`;
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    fData;
    fDisabled = false;
    fPreview;
    fPreviewMatchSize = true;
    fPlaceholder;
    ngOnInit() {
      this._fExternalItemService.registerItem(this);
      this.disablePointerEvents(Array.from(this.hostElement.children));
    }
    disablePointerEvents(children) {
      children.forEach(x => {
        x.style.pointerEvents = 'none';
        this.disablePointerEvents(Array.from(x.children));
      });
    }
    ngOnDestroy() {
      this._fExternalItemService.removeItem(this);
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFExternalItemDirective_BaseFactory;
      return function FExternalItemDirective_Factory(__ngFactoryType__) {
        return (ɵFExternalItemDirective_BaseFactory || (ɵFExternalItemDirective_BaseFactory = i0.ɵɵgetInheritedFactory(FExternalItemDirective)))(__ngFactoryType__ || FExternalItemDirective);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FExternalItemDirective,
      selectors: [["", "fExternalItem", ""]],
      hostAttrs: [1, "f-component", "f-external-item"],
      hostVars: 3,
      hostBindings: function FExternalItemDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.fExternalItemId);
          i0.ɵɵclassProp("f-external-item-disabled", ctx.fDisabled);
        }
      },
      inputs: {
        fExternalItemId: "fExternalItemId",
        fData: "fData",
        fDisabled: [2, "fDisabled", "fDisabled", booleanAttribute],
        fPreview: "fPreview",
        fPreviewMatchSize: [2, "fPreviewMatchSize", "fPreviewMatchSize", booleanAttribute],
        fPlaceholder: "fPlaceholder"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: F_EXTERNAL_ITEM,
        useExisting: FExternalItemDirective
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature]
    });
  }
  return FExternalItemDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FExternalItemPlaceholderDirective = /*#__PURE__*/(() => {
  class FExternalItemPlaceholderDirective {
    _fExternalItem = inject(F_EXTERNAL_ITEM);
    _templateRef = inject(TemplateRef);
    ngOnInit() {
      this._fExternalItem.fPlaceholder = this._templateRef;
    }
    ngOnDestroy() {
      this._fExternalItem.fPlaceholder = undefined;
    }
    static ɵfac = function FExternalItemPlaceholderDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FExternalItemPlaceholderDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FExternalItemPlaceholderDirective,
      selectors: [["ng-template", "fExternalItemPlaceholder", ""]],
      hostAttrs: [1, "f-component", "f-external-item-placeholder"],
      standalone: true
    });
  }
  return FExternalItemPlaceholderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FExternalItemPreviewDirective = /*#__PURE__*/(() => {
  class FExternalItemPreviewDirective {
    _fExternalItem = inject(F_EXTERNAL_ITEM);
    _templateRef = inject(TemplateRef);
    ngOnInit() {
      this._fExternalItem.fPreview = this._templateRef;
    }
    ngOnDestroy() {
      this._fExternalItem.fPreview = undefined;
    }
    static ɵfac = function FExternalItemPreviewDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FExternalItemPreviewDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FExternalItemPreviewDirective,
      selectors: [["ng-template", "fExternalItemPreview", ""]],
      hostAttrs: [1, "f-component", "f-external-item-preview"],
      standalone: true
    });
  }
  return FExternalItemPreviewDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_EXTERNAL_ITEM_PROVIDERS = [FExternalItemDirective];
const F_BEFORE_MAIN_PLUGIN = new InjectionToken('F_BEFORE_MAIN_PLUGIN');
const F_AFTER_MAIN_PLUGIN = new InjectionToken('F_AFTER_MAIN_PLUGIN');
let FDraggableDirective = /*#__PURE__*/(() => {
  class FDraggableDirective extends FDraggableBase {
    _fBrowser;
    _elementReference = inject(ElementRef);
    _fResult = inject(FDragHandlerResult);
    _fMediator = inject(FMediator);
    _fPlatform = inject(PlatformService);
    disabled = false;
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    fMultiSelectTrigger = event => {
      return this._fPlatform.getOS() === EOperationSystem.MAC_OS ? event.metaKey : event.ctrlKey;
    };
    fReassignConnectionTrigger = defaultEventTrigger;
    fCreateConnectionTrigger = defaultEventTrigger;
    fNodeResizeTrigger = defaultEventTrigger;
    fNodeRotateTrigger = defaultEventTrigger;
    fNodeMoveTrigger = defaultEventTrigger;
    fCanvasMoveTrigger = defaultEventTrigger;
    fExternalItemTrigger = defaultEventTrigger;
    fSelectionChange = new EventEmitter();
    fNodeIntersectedWithConnections = new EventEmitter();
    fEmitOnNodeIntersect = false;
    fCreateNode = new EventEmitter();
    fReassignConnection = new EventEmitter();
    fCreateConnection = new EventEmitter();
    fDropToGroup = new EventEmitter();
    vCellSize = 1;
    hCellSize = 1;
    fCellSizeWhileDragging = false;
    fDragStarted = new EventEmitter();
    fDragEnded = new EventEmitter();
    _beforePlugins;
    _afterPlugins;
    constructor(ngZone, _fBrowser) {
      super(ngZone);
      this._fBrowser = _fBrowser;
    }
    ngOnInit() {
      this._fMediator.execute(new AddDndToStoreRequest(this));
    }
    ngAfterViewInit() {
      super.subscribe(this._fBrowser.document);
    }
    onPointerDown(event) {
      this._fResult.clear();
      this._fMediator.execute(new InitializeDragSequenceRequest());
      this._beforePlugins.forEach(p => p.onPointerDown?.(event));
      this._fMediator.execute(new FSingleSelectRequest(event, this.fMultiSelectTrigger));
      this._fMediator.execute(new FReassignConnectionPreparationRequest(event, this.fReassignConnectionTrigger));
      this._fMediator.execute(new FCreateConnectionPreparationRequest(event, this.fCreateConnectionTrigger));
      this._afterPlugins.forEach(p => p.onPointerDown?.(event));
      const isMouseLeftOrTouch = event.isMouseLeftButton();
      if (!isMouseLeftOrTouch) {
        this.finalizeDragSequence();
      }
      return isMouseLeftOrTouch;
    }
    prepareDragSequence(event) {
      this._beforePlugins.forEach(p => p.prepareDragSequence?.(event));
      this._fMediator.execute(new FNodeResizePreparationRequest(event, this.fNodeResizeTrigger));
      this._fMediator.execute(new FNodeRotatePreparationRequest(event, this.fNodeRotateTrigger));
      this._fMediator.execute(new FNodeMovePreparationRequest(event, this.fNodeMoveTrigger));
      this._fMediator.execute(new FNodeDropToGroupPreparationRequest(event));
      this._fMediator.execute(new FCanvasMovePreparationRequest(event, this.fCanvasMoveTrigger));
      this._fMediator.execute(new FExternalItemPreparationRequest(event, this.fExternalItemTrigger));
      this._afterPlugins.forEach(p => p.prepareDragSequence?.(event));
      this._fMediator.execute(new PrepareDragSequenceRequest());
    }
    onSelect(event) {
      this._fMediator.execute(new PreventDefaultIsExternalItemRequest(event));
    }
    onPointerMove(event) {
      this._fMediator.execute(new OnPointerMoveRequest(event));
    }
    onPointerUp(event) {
      this._beforePlugins.forEach(x => x.onPointerUp?.(event));
      this._fMediator.execute(new FReassignConnectionFinalizeRequest(event));
      this._fMediator.execute(new FCreateConnectionFinalizeRequest(event));
      this._fMediator.execute(new FNodeResizeFinalizeRequest(event));
      this._fMediator.execute(new FNodeRotateFinalizeRequest(event));
      this._fMediator.execute(new FNodeMoveFinalizeRequest(event));
      this._fMediator.execute(new FNodeDropToGroupFinalizeRequest(event));
      this._fMediator.execute(new FCanvasMoveFinalizeRequest(event));
      this._fMediator.execute(new FExternalItemFinalizeRequest(event));
      this._afterPlugins.forEach(x => x.onPointerUp?.(event));
      this._fMediator.execute(new EndDragSequenceRequest());
    }
    finalizeDragSequence() {
      this._fMediator.execute(new EmitSelectionChangeEventRequest());
      this._fResult.clear();
    }
    ngOnDestroy() {
      this._fMediator.execute(new RemoveDndFromStoreRequest());
      super.unsubscribe();
    }
    static ɵfac = function FDraggableDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FDraggableDirective)(i0.ɵɵdirectiveInject(NgZone, 8), i0.ɵɵdirectiveInject(i1.BrowserService));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FDraggableDirective,
      selectors: [["f-flow", "fDraggable", ""]],
      contentQueries: function FDraggableDirective_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, F_BEFORE_MAIN_PLUGIN, 5);
          i0.ɵɵcontentQuery(dirIndex, F_AFTER_MAIN_PLUGIN, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._beforePlugins = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._afterPlugins = _t);
        }
      },
      inputs: {
        disabled: [2, "fDraggableDisabled", "disabled", booleanAttribute],
        fMultiSelectTrigger: "fMultiSelectTrigger",
        fReassignConnectionTrigger: "fReassignConnectionTrigger",
        fCreateConnectionTrigger: "fCreateConnectionTrigger",
        fNodeResizeTrigger: "fNodeResizeTrigger",
        fNodeRotateTrigger: "fNodeRotateTrigger",
        fNodeMoveTrigger: "fNodeMoveTrigger",
        fCanvasMoveTrigger: "fCanvasMoveTrigger",
        fExternalItemTrigger: "fExternalItemTrigger",
        fEmitOnNodeIntersect: [2, "fEmitOnNodeIntersect", "fEmitOnNodeIntersect", booleanAttribute],
        vCellSize: [2, "vCellSize", "vCellSize", numberAttribute],
        hCellSize: [2, "hCellSize", "hCellSize", numberAttribute],
        fCellSizeWhileDragging: [2, "fCellSizeWhileDragging", "fCellSizeWhileDragging", booleanAttribute]
      },
      outputs: {
        fSelectionChange: "fSelectionChange",
        fNodeIntersectedWithConnections: "fNodeIntersectedWithConnections",
        fCreateNode: "fCreateNode",
        fReassignConnection: "fReassignConnection",
        fCreateConnection: "fCreateConnection",
        fDropToGroup: "fDropToGroup",
        fDragStarted: "fDragStarted",
        fDragEnded: "fDragEnded"
      },
      exportAs: ["fDraggable"],
      features: [i0.ɵɵProvidersFeature([FDragHandlerResult]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature]
    });
  }
  return FDraggableDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FSelectionChangeEvent {
  fNodeIds;
  fGroupIds;
  fConnectionIds;
  constructor(fNodeIds, fGroupIds, fConnectionIds) {
    this.fNodeIds = fNodeIds;
    this.fGroupIds = fGroupIds;
    this.fConnectionIds = fConnectionIds;
  }
}
class MinimapDragPreparationRequest {
  event;
  minimap;
  constructor(event, minimap) {
    this.event = event;
    this.minimap = minimap;
  }
}
class CalculateFlowPointFromMinimapPointRequest {
  flowRect;
  canvasPosition;
  eventPoint;
  minimap;
  constructor(flowRect, canvasPosition, eventPoint, minimap) {
    this.flowRect = flowRect;
    this.canvasPosition = canvasPosition;
    this.eventPoint = eventPoint;
    this.minimap = minimap;
  }
}
let CalculateFlowPointFromMinimapPointExecution = /*#__PURE__*/(() => {
  let CalculateFlowPointFromMinimapPointExecution = class CalculateFlowPointFromMinimapPointExecution {
    fComponentsStore;
    get canvasScale() {
      return this.fComponentsStore.fCanvas.transform.scale;
    }
    constructor(fComponentsStore) {
      this.fComponentsStore = fComponentsStore;
    }
    handle(payload) {
      return PointExtensions.sub(payload.canvasPosition, PointExtensions.sub(this.getPositionInViewBox(payload.eventPoint, payload.minimap), this.getNormalizedFlowCenter(payload.flowRect)));
    }
    getNormalizedFlowCenter(flowRect) {
      return Point.fromPoint(flowRect.gravityCenter).sub(flowRect);
    }
    getPositionInViewBox(eventPoint, minimap) {
      const eventPointInFlow = this.normalizeEventPoint(eventPoint, minimap);
      return PointExtensions.sum(eventPointInFlow, RectExtensions.mult(minimap.viewBox, this.canvasScale));
    }
    normalizeEventPoint(point, minimap) {
      return this.getEventPointInMinimap(point, minimap).mult(minimap.scale).mult(this.canvasScale);
    }
    getEventPointInMinimap(eventPoint, minimap) {
      return Point.fromPoint(eventPoint).elementTransform(minimap.element);
    }
    static ɵfac = function CalculateFlowPointFromMinimapPointExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalculateFlowPointFromMinimapPointExecution)(i0.ɵɵinject(FComponentsStore));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CalculateFlowPointFromMinimapPointExecution,
      factory: CalculateFlowPointFromMinimapPointExecution.ɵfac
    });
  };
  CalculateFlowPointFromMinimapPointExecution = __decorate([FExecutionRegister(CalculateFlowPointFromMinimapPointRequest)], CalculateFlowPointFromMinimapPointExecution);
  return CalculateFlowPointFromMinimapPointExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FMinimapDragHandler {
  fComponentsStore;
  fMediator;
  flowRect;
  canvasPosition;
  eventPoint;
  minimap;
  fEventType = 'minimap';
  lastDifference = null;
  constructor(fComponentsStore, fMediator, flowRect, canvasPosition, eventPoint, minimap) {
    this.fComponentsStore = fComponentsStore;
    this.fMediator = fMediator;
    this.flowRect = flowRect;
    this.canvasPosition = canvasPosition;
    this.eventPoint = eventPoint;
    this.minimap = minimap;
  }
  prepareDragSequence() {
    this.fComponentsStore.fCanvas?.hostElement.classList.add('f-scaled-animate');
  }
  onPointerMove(difference) {
    if (this.lastDifference && this.isSamePoint(difference, this.lastDifference)) {
      return;
    }
    this.lastDifference = difference;
    this.fComponentsStore.fCanvas.setPosition(this.getNewPosition(Point.fromPoint(this.eventPoint).add(difference)));
    this.fComponentsStore.fCanvas.redraw();
  }
  isSamePoint(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
  }
  getNewPosition(eventPoint) {
    return this.fMediator.execute(new CalculateFlowPointFromMinimapPointRequest(this.flowRect, this.canvasPosition, eventPoint, this.minimap));
  }
  onPointerUp() {
    this.fComponentsStore.fCanvas?.hostElement.classList.remove('f-scaled-animate');
    this.fComponentsStore.fCanvas.emitCanvasChangeEvent();
  }
}
let MinimapDragPreparationExecution = /*#__PURE__*/(() => {
  let MinimapDragPreparationExecution = class MinimapDragPreparationExecution {
    fComponentsStore;
    fMediator;
    fDraggableDataContext;
    get flowHost() {
      return this.fComponentsStore.fFlow.hostElement;
    }
    constructor(fComponentsStore, fMediator, fDraggableDataContext) {
      this.fComponentsStore = fComponentsStore;
      this.fMediator = fMediator;
      this.fDraggableDataContext = fDraggableDataContext;
    }
    handle(request) {
      if (!this._isValid(request)) {
        return;
      }
      const eventPoint = request.event.getPosition();
      const startCanvasPosition = Point.fromPoint(this.fComponentsStore.fCanvas.transform.position);
      this.fComponentsStore.fCanvas.setPosition(this.getNewPosition(eventPoint, request.minimap));
      this.fComponentsStore.fCanvas.redraw();
      this.fComponentsStore.fCanvas.emitCanvasChangeEvent();
      this.fDraggableDataContext.onPointerDownScale = 1;
      this.fDraggableDataContext.onPointerDownPosition = Point.fromPoint(eventPoint).elementTransform(this.flowHost);
      this.fDraggableDataContext.draggableItems = [new FMinimapDragHandler(this.fComponentsStore, this.fMediator, this.getFlowRect(), startCanvasPosition, eventPoint, request.minimap)];
    }
    _isValid(request) {
      return !this.fDraggableDataContext.draggableItems.length && !!request.event.targetElement.closest('.f-minimap') && this.fComponentsStore.flowHost.contains(request.event.targetElement);
    }
    getNewPosition(eventPoint, minimap) {
      return this.fMediator.execute(new CalculateFlowPointFromMinimapPointRequest(this.getFlowRect(), Point.fromPoint(this.fComponentsStore.fCanvas.transform.position), eventPoint, minimap));
    }
    getFlowRect() {
      return RectExtensions.fromElement(this.flowHost);
    }
    static ɵfac = function MinimapDragPreparationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MinimapDragPreparationExecution)(i0.ɵɵinject(FComponentsStore), i0.ɵɵinject(i2$1.FMediator), i0.ɵɵinject(FDraggableDataContext));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MinimapDragPreparationExecution,
      factory: MinimapDragPreparationExecution.ɵfac
    });
  };
  MinimapDragPreparationExecution = __decorate([FExecutionRegister(MinimapDragPreparationRequest)], MinimapDragPreparationExecution);
  return MinimapDragPreparationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MINIMAP_DRAG_PREPARATION_PROVIDERS = [MinimapDragPreparationExecution];
class MinimapDragFinalizeRequest {
  event;
  constructor(event) {
    this.event = event;
  }
}
let MinimapDragFinalizeExecution = /*#__PURE__*/(() => {
  let MinimapDragFinalizeExecution = class MinimapDragFinalizeExecution {
    fDraggableDataContext;
    constructor(fDraggableDataContext) {
      this.fDraggableDataContext = fDraggableDataContext;
    }
    handle(request) {
      if (!this._isValid()) {
        return;
      }
      this.fDraggableDataContext.draggableItems.forEach(x => {
        x.onPointerUp?.();
      });
    }
    _isValid() {
      return this.fDraggableDataContext.draggableItems.some(x => x instanceof FMinimapDragHandler);
    }
    static ɵfac = function MinimapDragFinalizeExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MinimapDragFinalizeExecution)(i0.ɵɵinject(FDraggableDataContext));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MinimapDragFinalizeExecution,
      factory: MinimapDragFinalizeExecution.ɵfac
    });
  };
  MinimapDragFinalizeExecution = __decorate([FExecutionRegister(MinimapDragFinalizeRequest)], MinimapDragFinalizeExecution);
  return MinimapDragFinalizeExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MINIMAP_DRAG_FINALIZE_PROVIDERS = [MinimapDragFinalizeExecution];
class MinimapDrawNodesRequest {}
let MinimapDrawNodesExecution = /*#__PURE__*/(() => {
  let MinimapDrawNodesExecution = class MinimapDrawNodesExecution {
    _fBrowser = inject(BrowserService);
    _fComponentStore = inject(FComponentsStore);
    get _fFlow() {
      return this._fComponentStore.fFlow;
    }
    get _fNodes() {
      return this._fComponentStore.fNodes;
    }
    get _fCanvas() {
      return this._fComponentStore.fCanvas;
    }
    handle(request) {
      return this._createMinimapNodeElements(request);
    }
    _createMinimapNodeElements(request) {
      return this._fNodes.map(x => {
        const element = this._createNodeElement();
        setRectToElement(this._getNodeRect(x), element);
        this._applyClassList(element, x, x instanceof FNodeDirective);
        return element;
      });
    }
    _createNodeElement() {
      return createSVGElement('rect', this._fBrowser);
    }
    _getNodeRect(node) {
      return RectExtensions.div(this._getNodeRectInFlow(node), this._fCanvas.transform.scale);
    }
    _getNodeRectInFlow(node) {
      return RectExtensions.elementTransform(RectExtensions.fromElement(node.hostElement), this._fFlow.hostElement);
    }
    _applyClassList(element, node, isNode) {
      element.classList.add('f-component', isNode ? 'f-minimap-node' : 'f-minimap-group');
      if (node.isSelected()) {
        element.classList.add('f-selected');
      }
    }
    static ɵfac = function MinimapDrawNodesExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MinimapDrawNodesExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MinimapDrawNodesExecution,
      factory: MinimapDrawNodesExecution.ɵfac
    });
  };
  MinimapDrawNodesExecution = __decorate([FExecutionRegister(MinimapDrawNodesRequest)], MinimapDrawNodesExecution);
  return MinimapDrawNodesExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class MinimapCalculateViewBoxRequest {}
let MinimapCalculateViewBoxExecution = /*#__PURE__*/(() => {
  let MinimapCalculateViewBoxExecution = class MinimapCalculateViewBoxExecution {
    _fComponentStore = inject(FComponentsStore);
    get _fFlow() {
      return this._fComponentStore.fFlow;
    }
    get _fCanvas() {
      return this._fComponentStore.fCanvas;
    }
    handle(request) {
      if (!this._fFlow || !this._fCanvas) {
        return RectExtensions.initialize();
      }
      return this._getRectForMinimapView();
    }
    _getRectForMinimapView() {
      const result = this._calculateViewBox();
      result.x = 0;
      result.y = 0;
      return result;
    }
    _calculateViewBox() {
      return RectExtensions.div(RectExtensions.fromElement(this._fFlow.hostElement), this._fCanvas.transform.scale);
    }
    static ɵfac = function MinimapCalculateViewBoxExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MinimapCalculateViewBoxExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MinimapCalculateViewBoxExecution,
      factory: MinimapCalculateViewBoxExecution.ɵfac
    });
  };
  MinimapCalculateViewBoxExecution = __decorate([FExecutionRegister(MinimapCalculateViewBoxRequest)], MinimapCalculateViewBoxExecution);
  return MinimapCalculateViewBoxExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class MinimapCalculateSvgScaleAndViewBoxRequest {
  element;
  minSize;
  constructor(element, minSize) {
    this.element = element;
    this.minSize = minSize;
  }
}
let MinimapCalculateSvgScaleAndViewBoxExecution = /*#__PURE__*/(() => {
  let MinimapCalculateSvgScaleAndViewBoxExecution = class MinimapCalculateSvgScaleAndViewBoxExecution {
    _fMediator = inject(FMediator);
    _fComponentStore = inject(FComponentsStore);
    get _fFlow() {
      return this._fComponentStore.fFlow;
    }
    get _fCanvas() {
      return this._fComponentStore.fCanvas;
    }
    handle(request) {
      if (!this._fFlow) {
        return {
          scale: 1,
          viewBox: RectExtensions.initialize(0, 0, 0, 0)
        };
      }
      const nodesRect = this._getScaledNodesBoundingBox(request.minSize);
      const minimapRect = this._getMinimapRect(request.element);
      const scale = this._calculateViewScale(nodesRect, minimapRect);
      return {
        scale,
        viewBox: this._calculateViewBox(nodesRect, minimapRect, scale)
      };
    }
    _getScaledNodesBoundingBox(minSize) {
      const globalRect = this._calculateNodesBoundingBox();
      const flowRect = this._convertFromGlobalToFlowRect(globalRect);
      const scaledRect = this._convertRectToMinimapScale(flowRect);
      return adjustRectToMinSize(scaledRect, minSize);
    }
    _calculateNodesBoundingBox() {
      return this._fMediator.execute(new CalculateNodesBoundingBoxRequest()) || RectExtensions.initialize(0, 0, 0, 0);
    }
    _convertFromGlobalToFlowRect(rect) {
      return RectExtensions.elementTransform(rect, this._fFlow.hostElement);
    }
    _convertRectToMinimapScale(rect) {
      return RectExtensions.div(rect, this._fCanvas.transform.scale);
    }
    _getMinimapRect(element) {
      return RectExtensions.elementTransform(RectExtensions.fromElement(element), this._fFlow.hostElement);
    }
    _calculateViewScale(nodesRect, minimapRect) {
      return Math.max(nodesRect.width / minimapRect.width, nodesRect.height / minimapRect.height);
    }
    _calculateViewBox(nodesRect, minimapRect, scale) {
      return this._calculateCenteredViewBox(nodesRect, this._calculateViewSize(minimapRect, scale));
    }
    _calculateViewSize(minimapRect, scale) {
      return SizeExtensions.initialize(minimapRect.width * scale || 0, minimapRect.height * scale || 0);
    }
    _calculateCenteredViewBox(nodesRect, viewSize) {
      const centeredX = nodesRect.x - (viewSize.width - nodesRect.width) / 2;
      const centeredY = nodesRect.y - (viewSize.height - nodesRect.height) / 2;
      return RectExtensions.initialize(centeredX, centeredY, viewSize.width, viewSize.height);
    }
    static ɵfac = function MinimapCalculateSvgScaleAndViewBoxExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MinimapCalculateSvgScaleAndViewBoxExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MinimapCalculateSvgScaleAndViewBoxExecution,
      factory: MinimapCalculateSvgScaleAndViewBoxExecution.ɵfac
    });
  };
  MinimapCalculateSvgScaleAndViewBoxExecution = __decorate([FExecutionRegister(MinimapCalculateSvgScaleAndViewBoxRequest)], MinimapCalculateSvgScaleAndViewBoxExecution);
  return MinimapCalculateSvgScaleAndViewBoxExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_MINIMAP_DRAG_AND_DROP_PROVIDERS = [CalculateFlowPointFromMinimapPointExecution, ...MINIMAP_DRAG_FINALIZE_PROVIDERS, ...MINIMAP_DRAG_PREPARATION_PROVIDERS, MinimapDrawNodesExecution, MinimapCalculateSvgScaleAndViewBoxExecution, MinimapCalculateViewBoxExecution];
class SelectionAreaFinalizeRequest {
  event;
  constructor(event) {
    this.event = event;
  }
}
class SelectionAreaDragHandle {
  _fComponentsStore;
  _fSelectionArea;
  _fDraggableDataContext;
  _fMediator;
  fEventType = 'selection-area';
  _canBeSelected = [];
  _selectedByMove = [];
  get _fCanvasPosition() {
    return Point.fromPoint(this._fComponentsStore.fCanvas.transform.position).add(this._fComponentsStore.fCanvas.transform.scaledPosition);
  }
  constructor(_fComponentsStore, _fSelectionArea, _fDraggableDataContext, _fMediator) {
    this._fComponentsStore = _fComponentsStore;
    this._fSelectionArea = _fSelectionArea;
    this._fDraggableDataContext = _fDraggableDataContext;
    this._fMediator = _fMediator;
  }
  prepareDragSequence() {
    this._canBeSelected = this._fMediator.execute(new GetCanBeSelectedItemsRequest());
    this._fSelectionArea.show();
    this._fSelectionArea.draw(RectExtensions.initialize(this._fDraggableDataContext.onPointerDownPosition.x, this._fDraggableDataContext.onPointerDownPosition.y));
  }
  onPointerMove(difference) {
    const currentPoint = Point.fromPoint(difference).add(this._fDraggableDataContext.onPointerDownPosition);
    const point = this._getMinimumPoint(this._fDraggableDataContext.onPointerDownPosition, currentPoint);
    const width = Math.abs(difference.x);
    const height = Math.abs(difference.y);
    const fSelectionAreaRect = RectExtensions.initialize(point.x, point.y, width, height);
    this._fSelectionArea.draw(fSelectionAreaRect);
    this._selectedByMove = [];
    this._canBeSelected.forEach(item => {
      item.element.unmarkAsSelected();
      const fItemRect = RectExtensions.addPoint(item.fRect, this._fCanvasPosition);
      const isIntersect = RectExtensions.intersectionWithRect(fItemRect, fSelectionAreaRect);
      if (isIntersect) {
        item.element.markAsSelected();
        this._selectedByMove.push(item.element);
      }
    });
    this._fMediator.execute(new NotifyTransformChangedRequest());
  }
  _getMinimumPoint(point1, point2) {
    return PointExtensions.initialize(Math.min(point1.x, point2.x), Math.min(point1.y, point2.y));
  }
  onPointerUp() {
    this._fSelectionArea.hide();
    this._fDraggableDataContext.selectedItems.push(...this._selectedByMove);
    if (this._selectedByMove.length > 0) {
      this._fDraggableDataContext.isSelectedChanged = true;
    }
  }
}
let SelectionAreaFinalizeExecution = /*#__PURE__*/(() => {
  let SelectionAreaFinalizeExecution = class SelectionAreaFinalizeExecution {
    _fDraggableDataContext = inject(FDraggableDataContext);
    handle(request) {
      if (!this._isValid()) {
        return;
      }
      this._fDraggableDataContext.draggableItems.forEach(x => {
        x.onPointerUp?.();
      });
    }
    _isValid() {
      return this._fDraggableDataContext.draggableItems.some(x => x instanceof SelectionAreaDragHandle);
    }
    static ɵfac = function SelectionAreaFinalizeExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SelectionAreaFinalizeExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SelectionAreaFinalizeExecution,
      factory: SelectionAreaFinalizeExecution.ɵfac
    });
  };
  SelectionAreaFinalizeExecution = __decorate([FExecutionRegister(SelectionAreaFinalizeRequest)], SelectionAreaFinalizeExecution);
  return SelectionAreaFinalizeExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class SelectionAreaPreparationRequest {
  event;
  fSelectionArea;
  fTrigger;
  constructor(event, fSelectionArea, fTrigger) {
    this.event = event;
    this.fSelectionArea = fSelectionArea;
    this.fTrigger = fTrigger;
  }
}
let SelectionAreaPreparationExecution = /*#__PURE__*/(() => {
  let SelectionAreaPreparationExecution = class SelectionAreaPreparationExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    get _fHost() {
      return this._fComponentsStore.fFlow.hostElement;
    }
    handle(request) {
      if (!this._isValid(request)) {
        return;
      }
      this._fDraggableDataContext.draggableItems = [new SelectionAreaDragHandle(this._fComponentsStore, request.fSelectionArea, this._fDraggableDataContext, this._fMediator)];
      this._fDraggableDataContext.onPointerDownScale = 1;
      this._fDraggableDataContext.onPointerDownPosition = Point.fromPoint(request.event.getPosition()).elementTransform(this._fHost);
    }
    _isValid(request) {
      return this._fDraggableDataContext.isEmpty() && isValidEventTrigger(request.event.originalEvent, request.fTrigger);
    }
    static ɵfac = function SelectionAreaPreparationExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SelectionAreaPreparationExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SelectionAreaPreparationExecution,
      factory: SelectionAreaPreparationExecution.ɵfac
    });
  };
  SelectionAreaPreparationExecution = __decorate([FExecutionRegister(SelectionAreaPreparationRequest)], SelectionAreaPreparationExecution);
  return SelectionAreaPreparationExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_SELECTION_AREA_DRAG_AND_DROP_PROVIDERS = [SelectionAreaPreparationExecution, SelectionAreaFinalizeExecution];
let FSelectionAreaBase = /*#__PURE__*/(() => {
  class FSelectionAreaBase {
    static ɵfac = function FSelectionAreaBase_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FSelectionAreaBase)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FSelectionAreaBase
    });
  }
  return FSelectionAreaBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FSelectionAreaComponent = /*#__PURE__*/(() => {
  class FSelectionAreaComponent extends FSelectionAreaBase {
    _fMediator = inject(FMediator);
    _elementReference = inject(ElementRef);
    fTrigger = event => {
      return event.shiftKey;
    };
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    ngOnInit() {
      this.hostElement.style.display = 'none';
    }
    hide() {
      this.hostElement.style.display = 'none';
    }
    show() {
      this.hostElement.style.display = 'block';
    }
    draw(object) {
      const style = this.hostElement.style;
      style.left = object.x + 'px';
      style.top = object.y + 'px';
      style.width = object.width + 'px';
      style.height = object.height + 'px';
    }
    onPointerDown(event) {
      this._fMediator.execute(new SelectionAreaPreparationRequest(event, this, this.fTrigger));
    }
    onPointerUp(event) {
      this._fMediator.execute(new SelectionAreaFinalizeRequest(event));
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFSelectionAreaComponent_BaseFactory;
      return function FSelectionAreaComponent_Factory(__ngFactoryType__) {
        return (ɵFSelectionAreaComponent_BaseFactory || (ɵFSelectionAreaComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FSelectionAreaComponent)))(__ngFactoryType__ || FSelectionAreaComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FSelectionAreaComponent,
      selectors: [["f-selection-area"]],
      hostAttrs: [1, "f-selection-area", "f-component"],
      inputs: {
        fTrigger: "fTrigger"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: F_BEFORE_MAIN_PLUGIN,
        useExisting: FSelectionAreaComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function FSelectionAreaComponent_Template(rf, ctx) {},
      styles: ["[_nghost-%COMP%]{position:absolute}"]
    });
  }
  return FSelectionAreaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_SELECTION_AREA_PROVIDERS = [FSelectionAreaComponent];
const F_DRAGGABLE_PROVIDERS = [...CANVAS_PROVIDERS, ...CONNECTIONS_PROVIDERS, ...DRAG_AND_DROP_COMMON_PROVIDERS, ...SINGLE_SELECT_PROVIDERS, ...F_EXTERNAL_ITEM_DRAG_AND_DROP_PROVIDERS, ...NODE_PROVIDERS, ...NODE_DROP_TO_GROUP_PROVIDERS, ...NODE_RESIZE_PROVIDERS, ...NODE_ROTATE_PROVIDERS, ...F_SELECTION_AREA_DRAG_AND_DROP_PROVIDERS, ...F_MINIMAP_DRAG_AND_DROP_PROVIDERS];
class ClearSelectionRequest {}
let ClearSelectionExecution = /*#__PURE__*/(() => {
  let ClearSelectionExecution = class ClearSelectionExecution {
    _fDraggableDataContext = inject(FDraggableDataContext);
    handle(request) {
      this._fDraggableDataContext.selectedItems.forEach(x => x.unmarkAsSelected());
      this._fDraggableDataContext.selectedItems = [];
      this._fDraggableDataContext.isSelectedChanged = true;
    }
    static ɵfac = function ClearSelectionExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ClearSelectionExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ClearSelectionExecution,
      factory: ClearSelectionExecution.ɵfac
    });
  };
  ClearSelectionExecution = __decorate([FExecutionRegister(ClearSelectionRequest)], ClearSelectionExecution);
  return ClearSelectionExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetCanBeSelectedItemsRequest {}
let GetCanBeSelectedItemsExecution = /*#__PURE__*/(() => {
  let GetCanBeSelectedItemsExecution = class GetCanBeSelectedItemsExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    get fNodes() {
      return this._fComponentsStore.fNodes;
    }
    get fConnections() {
      return this._fComponentsStore.fConnections;
    }
    get transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    handle() {
      return [...this.getNodesWithRects(), ...this.getConnectionsWithRects()].filter(x => {
        return !this._fDraggableDataContext.selectedItems.includes(x.element);
      });
    }
    getNodesWithRects() {
      return this.fNodes.filter(x => !x.fSelectionDisabled).map(x => {
        return {
          element: x,
          fRect: RectExtensions.mult(this._fMediator.execute(new GetNormalizedElementRectRequest(x.hostElement, false)), this.transform.scale)
        };
      });
    }
    getConnectionsWithRects() {
      return this.fConnections.filter(x => !x.fSelectionDisabled).map(x => {
        return {
          element: x,
          fRect: RectExtensions.mult(this._fMediator.execute(new GetNormalizedElementRectRequest(x.boundingElement, false)), this.transform.scale)
        };
      });
    }
    static ɵfac = function GetCanBeSelectedItemsExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetCanBeSelectedItemsExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetCanBeSelectedItemsExecution,
      factory: GetCanBeSelectedItemsExecution.ɵfac
    });
  };
  GetCanBeSelectedItemsExecution = __decorate([FExecutionRegister(GetCanBeSelectedItemsRequest)], GetCanBeSelectedItemsExecution);
  return GetCanBeSelectedItemsExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetCurrentSelectionRequest {}
let GetCurrentSelectionExecution = /*#__PURE__*/(() => {
  let GetCurrentSelectionExecution = class GetCurrentSelectionExecution {
    _fDraggableDataContext = inject(FDraggableDataContext);
    handle() {
      return {
        fNodeIds: this._getSelectedNodes(),
        fGroupIds: this._getSelectedGroups(),
        fConnectionIds: this._getSelectedConnections()
      };
    }
    _getSelectedNodes() {
      return this._fDraggableDataContext.selectedItems.filter(x => x.hostElement.classList.contains('f-node')).map(x => x.hostElement.dataset['fNodeId']);
    }
    _getSelectedGroups() {
      return this._fDraggableDataContext.selectedItems.filter(x => x.hostElement.classList.contains('f-group')).map(x => x.hostElement.dataset['fGroupId']);
    }
    _getSelectedConnections() {
      return this._fDraggableDataContext.selectedItems.filter(x => !x.hostElement.classList.contains('f-node') && !x.hostElement.classList.contains('f-group')).map(x => x.hostElement.id);
    }
    static ɵfac = function GetCurrentSelectionExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetCurrentSelectionExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetCurrentSelectionExecution,
      factory: GetCurrentSelectionExecution.ɵfac
    });
  };
  GetCurrentSelectionExecution = __decorate([FExecutionRegister(GetCurrentSelectionRequest)], GetCurrentSelectionExecution);
  return GetCurrentSelectionExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class SelectRequest {
  nodes;
  connections;
  constructor(nodes, connections) {
    this.nodes = nodes;
    this.connections = connections;
  }
}
let SelectExecution = /*#__PURE__*/(() => {
  let SelectExecution = class SelectExecution {
    _fDraggableDataContext = inject(FDraggableDataContext);
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fDraggableDataContext.selectedItems.forEach(x => {
        x.unmarkAsSelected();
      });
      this._fDraggableDataContext.selectedItems = [];
      request.nodes.forEach(key => {
        const node = this._fComponentsStore.fNodes.find(x => x.fId === key);
        if (node) {
          node.markAsSelected();
          this._fDraggableDataContext.selectedItems.push(node);
        }
      });
      request.connections.forEach(key => {
        const connection = this._fComponentsStore.fConnections.find(x => x.fId === key);
        if (connection) {
          connection.markAsSelected();
          this._fDraggableDataContext.selectedItems.push(connection);
        }
      });
      this._fDraggableDataContext.isSelectedChanged = true;
    }
    static ɵfac = function SelectExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SelectExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SelectExecution,
      factory: SelectExecution.ɵfac
    });
  };
  SelectExecution = __decorate([FExecutionRegister(SelectRequest)], SelectExecution);
  return SelectExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class SelectAllRequest {}
let SelectAllExecution = /*#__PURE__*/(() => {
  let SelectAllExecution = class SelectAllExecution {
    _fDraggableDataContext = inject(FDraggableDataContext);
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fDraggableDataContext.selectedItems.forEach(x => {
        x.unmarkAsSelected();
      });
      this._fDraggableDataContext.selectedItems = [];
      this._fComponentsStore.fNodes.forEach(x => {
        x.markAsSelected();
        this._fDraggableDataContext.selectedItems.push(x);
      });
      this._fComponentsStore.fConnections.forEach(x => {
        x.markAsSelected();
        this._fDraggableDataContext.selectedItems.push(x);
      });
      this._fDraggableDataContext.isSelectedChanged = true;
    }
    static ɵfac = function SelectAllExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SelectAllExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SelectAllExecution,
      factory: SelectAllExecution.ɵfac
    });
  };
  SelectAllExecution = __decorate([FExecutionRegister(SelectAllRequest)], SelectAllExecution);
  return SelectAllExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class SelectAndUpdateNodeLayerRequest {
  fNode;
  constructor(fNode) {
    this.fNode = fNode;
  }
}
class MoveFrontElementsBeforeTargetElementRequest {
  fItemsContainer;
  allElements;
  elementsThatShouldBeInFront;
  targetIndex;
  constructor(fItemsContainer,
  // fGroupsContainer || fNodesContainer || fConnectionsContainer
  allElements, elementsThatShouldBeInFront, targetIndex) {
    this.fItemsContainer = fItemsContainer;
    this.allElements = allElements;
    this.elementsThatShouldBeInFront = elementsThatShouldBeInFront;
    this.targetIndex = targetIndex;
  }
}
let MoveFrontElementsBeforeTargetElementExecution = /*#__PURE__*/(() => {
  let MoveFrontElementsBeforeTargetElementExecution = class MoveFrontElementsBeforeTargetElementExecution {
    handle(request) {
      const elementsToMove = [];
      for (let i = request.targetIndex + 1; i < request.allElements.length; i++) {
        const element = request.allElements[i];
        if (!request.elementsThatShouldBeInFront.includes(element)) {
          elementsToMove.push(element);
        }
      }
      elementsToMove.forEach(x => {
        request.fItemsContainer.removeChild(x);
        request.fItemsContainer.insertBefore(x, request.allElements[request.targetIndex]);
      });
    }
    static ɵfac = function MoveFrontElementsBeforeTargetElementExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MoveFrontElementsBeforeTargetElementExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MoveFrontElementsBeforeTargetElementExecution,
      factory: MoveFrontElementsBeforeTargetElementExecution.ɵfac
    });
  };
  MoveFrontElementsBeforeTargetElementExecution = __decorate([FExecutionRegister(MoveFrontElementsBeforeTargetElementRequest)], MoveFrontElementsBeforeTargetElementExecution);
  return MoveFrontElementsBeforeTargetElementExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class UpdateItemAndChildrenLayersRequest {
  item;
  itemContainer;
  constructor(item, itemContainer) {
    this.item = item;
    this.itemContainer = itemContainer;
  }
}
class GetDeepChildrenNodesAndGroupsRequest {
  fId;
  constructor(fId) {
    this.fId = fId;
  }
}
let GetDeepChildrenNodesAndGroupsExecution = /*#__PURE__*/(() => {
  let GetDeepChildrenNodesAndGroupsExecution = class GetDeepChildrenNodesAndGroupsExecution {
    fComponentsStore;
    constructor(fComponentsStore) {
      this.fComponentsStore = fComponentsStore;
    }
    handle(request) {
      return this.getChildrenNodes(request.fId);
    }
    getChildrenNodes(fId, visited = new Set()) {
      if (visited.has(fId)) {
        throw new Error('Circular reference detected in the node hierarchy. Node id: ' + fId);
      }
      visited.add(fId);
      const result = this.fComponentsStore.fNodes.filter(x => x.fParentId === fId);
      result.forEach(x => {
        result.push(...this.getChildrenNodes(x.fId, visited));
      });
      return result;
    }
    static ɵfac = function GetDeepChildrenNodesAndGroupsExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetDeepChildrenNodesAndGroupsExecution)(i0.ɵɵinject(FComponentsStore));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetDeepChildrenNodesAndGroupsExecution,
      factory: GetDeepChildrenNodesAndGroupsExecution.ɵfac
    });
  };
  GetDeepChildrenNodesAndGroupsExecution = __decorate([FExecutionRegister(GetDeepChildrenNodesAndGroupsRequest)], GetDeepChildrenNodesAndGroupsExecution);
  return GetDeepChildrenNodesAndGroupsExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UpdateItemAndChildrenLayersExecution = /*#__PURE__*/(() => {
  let UpdateItemAndChildrenLayersExecution = class UpdateItemAndChildrenLayersExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    get _fCanvas() {
      return this._fComponentsStore.fCanvas;
    }
    get _fGroupsContainer() {
      return this._fCanvas.fGroupsContainer().nativeElement;
    }
    get _fNodesContainer() {
      return this._fCanvas.fNodesContainer().nativeElement;
    }
    get _fConnectionsContainer() {
      return this._fCanvas.fConnectionsContainer().nativeElement;
    }
    handle(request) {
      switch (request.itemContainer) {
        case this._fGroupsContainer:
          this._handleGroup(request);
          break;
        case this._fNodesContainer:
          this._handleNode(request);
          break;
        case this._fConnectionsContainer:
          this._handleConnection(request);
          break;
        default:
          throw new Error('Unknown container');
      }
    }
    _handleGroup(request) {
      const childrenNodesAndGroups = this._getChildrenNodesAndGroups(request.item.fId);
      const childrenGroups = this._getChildrenGroups(childrenNodesAndGroups);
      this._updateLayers(this._fGroupsContainer, request.item.hostElement, childrenGroups);
      const childrenNodes = this._getChildrenNodes(childrenNodesAndGroups);
      if (childrenNodes.length) {
        this._updateLayers(this._fNodesContainer, childrenNodes[0], childrenNodes);
      }
    }
    _handleNode(request) {
      const childrenNodesAndGroups = this._getChildrenNodesAndGroups(request.item.fId);
      const childrenNodes = this._getChildrenNodes(childrenNodesAndGroups);
      this._updateLayers(request.itemContainer, request.item.hostElement, childrenNodes);
    }
    _handleConnection(request) {
      this._updateLayers(request.itemContainer, request.item.hostElement, []);
    }
    _updateLayers(itemContainer, item, elementsThatShouldBeInFront) {
      const allElements = Array.from(itemContainer.children);
      const targetIndex = allElements.findIndex(x => x === item);
      if (this._isAnythingNeedToBeMoved(allElements, targetIndex, elementsThatShouldBeInFront)) {
        this._fMediator.execute(new MoveFrontElementsBeforeTargetElementRequest(itemContainer, allElements, elementsThatShouldBeInFront, targetIndex));
      }
    }
    _isAnythingNeedToBeMoved(allElements, targetIndex, elementsThatShouldBeInFront) {
      for (let i = targetIndex + 1; i < allElements.length; i++) {
        if (!elementsThatShouldBeInFront.includes(allElements[i])) {
          return true;
        }
      }
      return false;
    }
    _getChildrenGroups(elements) {
      const allElements = Array.from(this._fGroupsContainer.children);
      return elements.filter(x => this._fGroupsContainer.contains(x)).sort((a, b) => allElements.indexOf(a) - allElements.indexOf(b));
    }
    _getChildrenNodes(elements) {
      const allElements = Array.from(this._fNodesContainer.children);
      return elements.filter(x => this._fNodesContainer.contains(x)).sort((a, b) => allElements.indexOf(a) - allElements.indexOf(b));
    }
    _getChildrenNodesAndGroups(fId) {
      return this._fMediator.execute(new GetDeepChildrenNodesAndGroupsRequest(fId)).map(x => x.hostElement);
    }
    static ɵfac = function UpdateItemAndChildrenLayersExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UpdateItemAndChildrenLayersExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UpdateItemAndChildrenLayersExecution,
      factory: UpdateItemAndChildrenLayersExecution.ɵfac
    });
  };
  UpdateItemAndChildrenLayersExecution = __decorate([FExecutionRegister(UpdateItemAndChildrenLayersRequest)], UpdateItemAndChildrenLayersExecution);
  return UpdateItemAndChildrenLayersExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SelectAndUpdateNodeLayerExecution = /*#__PURE__*/(() => {
  let SelectAndUpdateNodeLayerExecution = class SelectAndUpdateNodeLayerExecution {
    fDraggableDataContext;
    fMediator;
    constructor(fDraggableDataContext, fMediator) {
      this.fDraggableDataContext = fDraggableDataContext;
      this.fMediator = fMediator;
    }
    handle(request) {
      this.selectNodeIfNotSelected(request.fNode);
      this.fMediator.execute(new UpdateItemAndChildrenLayersRequest(request.fNode, request.fNode.hostElement.parentElement));
    }
    selectNodeIfNotSelected(fNode) {
      if (!this.fDraggableDataContext.selectedItems.includes(fNode) && !fNode.fSelectionDisabled) {
        this.fDraggableDataContext.selectedItems.push(fNode);
        fNode.markAsSelected();
        this.fDraggableDataContext.isSelectedChanged = true;
      }
    }
    static ɵfac = function SelectAndUpdateNodeLayerExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SelectAndUpdateNodeLayerExecution)(i0.ɵɵinject(FDraggableDataContext), i0.ɵɵinject(i2$1.FMediator));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SelectAndUpdateNodeLayerExecution,
      factory: SelectAndUpdateNodeLayerExecution.ɵfac
    });
  };
  SelectAndUpdateNodeLayerExecution = __decorate([FExecutionRegister(SelectAndUpdateNodeLayerRequest)], SelectAndUpdateNodeLayerExecution);
  return SelectAndUpdateNodeLayerExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_SELECTION_FEATURES = [ClearSelectionExecution, GetCanBeSelectedItemsExecution, GetCurrentSelectionExecution, SelectExecution, SelectAllExecution, SelectAndUpdateNodeLayerExecution];
let EmitSelectionChangeEventExecution = /*#__PURE__*/(() => {
  let EmitSelectionChangeEventExecution = class EmitSelectionChangeEventExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    get _fSelectionChange() {
      return this._fComponentsStore.fDraggable.fSelectionChange;
    }
    _fDraggableDataContext = inject(FDraggableDataContext);
    handle(request) {
      if (!this._fDraggableDataContext.isSelectedChanged) {
        return;
      }
      this._emitSelectionChange(this._getSelection());
      this._fDraggableDataContext.isSelectedChanged = false;
      this._fMediator.execute(new NotifyTransformChangedRequest());
    }
    _getSelection() {
      return this._fMediator.execute(new GetCurrentSelectionRequest());
    }
    _emitSelectionChange(selection) {
      this._fSelectionChange.emit(new FSelectionChangeEvent(selection.fNodeIds, selection.fGroupIds, selection.fConnectionIds));
    }
    static ɵfac = function EmitSelectionChangeEventExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || EmitSelectionChangeEventExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: EmitSelectionChangeEventExecution,
      factory: EmitSelectionChangeEventExecution.ɵfac
    });
  };
  EmitSelectionChangeEventExecution = __decorate([FExecutionRegister(EmitSelectionChangeEventRequest)], EmitSelectionChangeEventExecution);
  return EmitSelectionChangeEventExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class EndDragSequenceRequest {}
let EndDragSequenceExecution = /*#__PURE__*/(() => {
  let EndDragSequenceExecution = class EndDragSequenceExecution {
    _fComponentsStore = inject(FComponentsStore);
    get _hostElement() {
      return this._fComponentsStore.fDraggable.hostElement;
    }
    _fDraggableDataContext = inject(FDraggableDataContext);
    handle(request) {
      this._hostElement.classList.remove(F_CSS_CLASS.DRAG_AND_DROP.DRAGGING);
      this._fDraggableDataContext.reset();
      this._emitDragEnded();
    }
    _emitDragEnded() {
      this._fComponentsStore.fDraggable?.fDragEnded?.emit();
    }
    static ɵfac = function EndDragSequenceExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || EndDragSequenceExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: EndDragSequenceExecution,
      factory: EndDragSequenceExecution.ɵfac
    });
  };
  EndDragSequenceExecution = __decorate([FExecutionRegister(EndDragSequenceRequest)], EndDragSequenceExecution);
  return EndDragSequenceExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class OnPointerMoveRequest {
  event;
  constructor(event) {
    this.event = event;
  }
}
let OnPointerMoveExecution = /*#__PURE__*/(() => {
  let OnPointerMoveExecution = class OnPointerMoveExecution {
    _fComponentsStore = inject(FComponentsStore);
    get _hostElement() {
      return this._fComponentsStore.fDraggable.hostElement;
    }
    _fDraggableDataContext = inject(FDraggableDataContext);
    handle(request) {
      this._setDifferenceToDraggableItems(this._getDifferenceBetweenPointerAndPointerDown(request.event));
    }
    _setDifferenceToDraggableItems(difference) {
      this._fDraggableDataContext.draggableItems.forEach(item => {
        item.onPointerMove({
          ...difference
        });
      });
    }
    _getDifferenceBetweenPointerAndPointerDown(event) {
      return this._getPointerPositionInCanvas(event).div(this._fDraggableDataContext.onPointerDownScale).sub(this._fDraggableDataContext.onPointerDownPosition);
    }
    _getPointerPositionInCanvas(event) {
      return Point.fromPoint(event.getPosition()).elementTransform(this._hostElement);
    }
    static ɵfac = function OnPointerMoveExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OnPointerMoveExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OnPointerMoveExecution,
      factory: OnPointerMoveExecution.ɵfac
    });
  };
  OnPointerMoveExecution = __decorate([FExecutionRegister(OnPointerMoveRequest)], OnPointerMoveExecution);
  return OnPointerMoveExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class InitializeDragSequenceRequest {}
let InitializeDragSequenceExecution = /*#__PURE__*/(() => {
  let InitializeDragSequenceExecution = class InitializeDragSequenceExecution {
    _fDraggableDataContext = inject(FDraggableDataContext);
    handle(request) {
      this._fDraggableDataContext.reset();
    }
    static ɵfac = function InitializeDragSequenceExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InitializeDragSequenceExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: InitializeDragSequenceExecution,
      factory: InitializeDragSequenceExecution.ɵfac
    });
  };
  InitializeDragSequenceExecution = __decorate([FExecutionRegister(InitializeDragSequenceRequest)], InitializeDragSequenceExecution);
  return InitializeDragSequenceExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class IsDragStartedRequest {}
let IsDragStartedExecution = /*#__PURE__*/(() => {
  let IsDragStartedExecution = class IsDragStartedExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      return !!this._fComponentsStore.fDraggable?.isDragStarted;
    }
    static ɵfac = function IsDragStartedExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IsDragStartedExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IsDragStartedExecution,
      factory: IsDragStartedExecution.ɵfac
    });
  };
  IsDragStartedExecution = __decorate([FExecutionRegister(IsDragStartedRequest)], IsDragStartedExecution);
  return IsDragStartedExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PrepareDragSequenceRequest {}
class StartDragSequenceRequest {}
let StartDragSequenceExecution = /*#__PURE__*/(() => {
  let StartDragSequenceExecution = class StartDragSequenceExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fDraggableDataContext = inject(FDraggableDataContext);
    get _hostElement() {
      return this._fComponentsStore.fDraggable.hostElement;
    }
    handle(request) {
      if (this._fDraggableDataContext.draggableItems.length > 0) {
        this._hostElement.classList.add(F_CSS_CLASS.DRAG_AND_DROP.DRAGGING);
        this._fMediator.execute(new EmitSelectionChangeEventRequest());
        this._emitDragStarted();
      }
    }
    _emitDragStarted() {
      this._fComponentsStore.fDraggable?.fDragStarted?.emit({
        fEventType: this._fDraggableDataContext.draggableItems[0].fEventType,
        fData: {
          ...this._fDraggableDataContext.draggableItems[0].fData
        }
      });
    }
    static ɵfac = function StartDragSequenceExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StartDragSequenceExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: StartDragSequenceExecution,
      factory: StartDragSequenceExecution.ɵfac
    });
  };
  StartDragSequenceExecution = __decorate([FExecutionRegister(StartDragSequenceRequest)], StartDragSequenceExecution);
  return StartDragSequenceExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PrepareDragSequenceExecution = /*#__PURE__*/(() => {
  let PrepareDragSequenceExecution = class PrepareDragSequenceExecution {
    _fMediator = inject(FMediator);
    _fDraggableDataContext = inject(FDraggableDataContext);
    handle(request) {
      this._callPrepareDragSequence();
      this._fMediator.execute(new StartDragSequenceRequest());
    }
    _callPrepareDragSequence() {
      this._fDraggableDataContext.draggableItems.forEach(item => {
        item.prepareDragSequence?.();
      });
    }
    static ɵfac = function PrepareDragSequenceExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PrepareDragSequenceExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PrepareDragSequenceExecution,
      factory: PrepareDragSequenceExecution.ɵfac
    });
  };
  PrepareDragSequenceExecution = __decorate([FExecutionRegister(PrepareDragSequenceRequest)], PrepareDragSequenceExecution);
  return PrepareDragSequenceExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RemoveDndFromStoreRequest {}
let RemoveDndFromStoreExecution = /*#__PURE__*/(() => {
  let RemoveDndFromStoreExecution = class RemoveDndFromStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fDraggable = undefined;
    }
    static ɵfac = function RemoveDndFromStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveDndFromStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RemoveDndFromStoreExecution,
      factory: RemoveDndFromStoreExecution.ɵfac
    });
  };
  RemoveDndFromStoreExecution = __decorate([FExecutionRegister(RemoveDndFromStoreRequest)], RemoveDndFromStoreExecution);
  return RemoveDndFromStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_DRAGGABLE_FEATURES = [AddDndToStoreExecution, EmitSelectionChangeEventExecution, EndDragSequenceExecution, OnPointerMoveExecution, InitializeDragSequenceExecution, PrepareDragSequenceExecution, IsDragStartedExecution, StartDragSequenceExecution, RemoveDndFromStoreExecution];
class AddFlowToStoreRequest {
  fComponent;
  constructor(fComponent) {
    this.fComponent = fComponent;
  }
}
let AddFlowToStoreExecution = /*#__PURE__*/(() => {
  let AddFlowToStoreExecution = class AddFlowToStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fFlow = request.fComponent;
    }
    static ɵfac = function AddFlowToStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddFlowToStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddFlowToStoreExecution,
      factory: AddFlowToStoreExecution.ɵfac
    });
  };
  AddFlowToStoreExecution = __decorate([FExecutionRegister(AddFlowToStoreRequest)], AddFlowToStoreExecution);
  return AddFlowToStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetFlowRequest {}
let GetFlowExecution = /*#__PURE__*/(() => {
  let GetFlowExecution = class GetFlowExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      const result = this._fComponentsStore.fFlow;
      if (!result) {
        throw new Error(`Flow not found in store`);
      }
      return result;
    }
    static ɵfac = function GetFlowExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetFlowExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetFlowExecution,
      factory: GetFlowExecution.ɵfac
    });
  };
  GetFlowExecution = __decorate([FExecutionRegister(GetFlowRequest)], GetFlowExecution);
  return GetFlowExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetFlowHostElementRequest {}
let GetFlowHostElementExecution = /*#__PURE__*/(() => {
  let GetFlowHostElementExecution = class GetFlowHostElementExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle() {
      return this._fComponentsStore.flowHost;
    }
    static ɵfac = function GetFlowHostElementExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetFlowHostElementExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetFlowHostElementExecution,
      factory: GetFlowHostElementExecution.ɵfac
    });
  };
  GetFlowHostElementExecution = __decorate([FExecutionRegister(GetFlowHostElementRequest)], GetFlowHostElementExecution);
  return GetFlowHostElementExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetFlowStateConnectionsRequest {}
let GetFlowStateConnectionsExecution = /*#__PURE__*/(() => {
  let GetFlowStateConnectionsExecution = class GetFlowStateConnectionsExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      return this._fComponentsStore.fConnections.map(this._mapToConnectionState);
    }
    _mapToConnectionState(x) {
      return {
        id: x.fId,
        fOutputId: x.fOutputId,
        fInputId: x.fInputId,
        fType: x.fType,
        fBehavior: x.fBehavior,
        isSelected: x.isSelected()
      };
    }
    static ɵfac = function GetFlowStateConnectionsExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetFlowStateConnectionsExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetFlowStateConnectionsExecution,
      factory: GetFlowStateConnectionsExecution.ɵfac
    });
  };
  GetFlowStateConnectionsExecution = __decorate([FExecutionRegister(GetFlowStateConnectionsRequest)], GetFlowStateConnectionsExecution);
  return GetFlowStateConnectionsExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetFlowStateNodesRequest {
  type;
  constructor(type) {
    this.type = type;
  }
}
let GetFlowStateNodesExecution = /*#__PURE__*/(() => {
  let GetFlowStateNodesExecution = class GetFlowStateNodesExecution {
    fComponentsStore;
    constructor(fComponentsStore) {
      this.fComponentsStore = fComponentsStore;
    }
    handle(request) {
      return this.fComponentsStore.fNodes.filter(x => x instanceof request.type).map(x => {
        return {
          id: x.fId,
          parent: x.fParentId,
          position: x.position,
          size: x.size,
          fOutputs: this._getOutputs(x.hostElement),
          fInputs: this._getInputs(x.hostElement),
          isSelected: x.isSelected()
        };
      });
    }
    _getOutputs(hostElement) {
      return this.fComponentsStore.fOutputs.filter(x => hostElement.contains(x.hostElement)).map(x => {
        return {
          id: x.fId,
          fConnectableSide: x.fConnectableSide
        };
      });
    }
    _getInputs(hostElement) {
      return this.fComponentsStore.fInputs.filter(x => hostElement.contains(x.hostElement)).map(x => {
        return {
          id: x.fId,
          fConnectableSide: x.fConnectableSide
        };
      });
    }
    static ɵfac = function GetFlowStateNodesExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetFlowStateNodesExecution)(i0.ɵɵinject(FComponentsStore));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetFlowStateNodesExecution,
      factory: GetFlowStateNodesExecution.ɵfac
    });
  };
  GetFlowStateNodesExecution = __decorate([FExecutionRegister(GetFlowStateNodesRequest)], GetFlowStateNodesExecution);
  return GetFlowStateNodesExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetFlowStateRequest {}
let GetFlowStateExecution = /*#__PURE__*/(() => {
  let GetFlowStateExecution = class GetFlowStateExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    handle(payload) {
      return {
        position: this._getCanvasPosition(this._fComponentsStore.fCanvas.transform),
        scale: this._fComponentsStore.fCanvas.transform.scale,
        nodes: this._fMediator.execute(new GetFlowStateNodesRequest(FNodeDirective)),
        groups: this._fMediator.execute(new GetFlowStateNodesRequest(FGroupDirective)),
        connections: this._fMediator.execute(new GetFlowStateConnectionsRequest())
      };
    }
    _getCanvasPosition(transform) {
      return PointExtensions.sum(transform.position, transform.scaledPosition);
    }
    static ɵfac = function GetFlowStateExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetFlowStateExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetFlowStateExecution,
      factory: GetFlowStateExecution.ɵfac
    });
  };
  GetFlowStateExecution = __decorate([FExecutionRegister(GetFlowStateRequest)], GetFlowStateExecution);
  return GetFlowStateExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const GET_FLOW_STATE_PROVIDERS = [GetFlowStateExecution, GetFlowStateNodesExecution, GetFlowStateConnectionsExecution];
class RemoveFlowFromStoreRequest {}
let RemoveFlowFromStoreExecution = /*#__PURE__*/(() => {
  let RemoveFlowFromStoreExecution = class RemoveFlowFromStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fFlow = undefined;
    }
    static ɵfac = function RemoveFlowFromStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveFlowFromStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RemoveFlowFromStoreExecution,
      factory: RemoveFlowFromStoreExecution.ɵfac
    });
  };
  RemoveFlowFromStoreExecution = __decorate([FExecutionRegister(RemoveFlowFromStoreRequest)], RemoveFlowFromStoreExecution);
  return RemoveFlowFromStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_FLOW_FEATURES = [AddFlowToStoreExecution, GetFlowExecution, GetFlowHostElementExecution, ...GET_FLOW_STATE_PROVIDERS, RemoveFlowFromStoreExecution];
class AddLineAlignmentToStoreRequest {
  fComponent;
  constructor(fComponent) {
    this.fComponent = fComponent;
  }
}
let AddLineAlignmentToStoreExecution = /*#__PURE__*/(() => {
  let AddLineAlignmentToStoreExecution = class AddLineAlignmentToStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fLineAlignment = request.fComponent;
    }
    static ɵfac = function AddLineAlignmentToStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddLineAlignmentToStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddLineAlignmentToStoreExecution,
      factory: AddLineAlignmentToStoreExecution.ɵfac
    });
  };
  AddLineAlignmentToStoreExecution = __decorate([FExecutionRegister(AddLineAlignmentToStoreRequest)], AddLineAlignmentToStoreExecution);
  return AddLineAlignmentToStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RemoveLineAlignmentFromStoreRequest {}
let RemoveLineAlignmentFromStoreExecution = /*#__PURE__*/(() => {
  let RemoveLineAlignmentFromStoreExecution = class RemoveLineAlignmentFromStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fLineAlignment = undefined;
    }
    static ɵfac = function RemoveLineAlignmentFromStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveLineAlignmentFromStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RemoveLineAlignmentFromStoreExecution,
      factory: RemoveLineAlignmentFromStoreExecution.ɵfac
    });
  };
  RemoveLineAlignmentFromStoreExecution = __decorate([FExecutionRegister(RemoveLineAlignmentFromStoreRequest)], RemoveLineAlignmentFromStoreExecution);
  return RemoveLineAlignmentFromStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_LINE_ALIGNMENT_FEATURES = [AddLineAlignmentToStoreExecution, RemoveLineAlignmentFromStoreExecution];
class AddNodeToStoreRequest {
  fComponent;
  constructor(fComponent) {
    this.fComponent = fComponent;
  }
}
let AddNodeToStoreExecution = /*#__PURE__*/(() => {
  let AddNodeToStoreExecution = class AddNodeToStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.addComponent(this._fComponentsStore.fNodes, request.fComponent);
    }
    static ɵfac = function AddNodeToStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddNodeToStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddNodeToStoreExecution,
      factory: AddNodeToStoreExecution.ɵfac
    });
  };
  AddNodeToStoreExecution = __decorate([FExecutionRegister(AddNodeToStoreRequest)], AddNodeToStoreExecution);
  return AddNodeToStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CalculateInputConnectionsRequest {
  fNode;
  constructor(fNode) {
    this.fNode = fNode;
  }
}
let CalculateInputConnectionsExecution = /*#__PURE__*/(() => {
  let CalculateInputConnectionsExecution = class CalculateInputConnectionsExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      return this._calculateConnections(new Set(this._calculateConnectors(request.fNode)));
    }
    _calculateConnectors(fNode) {
      return this._fComponentsStore.fInputs.filter(x => fNode.isContains(x.hostElement)).map(x => x.fId);
    }
    _calculateConnections(ids) {
      return this._fComponentsStore.fConnections.filter(x => ids.has(x.fInputId));
    }
    static ɵfac = function CalculateInputConnectionsExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalculateInputConnectionsExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CalculateInputConnectionsExecution,
      factory: CalculateInputConnectionsExecution.ɵfac
    });
  };
  CalculateInputConnectionsExecution = __decorate([FExecutionRegister(CalculateInputConnectionsRequest)], CalculateInputConnectionsExecution);
  return CalculateInputConnectionsExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CalculateNodesBoundingBoxRequest {}
let CalculateNodesBoundingBoxExecution = /*#__PURE__*/(() => {
  let CalculateNodesBoundingBoxExecution = class CalculateNodesBoundingBoxExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      return RectExtensions.union(this._getNodesRects());
    }
    _getNodesRects() {
      return this._fComponentsStore.fNodes.map(x => {
        return this._getElementRect(x.hostElement);
      });
    }
    _getElementRect(element) {
      return RectExtensions.fromElement(element);
    }
    static ɵfac = function CalculateNodesBoundingBoxExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalculateNodesBoundingBoxExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CalculateNodesBoundingBoxExecution,
      factory: CalculateNodesBoundingBoxExecution.ɵfac
    });
  };
  CalculateNodesBoundingBoxExecution = __decorate([FExecutionRegister(CalculateNodesBoundingBoxRequest)], CalculateNodesBoundingBoxExecution);
  return CalculateNodesBoundingBoxExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CalculateNodesBoundingBoxNormalizedPositionRequest {
  fNodes;
  constructor(fNodes) {
    this.fNodes = fNodes;
  }
}
let CalculateNodesBoundingBoxNormalizedPositionExecution = /*#__PURE__*/(() => {
  let CalculateNodesBoundingBoxNormalizedPositionExecution = class CalculateNodesBoundingBoxNormalizedPositionExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      return RectExtensions.union(this._getNodesRects(request.fNodes || this._fComponentsStore.fNodes));
    }
    _getNodesRects(fNodes) {
      return fNodes.map(x => {
        return this._getElementRect(x, RectExtensions.fromElement(x.hostElement));
      });
    }
    _getElementRect(fNode, rect) {
      return RectExtensions.initialize(fNode.position.x, fNode.position.y, rect.width, rect.height);
    }
    static ɵfac = function CalculateNodesBoundingBoxNormalizedPositionExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalculateNodesBoundingBoxNormalizedPositionExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CalculateNodesBoundingBoxNormalizedPositionExecution,
      factory: CalculateNodesBoundingBoxNormalizedPositionExecution.ɵfac
    });
  };
  CalculateNodesBoundingBoxNormalizedPositionExecution = __decorate([FExecutionRegister(CalculateNodesBoundingBoxNormalizedPositionRequest)], CalculateNodesBoundingBoxNormalizedPositionExecution);
  return CalculateNodesBoundingBoxNormalizedPositionExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CalculateOutputConnectionsRequest {
  fNode;
  constructor(fNode) {
    this.fNode = fNode;
  }
}
let CalculateOutputConnectionsExecution = /*#__PURE__*/(() => {
  let CalculateOutputConnectionsExecution = class CalculateOutputConnectionsExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      return this._calculateConnections(new Set(this._calculateConnectors(request.fNode)));
    }
    _calculateConnectors(fNode) {
      return this._fComponentsStore.fOutputs.filter(x => fNode.isContains(x.hostElement)).map(x => x.fId);
    }
    _calculateConnections(ids) {
      return this._fComponentsStore.fConnections.filter(x => ids.has(x.fOutputId));
    }
    static ɵfac = function CalculateOutputConnectionsExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CalculateOutputConnectionsExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CalculateOutputConnectionsExecution,
      factory: CalculateOutputConnectionsExecution.ɵfac
    });
  };
  CalculateOutputConnectionsExecution = __decorate([FExecutionRegister(CalculateOutputConnectionsRequest)], CalculateOutputConnectionsExecution);
  return CalculateOutputConnectionsExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetNodePaddingRequest {
  fNode;
  rect;
  constructor(fNode, rect) {
    this.fNode = fNode;
    this.rect = rect;
  }
}
let GetNodePaddingExecution = /*#__PURE__*/(() => {
  let GetNodePaddingExecution = class GetNodePaddingExecution {
    fBrowser;
    constructor(fBrowser) {
      this.fBrowser = fBrowser;
    }
    handle(request) {
      return request.fNode.fIncludePadding ? this.getPaddingData(request.fNode, request.rect) : [0, 0, 0, 0];
    }
    getPaddingData(node, rect) {
      const style = this.fBrowser.window.getComputedStyle(node.hostElement);
      return [this.fBrowser.toPixels(style.paddingLeft, rect.width, rect.height, style.fontSize), this.fBrowser.toPixels(style.paddingTop, rect.width, rect.height, style.fontSize), this.fBrowser.toPixels(style.paddingRight, rect.width, rect.height, style.fontSize), this.fBrowser.toPixels(style.paddingBottom, rect.width, rect.height, style.fontSize)];
    }
    static ɵfac = function GetNodePaddingExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetNodePaddingExecution)(i0.ɵɵinject(i1.BrowserService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetNodePaddingExecution,
      factory: GetNodePaddingExecution.ɵfac
    });
  };
  GetNodePaddingExecution = __decorate([FExecutionRegister(GetNodePaddingRequest)], GetNodePaddingExecution);
  return GetNodePaddingExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetNodesRequest {}
let GetNodesExecution = /*#__PURE__*/(() => {
  let GetNodesExecution = class GetNodesExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      return this._fComponentsStore.fNodes;
    }
    static ɵfac = function GetNodesExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetNodesExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetNodesExecution,
      factory: GetNodesExecution.ɵfac
    });
  };
  GetNodesExecution = __decorate([FExecutionRegister(GetNodesRequest)], GetNodesExecution);
  return GetNodesExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GetParentNodesRequest {
  fNode;
  constructor(fNode) {
    this.fNode = fNode;
  }
}
let GetParentNodesExecution = /*#__PURE__*/(() => {
  let GetParentNodesExecution = class GetParentNodesExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      return this._getParentNodes(request.fNode, new Set(), []);
    }
    _getParentNodes(fNode, visited, result) {
      if (visited.has(fNode.fId)) {
        throw new Error('Circular reference detected in the node hierarchy. Node id: ' + fNode.fId);
      }
      visited.add(fNode.fId);
      const parent = this._fComponentsStore.fNodes.find(x => x.fId === fNode.fParentId);
      if (!parent) {
        return result;
      }
      result.push(parent);
      return this._getParentNodes(parent, visited, result);
    }
    static ɵfac = function GetParentNodesExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetParentNodesExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetParentNodesExecution,
      factory: GetParentNodesExecution.ɵfac
    });
  };
  GetParentNodesExecution = __decorate([FExecutionRegister(GetParentNodesRequest)], GetParentNodesExecution);
  return GetParentNodesExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class UpdateNodeWhenStateOrSizeChangedRequest {
  fComponent;
  destroyRef;
  constructor(fComponent, destroyRef) {
    this.fComponent = fComponent;
    this.destroyRef = destroyRef;
  }
}
let UpdateNodeWhenStateOrSizeChangedExecution = /*#__PURE__*/(() => {
  let UpdateNodeWhenStateOrSizeChangedExecution = class UpdateNodeWhenStateOrSizeChangedExecution {
    _fMediator = inject(FMediator);
    handle(request) {
      const {
        hostElement,
        connectors,
        stateChanges
      } = request.fComponent;
      new FChannelHub(new FResizeChannel(hostElement), stateChanges).pipe(notifyOnStart(), debounceTime(10)).listen(request.destroyRef, () => {
        this._calculateConnectorsConnectableSide(connectors, hostElement);
        this._fMediator.execute(new NotifyDataChangedRequest());
      });
    }
    _calculateConnectorsConnectableSide(fConnectors, fNodeHost) {
      fConnectors.forEach(x => {
        x.fConnectableSide = this._calculateConnectorConnectableSide(x, fNodeHost);
      });
    }
    _calculateConnectorConnectableSide(fConnector, fNodeHost) {
      let result;
      if (fConnector.userFConnectableSide === EFConnectableSide.AUTO) {
        result = this._getSideByDelta(fConnector.hostElement, fNodeHost);
      } else {
        result = fConnector.userFConnectableSide;
      }
      return result;
    }
    _getSideByDelta(fConnectorHost, fNodeHost) {
      let result;
      const childRect = RectExtensions.fromElement(fConnectorHost);
      const parentRect = fNodeHost.getBoundingClientRect();
      const deltaLeft = childRect.gravityCenter.x - parentRect.left;
      const deltaRight = parentRect.right - childRect.gravityCenter.x;
      const deltaTop = childRect.gravityCenter.y - parentRect.top;
      const deltaBottom = parentRect.bottom - childRect.gravityCenter.y;
      const minDelta = Math.min(deltaLeft, deltaRight, deltaTop, deltaBottom);
      if (minDelta === deltaLeft) {
        result = EFConnectableSide.LEFT;
      } else if (minDelta === deltaRight) {
        result = EFConnectableSide.RIGHT;
      } else if (minDelta === deltaTop) {
        result = EFConnectableSide.TOP;
      } else {
        result = EFConnectableSide.BOTTOM;
      }
      return result;
    }
    static ɵfac = function UpdateNodeWhenStateOrSizeChangedExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UpdateNodeWhenStateOrSizeChangedExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UpdateNodeWhenStateOrSizeChangedExecution,
      factory: UpdateNodeWhenStateOrSizeChangedExecution.ɵfac
    });
  };
  UpdateNodeWhenStateOrSizeChangedExecution = __decorate([FExecutionRegister(UpdateNodeWhenStateOrSizeChangedRequest)], UpdateNodeWhenStateOrSizeChangedExecution);
  return UpdateNodeWhenStateOrSizeChangedExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RemoveNodeFromStoreRequest {
  fComponent;
  constructor(fComponent) {
    this.fComponent = fComponent;
  }
}
let RemoveNodeFromStoreExecution = /*#__PURE__*/(() => {
  let RemoveNodeFromStoreExecution = class RemoveNodeFromStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.removeComponent(this._fComponentsStore.fNodes, request.fComponent);
    }
    static ɵfac = function RemoveNodeFromStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveNodeFromStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RemoveNodeFromStoreExecution,
      factory: RemoveNodeFromStoreExecution.ɵfac
    });
  };
  RemoveNodeFromStoreExecution = __decorate([FExecutionRegister(RemoveNodeFromStoreRequest)], RemoveNodeFromStoreExecution);
  return RemoveNodeFromStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_NODE_FEATURES = [AddNodeToStoreExecution, CalculateInputConnectionsExecution, CalculateNodesBoundingBoxExecution, CalculateNodesBoundingBoxNormalizedPositionExecution, CalculateOutputConnectionsExecution, GetNodePaddingExecution, GetNodesExecution, GetParentNodesExecution, UpdateNodeWhenStateOrSizeChangedExecution, RemoveNodeFromStoreExecution];
class AddZoomToStoreRequest {
  fComponent;
  constructor(fComponent) {
    this.fComponent = fComponent;
  }
}
const F_ZOOM_TAG = 'F_ZOOM';
let AddZoomToStoreExecution = /*#__PURE__*/(() => {
  let AddZoomToStoreExecution = class AddZoomToStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fComponents = {
        [F_ZOOM_TAG]: request.fComponent
      };
    }
    static ɵfac = function AddZoomToStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddZoomToStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddZoomToStoreExecution,
      factory: AddZoomToStoreExecution.ɵfac
    });
  };
  AddZoomToStoreExecution = __decorate([FExecutionRegister(AddZoomToStoreRequest)], AddZoomToStoreExecution);
  return AddZoomToStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class RemoveZoomFromStoreRequest {}
let RemoveZoomFromStoreExecution = /*#__PURE__*/(() => {
  let RemoveZoomFromStoreExecution = class RemoveZoomFromStoreExecution {
    _fComponentsStore = inject(FComponentsStore);
    handle(request) {
      this._fComponentsStore.fComponents = {
        [F_ZOOM_TAG]: undefined
      };
    }
    static ɵfac = function RemoveZoomFromStoreExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RemoveZoomFromStoreExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RemoveZoomFromStoreExecution,
      factory: RemoveZoomFromStoreExecution.ɵfac
    });
  };
  RemoveZoomFromStoreExecution = __decorate([FExecutionRegister(RemoveZoomFromStoreRequest)], RemoveZoomFromStoreExecution);
  return RemoveZoomFromStoreExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ResetZoomRequest {}
let ResetZoomExecution = /*#__PURE__*/(() => {
  let ResetZoomExecution = class ResetZoomExecution {
    _fComponentsStore = inject(FComponentsStore);
    get _fCanvas() {
      return this._fComponentsStore.fCanvas;
    }
    handle(request) {
      this._fCanvas.resetScale();
      this._fCanvas.redraw();
      this._fCanvas.emitCanvasChangeEvent();
    }
    static ɵfac = function ResetZoomExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ResetZoomExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ResetZoomExecution,
      factory: ResetZoomExecution.ɵfac
    });
  };
  ResetZoomExecution = __decorate([FExecutionRegister(ResetZoomRequest)], ResetZoomExecution);
  return ResetZoomExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class SetZoomRequest {
  position;
  step;
  direction;
  animate;
  constructor(position, step, direction, animate = false) {
    this.position = position;
    this.step = step;
    this.direction = direction;
    this.animate = animate;
  }
}
let SetZoomExecution = /*#__PURE__*/(() => {
  let SetZoomExecution = class SetZoomExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    get _fHost() {
      return this._fComponentsStore.fFlow?.hostElement;
    }
    get _fCanvas() {
      return this._fComponentsStore.fCanvas;
    }
    get _fZoomComponent() {
      return this._fComponentsStore.fComponents[F_ZOOM_TAG];
    }
    get _isDragStarted() {
      return this._fMediator.execute(new IsDragStartedRequest());
    }
    handle(request) {
      if (this._isDragStarted || !this._fZoomComponent) {
        return;
      }
      const result = this._fCanvas.transform.scale + request.step * request.direction;
      this._fCanvas.setScale(this._clamp(result), this._castPositionToFlow(request.position));
      request.animate ? this._fCanvas.redrawWithAnimation() : this._fCanvas.redraw();
      this._fCanvas.emitCanvasChangeEvent();
    }
    _clamp(value) {
      return Math.max(this._fZoomComponent.minimum, Math.min(value, this._fZoomComponent.maximum));
    }
    _castPositionToFlow(position) {
      return Point.fromPoint(position).elementTransform(this._fHost);
    }
    static ɵfac = function SetZoomExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SetZoomExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SetZoomExecution,
      factory: SetZoomExecution.ɵfac
    });
  };
  SetZoomExecution = __decorate([FExecutionRegister(SetZoomRequest)], SetZoomExecution);
  return SetZoomExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_ZOOM_FEATURES = [AddZoomToStoreExecution, RemoveZoomFromStoreExecution, ResetZoomExecution, SetZoomExecution];
class GetNormalizedPointRequest {
  position;
  constructor(position) {
    this.position = position;
  }
}
let GetNormalizedPointExecution = /*#__PURE__*/(() => {
  let GetNormalizedPointExecution = class GetNormalizedPointExecution {
    _fComponentsStore = inject(FComponentsStore);
    get _transform() {
      return this._fComponentsStore.fCanvas.transform;
    }
    handle(request) {
      return Point.fromPoint(request.position).elementTransform(this._fComponentsStore.flowHost).sub(this._transform.scaledPosition).sub(this._transform.position).div(this._transform.scale);
    }
    static ɵfac = function GetNormalizedPointExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GetNormalizedPointExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GetNormalizedPointExecution,
      factory: GetNormalizedPointExecution.ɵfac
    });
  };
  GetNormalizedPointExecution = __decorate([FExecutionRegister(GetNormalizedPointRequest)], GetNormalizedPointExecution);
  return GetNormalizedPointExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class SortNodeLayersRequest {}
let SortNodeLayersExecution = /*#__PURE__*/(() => {
  let SortNodeLayersExecution = class SortNodeLayersExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fBrowser = inject(BrowserService);
    get _fCanvas() {
      return this._fComponentsStore.fCanvas;
    }
    get _fGroupsContainer() {
      return this._fCanvas.fGroupsContainer().nativeElement;
    }
    get _fNodesContainer() {
      return this._fCanvas.fNodesContainer().nativeElement;
    }
    get _fNodeElements() {
      return Array.from(this._fNodesContainer.children);
    }
    handle(request) {
      this._getGroups().forEach(parent => {
        this._moveChildrenNodes(this._getSortedChildrenNodes(parent));
      });
    }
    _getGroups() {
      return this._fComponentsStore.fNodes.filter(x => this._fGroupsContainer.contains(x.hostElement));
    }
    _getSortedChildrenNodes(parent) {
      const allElements = this._fNodeElements;
      return this._getChildrenNodes(parent.fId).sort((a, b) => allElements.indexOf(a) - allElements.indexOf(b));
    }
    _getChildrenNodes(fId) {
      return this._fMediator.execute(new GetDeepChildrenNodesAndGroupsRequest(fId)).filter(x => this._fNodesContainer.contains(x.hostElement)).map(x => x.hostElement);
    }
    _moveChildrenNodes(sortedChildrenGroups) {
      const fragment = this._fBrowser.document.createDocumentFragment();
      sortedChildrenGroups.forEach(childGroup => {
        fragment.appendChild(childGroup); // Append automatically removes the element from its current position
      });
      this._fNodesContainer.appendChild(fragment);
    }
    static ɵfac = function SortNodeLayersExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SortNodeLayersExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SortNodeLayersExecution,
      factory: SortNodeLayersExecution.ɵfac
    });
  };
  SortNodeLayersExecution = __decorate([FExecutionRegister(SortNodeLayersRequest)], SortNodeLayersExecution);
  return SortNodeLayersExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class SortItemsByParentRequest {
  fItemsContainer;
  constructor(fItemsContainer // fGroupsContainer || fNodesContainer
  ) {
    this.fItemsContainer = fItemsContainer;
  }
}
let SortItemsByParentExecution = /*#__PURE__*/(() => {
  let SortItemsByParentExecution = class SortItemsByParentExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    _fBrowser = inject(BrowserService);
    _fItemsContainer;
    get _fItemElements() {
      return Array.from(this._fItemsContainer.children);
    }
    handle(request) {
      this._fItemsContainer = request.fItemsContainer;
      this._getItemsOfContainer().forEach(fItem => {
        this._moveChildrenItems(this._getSortedChildrenItems(fItem), fItem);
      });
    }
    _getItemsOfContainer() {
      return this._fComponentsStore.fNodes.filter(x => this._fItemsContainer.contains(x.hostElement));
    }
    _getSortedChildrenItems(fItem) {
      const indexInContainer = this._fItemElements.indexOf(fItem.hostElement);
      return this._getChildrenItems(fItem.fId).filter(child => this._fItemElements.indexOf(child) < indexInContainer).sort((a, b) => this._fItemElements.indexOf(a) - this._fItemElements.indexOf(b));
    }
    _getChildrenItems(fId) {
      return this._fMediator.execute(new GetDeepChildrenNodesAndGroupsRequest(fId)).filter(x => this._fItemsContainer.contains(x.hostElement)).map(x => x.hostElement);
    }
    _moveChildrenItems(sortedChildrenItems, parent) {
      let nextSibling = parent.hostElement.nextElementSibling;
      const fragment = this._fBrowser.document.createDocumentFragment();
      sortedChildrenItems.forEach(child => {
        fragment.appendChild(child); // Append automatically removes the element from its current position
      });
      this._fItemsContainer.insertBefore(fragment, nextSibling);
    }
    static ɵfac = function SortItemsByParentExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SortItemsByParentExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SortItemsByParentExecution,
      factory: SortItemsByParentExecution.ɵfac
    });
  };
  SortItemsByParentExecution = __decorate([FExecutionRegister(SortItemsByParentRequest)], SortItemsByParentExecution);
  return SortItemsByParentExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class SortItemLayersRequest {}
let SortItemLayersExecution = /*#__PURE__*/(() => {
  let SortItemLayersExecution = class SortItemLayersExecution {
    _fMediator = inject(FMediator);
    _fComponentsStore = inject(FComponentsStore);
    get _fCanvas() {
      return this._fComponentsStore.fCanvas;
    }
    handle(request) {
      if (!this._fComponentsStore.fCanvas) {
        return;
      }
      this._fMediator.execute(new SortItemsByParentRequest(this._fCanvas.fGroupsContainer().nativeElement));
      this._fMediator.execute(new SortNodeLayersRequest());
      this._fMediator.execute(new SortItemsByParentRequest(this._fCanvas.fNodesContainer().nativeElement));
    }
    static ɵfac = function SortItemLayersExecution_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SortItemLayersExecution)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SortItemLayersExecution,
      factory: SortItemLayersExecution.ɵfac
    });
  };
  SortItemLayersExecution = __decorate([FExecutionRegister(SortItemLayersRequest)], SortItemLayersExecution);
  return SortItemLayersExecution;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function createSVGElement(tag, fBrowser) {
  return fBrowser.document.createElementNS('http://www.w3.org/2000/svg', tag);
}
function isValidEventTrigger(event, fTrigger) {
  return fTrigger(event);
}
function defaultEventTrigger(event) {
  return true;
}
function isMobile() {
  // @ts-ignore
  return /android|iPad|iPhone|iPod/i.test(navigator.userAgent || navigator.vendor || window['opera']);
}
function Deprecated(newMethodName, removalVersion = '18.0.0') {
  return function (target, propertyKey, descriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args) {
      console.warn(`Method "${String(propertyKey)}" is deprecated. Use "${newMethodName}" instead. This method will be removed in version ${removalVersion}.`);
      return originalMethod.apply(this, args);
    };
    return descriptor;
  };
}
function LogExecutionTime(label) {
  return function (target, propertyKey, descriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args) {
      console.time(label || String(propertyKey));
      const result = originalMethod.apply(this, args);
      if (result instanceof Promise) {
        return result.finally(() => console.timeEnd(label || String(propertyKey)));
      }
      console.timeEnd(label || String(propertyKey));
      return result;
    };
    return descriptor;
  };
}
const COMMON_PROVIDERS = [...F_CANVAS_FEATURES, ...F_CONNECTION_FEATURES, ...F_BACKGROUND_FEATURES, ...F_CONNECTORS_FEATURES, ...F_DRAGGABLE_FEATURES, ...F_FLOW_FEATURES, ...F_LINE_ALIGNMENT_FEATURES, ...F_NODE_FEATURES, GetElementRoundedRectExecution, ...F_SELECTION_FEATURES, ...F_ZOOM_FEATURES, GetDeepChildrenNodesAndGroupsExecution, GetNormalizedElementRectExecution, GetNormalizedPointExecution, SortItemLayersExecution, SortItemsByParentExecution, SortNodeLayersExecution, UpdateItemAndChildrenLayersExecution, MoveFrontElementsBeforeTargetElementExecution];
let uniqueId$2 = 0;
let FRectPatternComponent = /*#__PURE__*/(() => {
  class FRectPatternComponent {
    _destroyRef = inject(DestroyRef);
    _elementReference = inject(ElementRef);
    _fBrowser = inject(BrowserService);
    _stateChanges = new FChannel();
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    id = input(`f-pattern-${uniqueId$2++}`);
    vColor = input('rgba(0,0,0,0.1)');
    hColor = input('rgba(0,0,0,0.1)');
    vSize = input(20, {
      transform: numberAttribute
    });
    hSize = input(20, {
      transform: numberAttribute
    });
    _transform = TransformModelExtensions.default();
    _position = PointExtensions.initialize();
    _size = SizeExtensions.initialize(this.hSize(), this.vSize());
    _pattern;
    _vLine;
    _hLine;
    constructor() {
      this._createPattern();
    }
    _createPattern() {
      this._pattern = createSVGElement('pattern', this._fBrowser);
      this._pattern.setAttribute('patternUnits', 'userSpaceOnUse');
      this.hostElement.appendChild(this._pattern);
      this._vLine = createSVGElement('line', this._fBrowser);
      this._pattern.appendChild(this._vLine);
      this._hLine = createSVGElement('line', this._fBrowser);
      this._pattern.appendChild(this._hLine);
    }
    ngOnInit() {
      this._listenStateChanges();
    }
    _listenStateChanges() {
      new FChannelHub(this._stateChanges).pipe(notifyOnStart()).listen(this._destroyRef, () => this._redraw());
    }
    ngOnChanges(changes) {
      if (changes['vSize'] || changes['hSize'] || changes['vColor'] || changes['hColor']) {
        this._refresh();
      }
    }
    _redraw() {
      this._calculatePattern();
      this._redrawPattern();
      this.redrawLine(this._vLine, this.vColor(), this._size.width, 0, this._size.width, this._size.height);
      this.redrawLine(this._hLine, this.hColor(), 0, this._size.height, this._size.width, this._size.height);
    }
    _calculatePattern() {
      this._position.x = this._transform.position.x + this._transform.scaledPosition.x;
      this._position.y = this._transform.position.y + this._transform.scaledPosition.y;
      this._size = SizeExtensions.initialize(this.hSize() * this._transform.scale, this.vSize() * this._transform.scale);
    }
    _redrawPattern() {
      this._pattern.setAttribute('x', `${this._position.x}`);
      this._pattern.setAttribute('y', `${this._position.y}`);
      this._pattern.setAttribute('width', `${this._size.width}`);
      this._pattern.setAttribute('height', `${this._size.height}`);
    }
    redrawLine(line, color, x1, y1, x2, y2) {
      line.setAttribute('stroke', `${color}`);
      line.setAttribute('x1', `${x1}`);
      line.setAttribute('x2', `${x2}`);
      line.setAttribute('y1', `${y1}`);
      line.setAttribute('y2', `${y2}`);
    }
    setTransform(transform) {
      this._transform = transform;
      this._refresh();
    }
    _refresh() {
      this._stateChanges.notify();
    }
    static ɵfac = function FRectPatternComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FRectPatternComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FRectPatternComponent,
      selectors: [["f-rect-pattern"]],
      hostVars: 1,
      hostBindings: function FRectPatternComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.id);
        }
      },
      inputs: {
        id: [1, "id"],
        vColor: [1, "vColor"],
        hColor: [1, "hColor"],
        vSize: [1, "vSize"],
        hSize: [1, "hSize"]
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: F_BACKGROUND_PATTERN,
        useExisting: FRectPatternComponent
      }]), i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      decls: 0,
      vars: 0,
      template: function FRectPatternComponent_Template(rf, ctx) {},
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return FRectPatternComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let uniqueId$1 = 0;
let FCirclePatternComponent = /*#__PURE__*/(() => {
  class FCirclePatternComponent {
    _destroyRef = inject(DestroyRef);
    _elementReference = inject(ElementRef);
    _fBrowser = inject(BrowserService);
    _stateChanges = new FChannel();
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    id = input(`f-pattern-${uniqueId$1++}`);
    color = input('rgba(0,0,0,0.1)');
    radius = input(20, {
      transform: numberAttribute
    });
    _scaledRadius = 20;
    _transform = TransformModelExtensions.default();
    _position = PointExtensions.initialize();
    _pattern;
    _circle;
    constructor() {
      this._createPattern();
    }
    _createPattern() {
      this._pattern = createSVGElement('pattern', this._fBrowser);
      this._pattern.setAttribute('patternUnits', 'userSpaceOnUse');
      this.hostElement.appendChild(this._pattern);
      this._circle = createSVGElement('circle', this._fBrowser);
      this._pattern.appendChild(this._circle);
    }
    ngOnInit() {
      this._listenStateChanges();
    }
    _listenStateChanges() {
      new FChannelHub(this._stateChanges).pipe(notifyOnStart()).listen(this._destroyRef, () => this._redraw());
    }
    ngOnChanges(changes) {
      if (changes['radius'] || changes['color']) {
        this._refresh();
      }
    }
    _redraw() {
      this._calculatePattern();
      this._redrawPattern();
      this._redrawElement();
    }
    _calculatePattern() {
      this._position.x = this._transform.position.x + this._transform.scaledPosition.x;
      this._position.y = this._transform.position.y + this._transform.scaledPosition.y;
      this._scaledRadius = this.radius() * this._transform.scale;
    }
    _redrawPattern() {
      this._pattern.setAttribute('x', `${this._position.x}`);
      this._pattern.setAttribute('y', `${this._position.y}`);
      this._pattern.setAttribute('width', `${this._scaledRadius}`);
      this._pattern.setAttribute('height', `${this._scaledRadius}`);
    }
    _redrawElement() {
      this._circle.setAttribute('fill', this.color());
      this._circle.setAttribute('cx', `${this._scaledRadius / 2}`);
      this._circle.setAttribute('cy', `${this._scaledRadius / 2}`);
      this._circle.setAttribute('r', `${this._scaledRadius / this.radius()}`);
    }
    setTransform(transform) {
      this._transform = transform;
      this._refresh();
    }
    _refresh() {
      this._stateChanges.notify();
    }
    static ɵfac = function FCirclePatternComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FCirclePatternComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FCirclePatternComponent,
      selectors: [["f-circle-pattern"]],
      hostVars: 1,
      hostBindings: function FCirclePatternComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.id);
        }
      },
      inputs: {
        id: [1, "id"],
        color: [1, "color"],
        radius: [1, "radius"]
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: F_BACKGROUND_PATTERN,
        useExisting: FCirclePatternComponent
      }]), i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
      decls: 0,
      vars: 0,
      template: function FCirclePatternComponent_Template(rf, ctx) {},
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return FCirclePatternComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_BACKGROUND = new InjectionToken('F_BACKGROUND');
let FBackgroundBase = /*#__PURE__*/(() => {
  class FBackgroundBase {
    static ɵfac = function FBackgroundBase_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FBackgroundBase)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FBackgroundBase
    });
  }
  return FBackgroundBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FBackgroundComponent = /*#__PURE__*/(() => {
  class FBackgroundComponent extends FBackgroundBase {
    _fMediator = inject(FMediator);
    _elementReference = inject(ElementRef);
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    fBackgroundPattern = contentChild(F_BACKGROUND_PATTERN);
    ngOnInit() {
      this._fMediator.execute(new AddBackgroundToStoreRequest(this));
    }
    ngAfterContentInit() {
      this._fMediator.execute(new AddPatternToBackgroundRequest(this.fBackgroundPattern()));
    }
    setTransform(transform) {
      this.fBackgroundPattern()?.setTransform(transform);
    }
    ngOnDestroy() {
      this._fMediator.execute(new RemoveBackgroundFromStoreRequest(this));
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFBackgroundComponent_BaseFactory;
      return function FBackgroundComponent_Factory(__ngFactoryType__) {
        return (ɵFBackgroundComponent_BaseFactory || (ɵFBackgroundComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FBackgroundComponent)))(__ngFactoryType__ || FBackgroundComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FBackgroundComponent,
      selectors: [["f-background"]],
      contentQueries: function FBackgroundComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.fBackgroundPattern, F_BACKGROUND_PATTERN, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostAttrs: [1, "f-component", "f-background"],
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: F_BACKGROUND,
        useExisting: FBackgroundComponent
      }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c11,
      decls: 2,
      vars: 0,
      template: function FBackgroundComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(0, "svg");
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      styles: ["[_nghost-%COMP%]{position:absolute;width:100%;height:100%;left:0;top:0;transform-origin:0 0;pointer-events:none}[_nghost-%COMP%]   svg[_ngcontent-%COMP%]{width:100%;height:100%}"],
      changeDetection: 0
    });
  }
  return FBackgroundComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_BACKGROUND_PROVIDERS = [FBackgroundComponent, FRectPatternComponent, FCirclePatternComponent];
class FCanvasChangeEvent {
  position;
  scale;
  constructor(position, scale) {
    this.position = position;
    this.scale = scale;
  }
}
const F_CANVAS = new InjectionToken('F_CANVAS');
let FCanvasBase = /*#__PURE__*/(() => {
  class FCanvasBase {
    transform = TransformModelExtensions.default();
    getPosition() {
      return this.transform.position;
    }
    setPosition(position) {
      this.transform.position = position;
    }
    emitCanvasChangeEvent() {
      this.fCanvasChange.emit(new FCanvasChangeEvent(PointExtensions.sum(this.transform.position, this.transform.scaledPosition), this.transform.scale));
    }
    static ɵfac = function FCanvasBase_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FCanvasBase)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FCanvasBase
    });
  }
  return FCanvasBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FCanvasComponent = /*#__PURE__*/(() => {
  class FCanvasComponent extends FCanvasBase {
    _fMediator = inject(FMediator);
    _elementReference = inject(ElementRef);
    _injector = inject(Injector);
    fCanvasChange = output();
    position = input(PointExtensions.initialize(), {
      transform: PointExtensions.castToPoint
    });
    scale = input(1, {
      transform: numberAttribute
    });
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    fGroupsContainer = viewChild.required('fGroupsContainer');
    fNodesContainer = viewChild.required('fNodesContainer');
    fConnectionsContainer = viewChild.required('fConnectionsContainer');
    ngOnInit() {
      this._fMediator.execute(new AddCanvasToStoreRequest(this));
      this._positionChange();
      this._scaleChange();
    }
    _positionChange() {
      effect(() => {
        this._fMediator.execute(new InputCanvasPositionRequest(this.transform, this.position()));
      }, {
        injector: this._injector
      });
    }
    _scaleChange() {
      effect(() => {
        this._fMediator.execute(new InputCanvasScaleRequest(this.transform, this.scale()));
      }, {
        injector: this._injector
      });
    }
    redraw() {
      this._fMediator.execute(new SetBackgroundTransformRequest(this.transform));
      this.hostElement.setAttribute("style", `transform: ${TransformModelExtensions.toString(this.transform)}`);
      this._fMediator.execute(new NotifyTransformChangedRequest());
    }
    redrawWithAnimation() {
      this._fMediator.execute(new SetBackgroundTransformRequest(this.transform));
      this.hostElement.setAttribute("style", `transition: transform ${isMobile() ? 80 : 150}ms ease-in-out; transform: ${TransformModelExtensions.toString(this.transform)}`);
      transitionEnd(this.hostElement, () => this.redraw());
    }
    centerGroupOrNode(id, animated = true) {
      setTimeout(() => this._fMediator.execute(new CenterGroupOrNodeRequest(id, animated)));
    }
    fitToScreen(toCenter = PointExtensions.initialize(), animated = true) {
      setTimeout(() => this._fMediator.execute(new FitToFlowRequest(toCenter, animated)));
    }
    resetScaleAndCenter(animated = true) {
      setTimeout(() => this._fMediator.execute(new ResetScaleAndCenterRequest(animated)));
    }
    getScale() {
      return this.transform.scale || 1;
    }
    /**
     *  @deprecated Method "setZoom" is deprecated. Use "setScale" instead. This method will be removed in version 18.0.0.`,
     */
    setZoom(scale, toPosition = PointExtensions.initialize()) {
      this.setScale(scale, toPosition);
    }
    setScale(scale, toPosition = PointExtensions.initialize()) {
      this._fMediator.execute(new UpdateScaleRequest(scale, toPosition));
    }
    /**
     *  @deprecated Method "resetZoom" is deprecated. Use "resetScale" instead. This method will be removed in version 18.0.0.`,
     */
    resetZoom() {
      this.resetScale();
    }
    resetScale() {
      this._fMediator.execute(new ResetScaleRequest());
    }
    ngOnDestroy() {
      this._fMediator.execute(new RemoveCanvasFromStoreRequest());
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFCanvasComponent_BaseFactory;
      return function FCanvasComponent_Factory(__ngFactoryType__) {
        return (ɵFCanvasComponent_BaseFactory || (ɵFCanvasComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FCanvasComponent)))(__ngFactoryType__ || FCanvasComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FCanvasComponent,
      selectors: [["f-canvas"]],
      viewQuery: function FCanvasComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.fGroupsContainer, _c12, 5);
          i0.ɵɵviewQuerySignal(ctx.fNodesContainer, _c13, 5);
          i0.ɵɵviewQuerySignal(ctx.fConnectionsContainer, _c14, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance(3);
        }
      },
      hostAttrs: [1, "f-component", "f-canvas"],
      inputs: {
        position: [1, "position"],
        scale: [1, "scale"]
      },
      outputs: {
        fCanvasChange: "fCanvasChange"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: F_CANVAS,
        useExisting: FCanvasComponent
      }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c16,
      decls: 12,
      vars: 0,
      consts: [["fGroupsContainer", ""], ["fConnectionsContainer", ""], ["fNodesContainer", ""]],
      template: function FCanvasComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c15);
          i0.ɵɵelementContainerStart(0);
          i0.ɵɵelementStart(1, "div", null, 0);
          i0.ɵɵprojection(3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "div", null, 1);
          i0.ɵɵprojection(6, 1);
          i0.ɵɵprojection(7, 2);
          i0.ɵɵprojection(8, 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "div", null, 2);
          i0.ɵɵprojection(11, 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementContainerEnd();
        }
      },
      styles: ["[_nghost-%COMP%]{position:absolute;overflow:visible;width:100%;height:100%;left:0;top:0;transform-origin:0 0;pointer-events:none}.f-scaled-animate[_nghost-%COMP%]{transition:transform .09s}"],
      changeDetection: 0
    });
  }
  __decorate([Deprecated('setScale')], FCanvasComponent.prototype, "setZoom", null);
  __decorate([Deprecated('resetScale')], FCanvasComponent.prototype, "resetZoom", null);
  return FCanvasComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_CANVAS_PROVIDERS = [FCanvasComponent];
class FMinimapData {
  element;
  scale;
  viewBox;
  constructor(element, scale = 1, viewBox = RectExtensions.initialize(0, 0, 0, 0)) {
    this.element = element;
    this.scale = scale;
    this.viewBox = viewBox;
  }
}
let FMinimapFlowDirective = /*#__PURE__*/(() => {
  class FMinimapFlowDirective {
    fMinSize = 1000;
    _fMediator = inject(FMediator);
    _elementReference = inject(ElementRef);
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    model = new FMinimapData(this.hostElement);
    redraw() {
      const {
        scale,
        viewBox
      } = this._fMediator.execute(new MinimapCalculateSvgScaleAndViewBoxRequest(this.hostElement, this.fMinSize));
      this.model = new FMinimapData(this.hostElement, scale, viewBox);
      setRectToViewBox(viewBox, this.hostElement);
    }
    static ɵfac = function FMinimapFlowDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FMinimapFlowDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FMinimapFlowDirective,
      selectors: [["svg", "fMinimapFlow", ""]],
      inputs: {
        fMinSize: "fMinSize"
      }
    });
  }
  return FMinimapFlowDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FMinimapCanvasDirective = /*#__PURE__*/(() => {
  class FMinimapCanvasDirective {
    _fMediator = inject(FMediator);
    _elementReference = inject(ElementRef);
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    redraw() {
      this._clearCanvas();
      this._fMediator.execute(new MinimapDrawNodesRequest()).forEach(x => {
        this.hostElement.appendChild(x);
      });
    }
    _clearCanvas() {
      this.hostElement.innerHTML = '';
    }
    static ɵfac = function FMinimapCanvasDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FMinimapCanvasDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FMinimapCanvasDirective,
      selectors: [["g", "fMinimapCanvas", ""]]
    });
  }
  return FMinimapCanvasDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FMinimapViewDirective = /*#__PURE__*/(() => {
  class FMinimapViewDirective {
    _fMediator = inject(FMediator);
    _elementReference = inject(ElementRef);
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    redraw() {
      setRectToElement(this._fMediator.execute(new MinimapCalculateViewBoxRequest()), this.hostElement);
    }
    static ɵfac = function FMinimapViewDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FMinimapViewDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FMinimapViewDirective,
      selectors: [["rect", "fMinimapView", ""]],
      hostAttrs: [1, "f-component", "f-minimap-view"]
    });
  }
  return FMinimapViewDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FMinimapComponent = /*#__PURE__*/(() => {
  class FMinimapComponent {
    _destroyRef = inject(DestroyRef);
    _fMediator = inject(FMediator);
    _fBrowser = inject(BrowserService);
    fMinimapCanvas;
    fMinimapFlow;
    fMinimapView;
    fMinSize = 1000;
    ngAfterViewInit() {
      this._listenTransformChanges();
    }
    _listenTransformChanges() {
      this._fMediator.execute(new ListenTransformChangesRequest()).pipe(notifyOnStart(), debounceTime(5)).listen(this._destroyRef, () => this._redraw());
    }
    _redraw() {
      if (!this._fBrowser.isBrowser()) {
        return;
      }
      this.fMinimapFlow.redraw();
      this.fMinimapView.redraw();
      this.fMinimapCanvas.redraw();
    }
    onPointerDown(event) {
      this._fMediator.execute(new MinimapDragPreparationRequest(event, this.fMinimapFlow.model));
    }
    onPointerUp(event) {
      this._fMediator.execute(new MinimapDragFinalizeRequest(event));
    }
    static ɵfac = function FMinimapComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FMinimapComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FMinimapComponent,
      selectors: [["f-minimap"]],
      viewQuery: function FMinimapComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(FMinimapCanvasDirective, 7);
          i0.ɵɵviewQuery(FMinimapFlowDirective, 7);
          i0.ɵɵviewQuery(FMinimapViewDirective, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fMinimapCanvas = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fMinimapFlow = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fMinimapView = _t.first);
        }
      },
      hostAttrs: [1, "f-component", "f-minimap"],
      inputs: {
        fMinSize: "fMinSize"
      },
      exportAs: ["fComponent"],
      features: [i0.ɵɵProvidersFeature([{
        provide: F_BEFORE_MAIN_PLUGIN,
        useExisting: FMinimapComponent
      }])],
      decls: 3,
      vars: 1,
      consts: [["fMinimapFlow", "", "width", "100%", "height", "100%", "fLockedContext", "", 3, "fMinSize"], ["fMinimapCanvas", ""], ["fMinimapView", "", "x", "0", "y", "0", "width", "100%", "height", "100%", "stroke", "none"]],
      template: function FMinimapComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(0, "svg", 0);
          i0.ɵɵelement(1, "g", 1)(2, "rect", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("fMinSize", ctx.fMinSize);
        }
      },
      dependencies: [FMinimapCanvasDirective, FMinimapViewDirective, FMinimapFlowDirective],
      styles: ["[_nghost-%COMP%]{display:block;position:absolute}[_nghost-%COMP%]   svg[_ngcontent-%COMP%]{overflow:hidden}"],
      changeDetection: 0
    });
  }
  return FMinimapComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_MINIMAP_PROVIDERS = [FMinimapComponent, FMinimapCanvasDirective, FMinimapViewDirective, FMinimapFlowDirective];
const F_FLOW = new InjectionToken('F_FLOW');
class FFlowBase {}
let uniqueId = 0;
let FFlowComponent = /*#__PURE__*/(() => {
  class FFlowComponent extends FFlowBase {
    _destroyRef = inject(DestroyRef);
    _fMediator = inject(FMediator);
    _browserService = inject(BrowserService);
    _elementReference = inject(ElementRef);
    fId = input(`f-flow-${uniqueId++}`, {
      alias: 'fFlowId'
    });
    get hostElement() {
      return this._elementReference.nativeElement;
    }
    fLoaded = output();
    _isLoaded = false;
    ngOnInit() {
      this._fMediator.execute(new AddFlowToStoreRequest(this));
    }
    ngAfterContentInit() {
      if (!this._browserService.isBrowser()) {
        return;
      }
      this._listenCountChanges();
      this._listenDataChanges();
    }
    _listenCountChanges() {
      this._fMediator.execute(new ListenCountChangesRequest()).listen(this._destroyRef, () => {
        this._fMediator.execute(new SortItemLayersRequest());
      });
    }
    _listenDataChanges() {
      this._fMediator.execute(new ListenDataChangesRequest()).listen(this._destroyRef, () => {
        this._fMediator.execute(new RedrawConnectionsRequest());
        this._emitLoaded();
      });
    }
    _emitLoaded() {
      if (!this._isLoaded) {
        this._isLoaded = true;
        this.fLoaded.emit();
      }
    }
    redraw() {
      this._fMediator.execute(new NotifyDataChangedRequest());
    }
    reset() {
      this._isLoaded = false;
    }
    getNodesBoundingBox() {
      return this._fMediator.execute(new CalculateNodesBoundingBoxNormalizedPositionRequest());
    }
    getSelection() {
      return this._fMediator.execute(new GetCurrentSelectionRequest());
    }
    getPositionInFlow(position) {
      return this._fMediator.execute(new GetNormalizedPointRequest(position));
    }
    getState() {
      return this._fMediator.execute(new GetFlowStateRequest());
    }
    selectAll() {
      this._fMediator.execute(new SelectAllRequest());
    }
    select(nodes, connections) {
      this._fMediator.execute(new SelectRequest(nodes, connections));
    }
    clearSelection() {
      this._fMediator.execute(new ClearSelectionRequest());
    }
    ngOnDestroy() {
      this._fMediator.execute(new RemoveFlowFromStoreRequest());
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFFlowComponent_BaseFactory;
      return function FFlowComponent_Factory(__ngFactoryType__) {
        return (ɵFFlowComponent_BaseFactory || (ɵFFlowComponent_BaseFactory = i0.ɵɵgetInheritedFactory(FFlowComponent)))(__ngFactoryType__ || FFlowComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FFlowComponent,
      selectors: [["f-flow"]],
      hostAttrs: [1, "f-component", "f-flow"],
      hostVars: 1,
      hostBindings: function FFlowComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.fId());
        }
      },
      inputs: {
        fId: [1, "fFlowId", "fId"]
      },
      outputs: {
        fLoaded: "fLoaded"
      },
      standalone: true,
      features: [i0.ɵɵProvidersFeature([FMediator, ...F_STORAGE_PROVIDERS, FDraggableDataContext, FConnectionFactory, ...COMMON_PROVIDERS, ...F_DRAGGABLE_PROVIDERS, {
        provide: F_FLOW,
        useExisting: FFlowComponent
      }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      ngContentSelectors: _c18,
      decls: 7,
      vars: 0,
      template: function FFlowComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c17);
          i0.ɵɵelementContainerStart(0);
          i0.ɵɵprojection(1);
          i0.ɵɵprojection(2, 1);
          i0.ɵɵprojection(3, 2);
          i0.ɵɵprojection(4, 3);
          i0.ɵɵprojection(5, 4);
          i0.ɵɵprojection(6, 5);
          i0.ɵɵelementContainerEnd();
        }
      },
      styles: ["[_nghost-%COMP%]{display:block;position:relative;width:100%;height:100%;overflow:hidden;pointer-events:all;-webkit-user-select:none;user-select:none;touch-action:none}"],
      changeDetection: 0
    });
  }
  return FFlowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_FLOW_PROVIDERS = [FFlowComponent];
var EFZoomDirection = /*#__PURE__*/function (EFZoomDirection) {
  EFZoomDirection[EFZoomDirection["ZOOM_IN"] = 1] = "ZOOM_IN";
  EFZoomDirection[EFZoomDirection["ZOOM_OUT"] = -1] = "ZOOM_OUT";
  return EFZoomDirection;
}(EFZoomDirection || {});
const F_ZOOM = new InjectionToken('F_ZOOM');
class FZoomBase {}
let FZoomDirective = /*#__PURE__*/(() => {
  class FZoomDirective extends FZoomBase {
    _fMediator = inject(FMediator);
    _rendered = inject(Renderer2);
    _triggersListener = [];
    isEnabled = false;
    fWheelTrigger = defaultEventTrigger;
    fDblClickTrigger = defaultEventTrigger;
    minimum = 0.1;
    maximum = 4;
    step = 0.1;
    dblClickStep = 0.5;
    get _fHost() {
      return this._fMediator.execute(new GetFlowHostElementRequest());
    }
    get _fCanvas() {
      return this._fMediator.execute(new GetCanvasRequest());
    }
    ngOnInit() {
      this._fMediator.execute(new AddZoomToStoreRequest(this));
    }
    ngAfterViewInit() {
      this._listenTriggers();
    }
    ngOnChanges(changes) {
      if (changes['isEnabled']) {
        this._listenTriggers();
      }
    }
    _listenTriggers() {
      if (!this._fHost) {
        return;
      }
      this._disposeListeners();
      if (!this.isEnabled) {
        return;
      }
      this._triggersListener.push(this._rendered.listen(this._fHost, 'wheel', this._onWheel));
      this._triggersListener.push(this._rendered.listen(this._fHost, 'dblclick', this._onDoubleClick));
    }
    _onWheel = event => {
      if (!isValidEventTrigger(event, this.fWheelTrigger)) {
        return;
      }
      event.preventDefault();
      const targetElement = event.target;
      if (targetElement?.closest('[fLockedContext]')) {
        return;
      }
      this.setZoom(PointExtensions.initialize(event.clientX, event.clientY), this.step, this._calculateDirection(event.deltaY), false);
    };
    _calculateDirection(deltaY) {
      return deltaY > 0 ? EFZoomDirection.ZOOM_OUT : EFZoomDirection.ZOOM_IN;
    }
    _onDoubleClick = event => {
      if (!isValidEventTrigger(event, this.fDblClickTrigger)) {
        return;
      }
      event.preventDefault();
      const targetElement = event.target;
      if (isNode(targetElement) || targetElement?.closest('[fLockedContext]')) {
        return;
      }
      this.setZoom(PointExtensions.initialize(event.clientX, event.clientY), this.dblClickStep, EFZoomDirection.ZOOM_IN, true);
    };
    _getToCenterPosition(position, rect) {
      return PointExtensions.initialize(position?.x || rect.gravityCenter.x, position?.y || rect.gravityCenter.y);
    }
    zoomIn(position) {
      this._onZoomToCenter(EFZoomDirection.ZOOM_IN, position);
    }
    zoomOut(position) {
      this._onZoomToCenter(EFZoomDirection.ZOOM_OUT, position);
    }
    _onZoomToCenter(direction, position) {
      this.setZoom(this._getToCenterPosition(position, RectExtensions.fromElement(this._fHost)), this.step, direction, false);
    }
    setZoom(position, step, direction, animated) {
      this._fMediator.execute(new SetZoomRequest(position, step, direction, animated));
    }
    /**
     *  @deprecated Method "getScale" is deprecated. Use "getZoomValue" instead. This method will be removed in version 18.0.0.`,
     */
    getScale() {
      return this.getZoomValue();
    }
    getZoomValue() {
      return this._fCanvas.transform.scale || 1;
    }
    reset() {
      this._fMediator.execute(new ResetZoomRequest());
    }
    _disposeListeners() {
      this._triggersListener.forEach(listener => listener());
      this._triggersListener = [];
    }
    ngOnDestroy() {
      this._disposeListeners();
      this._fMediator.execute(new RemoveZoomFromStoreRequest());
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFZoomDirective_BaseFactory;
      return function FZoomDirective_Factory(__ngFactoryType__) {
        return (ɵFZoomDirective_BaseFactory || (ɵFZoomDirective_BaseFactory = i0.ɵɵgetInheritedFactory(FZoomDirective)))(__ngFactoryType__ || FZoomDirective);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FZoomDirective,
      selectors: [["f-canvas", "fZoom", ""]],
      hostAttrs: [1, "f-zoom", "f-component"],
      inputs: {
        isEnabled: [2, "fZoom", "isEnabled", booleanAttribute],
        fWheelTrigger: "fWheelTrigger",
        fDblClickTrigger: "fDblClickTrigger",
        minimum: [2, "fZoomMinimum", "minimum", numberAttribute],
        maximum: [2, "fZoomMaximum", "maximum", numberAttribute],
        step: [2, "fZoomStep", "step", numberAttribute],
        dblClickStep: [2, "fZoomDblClickStep", "dblClickStep", numberAttribute]
      },
      exportAs: ["fComponent"],
      standalone: true,
      features: [i0.ɵɵProvidersFeature([{
        provide: F_ZOOM,
        useExisting: FZoomDirective
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
    });
  }
  __decorate([Deprecated('getZoomValue')], FZoomDirective.prototype, "getScale", null);
  return FZoomDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const F_ZOOM_PROVIDERS = [FZoomDirective];
let FFlowModule = /*#__PURE__*/(() => {
  class FFlowModule {
    static ɵfac = function FFlowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FFlowModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FFlowModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return FFlowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AddBackgroundToStoreExecution, AddBackgroundToStoreRequest, AddCanvasToStoreExecution, AddCanvasToStoreRequest, AddConnectionForCreateToStoreExecution, AddConnectionForCreateToStoreRequest, AddConnectionMarkerToStoreExecution, AddConnectionMarkerToStoreRequest, AddConnectionToStoreExecution, AddConnectionToStoreRequest, AddDndToStoreExecution, AddDndToStoreRequest, AddFlowToStoreExecution, AddFlowToStoreRequest, AddInputToStoreExecution, AddInputToStoreRequest, AddLineAlignmentToStoreExecution, AddLineAlignmentToStoreRequest, AddNodeToStoreExecution, AddNodeToStoreRequest, AddOutletToStoreExecution, AddOutletToStoreRequest, AddOutputToStoreExecution, AddOutputToStoreRequest, AddPatternToBackgroundExecution, AddPatternToBackgroundRequest, AddSnapConnectionToStoreExecution, AddSnapConnectionToStoreRequest, AddZoomToStoreExecution, AddZoomToStoreRequest, ApplyChildResizeRestrictionsExecution, ApplyChildResizeRestrictionsRequest, ApplyParentResizeRestrictionsExecution, ApplyParentResizeRestrictionsRequest, BaseConnectionDragHandler, CANVAS_PROVIDERS, COMMON_PROVIDERS, CONNECTIONS_PROVIDERS, CONNECTION_GRADIENT, CONNECTION_PATH, CONNECTION_TEXT, CREATE_MOVE_NODE_DRAG_MODEL_FROM_SELECTION_PROVIDERS, CalculateCenterBetweenPointsHandler, CalculateCenterBetweenPointsRequest, CalculateChangedPositionExecution, CalculateChangedPositionRequest, CalculateChangedSizeExecution, CalculateChangedSizeRequest, CalculateClosestInputExecution, CalculateClosestInputRequest, CalculateCommonNodeMoveLimitsExecution, CalculateCommonNodeMoveLimitsRequest, CalculateConnectionCenterHandler, CalculateConnectionCenterRequest, CalculateConnectionLineByBehaviorExecution, CalculateConnectionLineByBehaviorRequest, CalculateFlowPointFromMinimapPointExecution, CalculateFlowPointFromMinimapPointRequest, CalculateInputConnectionsExecution, CalculateInputConnectionsRequest, CalculateNodeMoveLimitsExecution, CalculateNodeMoveLimitsRequest, CalculateNodesBoundingBoxExecution, CalculateNodesBoundingBoxNormalizedPositionExecution, CalculateNodesBoundingBoxNormalizedPositionRequest, CalculateNodesBoundingBoxRequest, CalculateOutputConnectionsExecution, CalculateOutputConnectionsRequest, CenterGroupOrNodeExecution, CenterGroupOrNodeRequest, ClearSelectionExecution, ClearSelectionRequest, CreateConnectionMarkersExecution, CreateConnectionMarkersRequest, CreateMoveNodesDragModelFromSelectionExecution, CreateMoveNodesDragModelFromSelectionRequest, DRAG_AND_DROP_COMMON_PROVIDERS, Deprecated, EFConnectableSide, EFConnectionBehavior, EFConnectionType, EFMarkerType, EFResizeHandleType, EFZoomDirection, EmitSelectionChangeEventExecution, EmitSelectionChangeEventRequest, EndDragSequenceExecution, EndDragSequenceRequest, FBackgroundBase, FBackgroundComponent, FBezierPathBuilder, FCanvasBase, FCanvasChangeEvent, FCanvasComponent, FCanvasDragHandler, FCanvasMoveFinalizeExecution, FCanvasMoveFinalizeRequest, FCanvasMovePreparationExecution, FCanvasMovePreparationRequest, FChannel, FChannelHub, FCirclePatternComponent, FComponentsStore, FConnectionBase, FConnectionCenterDirective, FConnectionComponent, FConnectionDragHandleEndComponent, FConnectionDragHandleStartComponent, FConnectionFactory, FConnectionForCreateComponent, FConnectionGradientComponent, FConnectionPathComponent, FConnectionSelectionComponent, FConnectionTextComponent, FConnectionTextPathDirective, FConnectorBase, FCreateConnectionDragHandler, FCreateConnectionDragHandlerPreparationExecution, FCreateConnectionDragHandlerPreparationRequest, FCreateConnectionEvent, FCreateConnectionFinalizeExecution, FCreateConnectionFinalizeRequest, FCreateConnectionFromOutletPreparationExecution, FCreateConnectionFromOutletPreparationRequest, FCreateConnectionFromOutputPreparationExecution, FCreateConnectionFromOutputPreparationRequest, FCreateConnectionPreparationExecution, FCreateConnectionPreparationRequest, FCreateNodeEvent, FDragHandleDirective, FDragHandlerResult, FDragStartedEvent, FDraggableBase, FDraggableDataContext, FDraggableDirective, FDropToGroupEvent, FExternalItemBase, FExternalItemCreatePlaceholderExecution, FExternalItemCreatePlaceholderRequest, FExternalItemCreatePreviewExecution, FExternalItemCreatePreviewRequest, FExternalItemDirective, FExternalItemDragHandler, FExternalItemFinalizeExecution, FExternalItemFinalizeRequest, FExternalItemPlaceholderDirective, FExternalItemPreparationExecution, FExternalItemPreparationRequest, FExternalItemPreviewDirective, FExternalItemService, FFlowBase, FFlowComponent, FFlowModule, FGroupDirective, FLineAlignmentBase, FLineAlignmentComponent, FLineAlignmentDragHandler, FMarkerBase, FMarkerDirective, FMinimapCanvasDirective, FMinimapComponent, FMinimapData, FMinimapDragHandler, FMinimapFlowDirective, FMinimapViewDirective, FNodeBase, FNodeDirective, FNodeDropToGroupDragHandler, FNodeDropToGroupFinalizeExecution, FNodeDropToGroupFinalizeRequest, FNodeDropToGroupPreparationExecution, FNodeDropToGroupPreparationRequest, FNodeInputBase, FNodeInputDirective, FNodeIntersectedWithConnections, FNodeMoveDragHandler, FNodeMoveFinalizeExecution, FNodeMoveFinalizeRequest, FNodeMovePreparationExecution, FNodeMovePreparationRequest, FNodeOutletBase, FNodeOutletDirective, FNodeOutputBase, FNodeOutputDirective, FNodeResizeDragHandler, FNodeResizeFinalizeExecution, FNodeResizeFinalizeRequest, FNodeResizePreparationExecution, FNodeResizePreparationRequest, FNodeRotateDragHandler, FNodeRotateFinalizeExecution, FNodeRotateFinalizeRequest, FNodeRotatePreparationExecution, FNodeRotatePreparationRequest, FReassignConnectionDragHandler, FReassignConnectionEvent, FReassignConnectionFinalizeExecution, FReassignConnectionFinalizeRequest, FReassignConnectionPreparationExecution, FReassignConnectionPreparationRequest, FRectPatternComponent, FResizeChannel, FResizeHandleDirective, FRotateHandleDirective, FSegmentPathBuilder, FSelectionAreaBase, FSelectionAreaComponent, FSelectionChangeEvent, FSingleSelectExecution, FSingleSelectRequest, FSnapConnectionComponent, FStraightPathBuilder, FSummaryNodeMoveDragHandler, FZoomBase, FZoomDirective, F_AFTER_MAIN_PLUGIN, F_BACKGROUND, F_BACKGROUND_FEATURES, F_BACKGROUND_PATTERN, F_BACKGROUND_PROVIDERS, F_BEFORE_MAIN_PLUGIN, F_CANVAS, F_CANVAS_FEATURES, F_CANVAS_PROVIDERS, F_CONNECTION_BUILDERS, F_CONNECTION_FEATURES, F_CONNECTION_IDENTIFIERS, F_CONNECTION_PROVIDERS, F_CONNECTORS_FEATURES, F_CONNECTORS_PROVIDERS, F_CSS_CLASS, F_DRAGGABLE_FEATURES, F_DRAGGABLE_PROVIDERS, F_EXTERNAL_ITEM, F_EXTERNAL_ITEM_DRAG_AND_DROP_PROVIDERS, F_EXTERNAL_ITEM_PROVIDERS, F_FLOW, F_FLOW_FEATURES, F_FLOW_PROVIDERS, F_LINE_ALIGNMENT, F_LINE_ALIGNMENT_FEATURES, F_LINE_ALIGNMENT_PROVIDERS, F_MARKER, F_MINIMAP_DRAG_AND_DROP_PROVIDERS, F_MINIMAP_PROVIDERS, F_NODE, F_NODE_FEATURES, F_NODE_INPUT, F_NODE_OUTLET, F_NODE_OUTPUT, F_NODE_PROVIDERS, F_SELECTED_CLASS, F_SELECTION_AREA_DRAG_AND_DROP_PROVIDERS, F_SELECTION_AREA_PROVIDERS, F_SELECTION_FEATURES, F_STORAGE_PROVIDERS, F_ZOOM, F_ZOOM_FEATURES, F_ZOOM_PROVIDERS, F_ZOOM_TAG, FindInputAtPositionExecution, FindInputAtPositionRequest, FitToFlowExecution, FitToFlowRequest, GET_FLOW_STATE_PROVIDERS, GetAllCanBeConnectedInputsAndRectsExecution, GetAllCanBeConnectedInputsAndRectsRequest, GetCanBeSelectedItemsExecution, GetCanBeSelectedItemsRequest, GetCanvasExecution, GetCanvasRequest, GetConnectorAndRectExecution, GetConnectorAndRectRequest, GetCurrentSelectionExecution, GetCurrentSelectionRequest, GetDeepChildrenNodesAndGroupsExecution, GetDeepChildrenNodesAndGroupsRequest, GetElementRoundedRectExecution, GetElementRoundedRectRequest, GetFirstConnectableOutputExecution, GetFirstConnectableOutputRequest, GetFlowExecution, GetFlowHostElementExecution, GetFlowHostElementRequest, GetFlowRequest, GetFlowStateConnectionsExecution, GetFlowStateConnectionsRequest, GetFlowStateExecution, GetFlowStateNodesExecution, GetFlowStateNodesRequest, GetFlowStateRequest, GetNodePaddingExecution, GetNodePaddingRequest, GetNodeResizeRestrictionsExecution, GetNodeResizeRestrictionsRequest, GetNodesExecution, GetNodesRequest, GetNormalizedChildrenNodesRectExecution, GetNormalizedChildrenNodesRectRequest, GetNormalizedElementRectExecution, GetNormalizedElementRectRequest, GetNormalizedParentNodeRectExecution, GetNormalizedParentNodeRectRequest, GetNormalizedPointExecution, GetNormalizedPointRequest, GetParentNodesExecution, GetParentNodesRequest, InitializeDragSequenceExecution, InitializeDragSequenceRequest, InputCanvasPositionExecution, InputCanvasPositionRequest, InputCanvasScaleExecution, InputCanvasScaleRequest, IsArrayHasParentNodeExecution, IsArrayHasParentNodeRequest, IsConnectionUnderNodeExecution, IsConnectionUnderNodeRequest, IsDragStartedExecution, IsDragStartedRequest, LineAlignmentPreparationExecution, LineAlignmentPreparationRequest, LineElement, LineService, ListenCountChangesExecution, ListenCountChangesRequest, ListenDataChangesExecution, ListenDataChangesRequest, ListenTransformChangesExecution, ListenTransformChangesRequest, LogExecutionTime, MINIMAP_DRAG_FINALIZE_PROVIDERS, MINIMAP_DRAG_PREPARATION_PROVIDERS, MarkAllCanBeConnectedInputsExecution, MarkAllCanBeConnectedInputsRequest, MinimapCalculateSvgScaleAndViewBoxExecution, MinimapCalculateSvgScaleAndViewBoxRequest, MinimapCalculateViewBoxExecution, MinimapCalculateViewBoxRequest, MinimapDragFinalizeExecution, MinimapDragFinalizeRequest, MinimapDragPreparationExecution, MinimapDragPreparationRequest, MinimapDrawNodesExecution, MinimapDrawNodesRequest, MoveFrontElementsBeforeTargetElementExecution, MoveFrontElementsBeforeTargetElementRequest, NODE_DROP_TO_GROUP_PROVIDERS, NODE_PROVIDERS, NODE_RESIZE_PROVIDERS, NODE_ROTATE_PROVIDERS, NotifyDataChangedExecution, NotifyDataChangedRequest, NotifyTransformChangedExecution, NotifyTransformChangedRequest, OnPointerMoveExecution, OnPointerMoveRequest, PointBoundsLimiter, PrepareDragSequenceExecution, PrepareDragSequenceRequest, PreventDefaultIsExternalItemExecution, PreventDefaultIsExternalItemRequest, PutInputConnectionHandlersToArrayExecution, PutInputConnectionHandlersToArrayRequest, PutOutputConnectionHandlersToArrayExecution, PutOutputConnectionHandlersToArrayRequest, RESIZE_DIRECTIONS, RedrawCanvasWithAnimationExecution, RedrawCanvasWithAnimationRequest, RedrawConnectionsExecution, RedrawConnectionsRequest, RemoveBackgroundFromStoreExecution, RemoveBackgroundFromStoreRequest, RemoveCanvasFromStoreExecution, RemoveCanvasFromStoreRequest, RemoveConnectionForCreateFromStoreExecution, RemoveConnectionForCreateFromStoreRequest, RemoveConnectionFromStoreExecution, RemoveConnectionFromStoreRequest, RemoveConnectionMarkerFromStoreExecution, RemoveConnectionMarkerFromStoreRequest, RemoveDndFromStoreExecution, RemoveDndFromStoreRequest, RemoveFlowFromStoreExecution, RemoveFlowFromStoreRequest, RemoveInputFromStoreExecution, RemoveInputFromStoreRequest, RemoveLineAlignmentFromStoreExecution, RemoveLineAlignmentFromStoreRequest, RemoveNodeFromStoreExecution, RemoveNodeFromStoreRequest, RemoveOutletFromStoreExecution, RemoveOutletFromStoreRequest, RemoveOutputFromStoreExecution, RemoveOutputFromStoreRequest, RemoveSnapConnectionFromStoreExecution, RemoveSnapConnectionFromStoreRequest, RemoveZoomFromStoreExecution, RemoveZoomFromStoreRequest, ResetScaleAndCenterExecution, ResetScaleAndCenterRequest, ResetScaleExecution, ResetScaleRequest, ResetZoomExecution, ResetZoomRequest, SINGLE_SELECT_PROVIDERS, SelectAllExecution, SelectAllRequest, SelectAndUpdateNodeLayerExecution, SelectAndUpdateNodeLayerRequest, SelectExecution, SelectRequest, SelectionAreaDragHandle, SelectionAreaFinalizeExecution, SelectionAreaFinalizeRequest, SelectionAreaPreparationExecution, SelectionAreaPreparationRequest, SetBackgroundTransformExecution, SetBackgroundTransformRequest, SetZoomExecution, SetZoomRequest, SortItemLayersExecution, SortItemLayersRequest, SortItemsByParentExecution, SortItemsByParentRequest, SortNodeLayersExecution, SortNodeLayersRequest, SourceConnectionDragHandler, SourceTargetConnectionDragHandler, StartDragSequenceExecution, StartDragSequenceRequest, TargetConnectionDragHandler, UnmarkAllCanBeConnectedInputsExecution, UnmarkAllCanBeConnectedInputsRequest, UpdateItemAndChildrenLayersExecution, UpdateItemAndChildrenLayersRequest, UpdateNodeWhenStateOrSizeChangedExecution, UpdateNodeWhenStateOrSizeChangedRequest, UpdateScaleExecution, UpdateScaleRequest, createSVGElement, debounceTime, defaultEventTrigger, fixedCenterBehavior, fixedOutboundBehavior, floatingBehavior, getExternalItem, getMarkerEndId, getMarkerSelectedEndId, getMarkerSelectedStartId, getMarkerStartId, isExternalItem, isMobile, isNode, isNodeOutlet, isNodeOutput, isRotateHandle, isValidEventTrigger, mediatorEffect, mixinChangeSelection, mixinChangeVisibility, notifyOnStart, transitionEnd };
